<template>
  <div class="task-list-page">
    <div v-if="true" class="mains">
      <div class="page">
        <div class="group_1 flex-col">
          <div class="box_1 flex-col justify-end">
            <site-header />
            <div v-if="false" class="group_2 flex-col">
              <div class="box_2 flex-row">
                <div class="flex-row" style="align-items: center">
                  <img
                    @click="toPath('/index')"
                    data-track-text="首页Logo"
                    aria-label="首页Logo"
                    class="image_1"
                    referrerpolicy="no-referrer"
                    src="../assets/v2/img/logo-black.png"
                  />
                  <span class="text_1">
                    <span data-track-text="首页" aria-label="首页" @click="toPath('/')">首页</span>
                    <span>
                      <el-dropdown @command="gotoPage">
                        <span> 产品 </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            command="text"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 文本翻译 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="doc"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 文档翻译 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="ai"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> AI翻译 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="lange"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 多语种翻译 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="polish"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 润色改写 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="aiPPT"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> AI PPT </span>
                          </el-dropdown-item>
                        <el-dropdown-item
                            command="rag"
                            style="z-index: 1; font-weight: 800; position: relative;"
                        >
                          <span> RAG知识库 </span>
                          <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                        </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <img
                        class="thumbnail_4"
                        referrerpolicy="no-referrer"
                        src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                    <span>
                      <el-dropdown @command="logOut">
                        <span> 服务 </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            command="toTransPro"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 人工翻译 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="standLangSet"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 术语词库 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="convertDoc"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 文档转换 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="mySelfDoc"
                            style="z-index: 1; font-weight: 800"
                          >
                            <span> 我的文档 </span>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="webTranslate"
                            style="z-index: 1; font-weight: 800; position: relative;"
                          >
                            <span> 网页翻译 </span>
                            <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                          <el-dropdown-item
                            command="smartClassify"
                            style="z-index: 1; font-weight: 800; position: relative;"
                          >
                            <span> 数据分析 </span>
                            <img :src="require('@/assets/new_icon.png')" alt="new" style="position: absolute;top: 2px;right: 5px;width: 18px;height: auto;"/>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <img
                        class="thumbnail_4"
                        referrerpolicy="no-referrer"
                        src="../assets/v2/img/trans/operate.png"
                      />
                    </span>
                  </span>
                </div>
                <div class="flex-row" style="align-items: center">
                  <img
                    class="thumbnail_1"
                    @click="toPath('/help')"
                    data-track-text="帮助"
                    aria-label="帮助"
                    referrerpolicy="no-referrer"
                    src="../assets/v2/img/trans/help.png"
                  />
                  <span data-track-text="帮助" aria-label="帮助" class="text_2" @click="toPath('/help')">帮助</span>
                  <span data-track-text="登录" aria-label="登录"
                    class="text_2"
                    v-if="groupUserInfo === '机构登录'"
                    @click="showIframe('/login')"
                  >
                    {{ groupUserInfo }}
                  </span>
                  <el-dropdown
                    @command="logOut"
                    v-if="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
                    style="
                      display: flex;
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #333333;
                    "
                  >
                    <span
                      v-show="
                        groupUserInfo !== '' && groupUserInfo !== '机构登录'
                      "
                      class="text_2"
                      >{{ groupUserInfo }}</span
                    >
                    <el-dropdown-menu
                      v-if="
                        groupUserInfo !== '' && groupUserInfo !== '机构登录'
                      "
                      slot="dropdown"
                    >
                      <el-dropdown-item
                        v-for="(item, index) in groupUserInfos"
                        :key="index"
                        :command="item.name"
                        style="z-index: 1; font-weight: 800"
                      >
                        <span
                          style="
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #333333;
                          "
                          >{{ item.name }}</span
                        >
                        <span
                          style="
                            margin-left: 10px;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #333333;
                          "
                          v-if="!item.isIpScore"
                          >退出</span
                        >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <img
                    class="thumbnail_1"
                    @click="userInfo !== '' ? toCenter : ''"
                    data-track-text="个人中心"
                    aria-label="个人中心"
                    referrerpolicy="no-referrer"
                    src="../assets/v2/img/trans/login.png"
                  />
                  <el-dropdown
                    @command="logOut"
                    v-if="showloginOut"
                    style="
                      display: flex;
                      font-size: 14px;
                      font-family: Microsoft YaHei;
                      font-weight: 400;
                      color: #333333;
                    "
                  >
                    <span v-show="userInfo !== ''" class="text_2">
                      {{ userInfo }}
                    </span>
                    <el-dropdown-menu v-if="showloginOut" slot="dropdown">
                      <el-dropdown-item
                        command="toCenter"
                        style="z-index: 1; font-weight: 800"
                      >
                        <span
                          style="
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #333333;
                          "
                          >个人中心</span
                        >
                      </el-dropdown-item>
                      <el-dropdown-item style="z-index: 1; font-weight: 800">
                        <span
                          style="
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #333333;
                          "
                          >退出</span
                        >
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <span class="text_2" v-show="userInfo === ''">
                    <span data-track-text="登录" aria-label="登录" @click="showIframe('/login')">登录</span>
                    /
                    <span data-track-text="注册" aria-label="注册" @click="showIframe('/register')">注册</span>
                  </span>
                  <span v-if="isShowInRoaming && showRoaming">
                    <span class="text_2">｜</span>
                    <el-popover
                      @hide="removeQrcode"
                      @show="getQrcode"
                      placement="top-start"
                      title="扫一扫开通漫游"
                      width="150"
                      trigger="hover"
                    >
                      <el-image
                        :src="qrcodeUrl"
                        fit="contain"
                        style="width: 150px; height: 150px"
                        alt="开通漫游"
                      >
                      </el-image>
                      <el-button
                        type="text"
                        data-track-text="开通漫游"
                        aria-label="开通漫游"
                        slot="reference"
                        class="text_2"
                        style="margin-top: 4px; cursor: pointer"
                        >开通漫游</el-button
                      >
                    </el-popover>
                    <span
                      style="
                        position: absolute;
                        margin-top: -8px;
                        margin-left: -20px;
                      "
                    >
                      <img src="../assets/new_icon.png" alt="" />
                    </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <main class="task-list-workspace">
      <section class="list-page-intro" aria-labelledby="list-page-title">
        <div class="list-page-intro-copy">
          <span class="list-page-eyebrow">文档中心</span>
          <h1 id="list-page-title">我的文档</h1>
          <p>集中查看翻译、润色与格式转换任务，及时下载处理结果。</p>
        </div>
        <button
          class="list-page-primary-action"
          type="button"
          data-track-text="开始翻译"
          aria-label="开始翻译"
          @click="toPath('/translate', 'doc')"
        >
          <i class="el-icon-upload2" aria-hidden="true"></i>
          <span>开始翻译</span>
        </button>
      </section>
      <div class="tip-alert-content">
        <div class="tip-alert">
          <template>
            <el-alert center title="" type="">
              <template slot="title">
                提示：您的文档可保留10日，请及时下载。
                <span data-track-text="全部发送邮件" aria-label="全部发送邮件" class="tip-email-action"
                  style="
                    font-size: 14px;
                    font-family: Adobe Heiti Std;
                    font-weight: normal;
                    color: #666666;
                    margin-left: 10px;
                    cursor: pointer;
                  "
                  @click="senEmailAll"
                  >发送至<span style="color: var(--primary); margin-left: 5px"
                    >邮箱</span
                  ></span
                >
              </template>
            </el-alert>
          </template>
        </div>
      </div>
      <div v-if="h5Message || h5ErrorMessage" class="mobile-document-feedback">
        <el-alert
          v-if="h5Message"
          :title="h5Message"
          type="success"
          show-icon
          closable
          @close="h5Message = ''"
        ></el-alert>
        <el-alert
          v-if="h5ErrorMessage"
          :title="h5ErrorMessage"
          type="error"
          show-icon
          closable
          @close="h5ErrorMessage = ''"
        ></el-alert>
      </div>
      <div class="list-content">
        <div class="list-main">
          <div class="list-tab">
            <div class="list-tab-but" role="tablist" aria-label="文档分类">
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'all'"
                class="check-tab-default"
                :class="activeTabClassAll"
                data-track-text="全部文档"
                aria-label="全部文档"
                @click="handleClick('all')"
              >
                全部
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'first'"
                class="check-tab-default"
                :class="activeTabClassFirst"
                data-track-text="机器翻译文档"
                aria-label="机器翻译文档"
                @click="handleClick('first')"
              >
                机器翻译
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'ai'"
                class="check-tab-default"
                :class="activeTabClassAi"
                data-track-text="AI翻译文档"
                aria-label="AI翻译文档"
                @click="handleClick('ai')"
              >
                AI翻译
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'four'"
                class="check-tab-default"
                :class="activeTabClassFour"
                data-track-text="专业翻译文档"
                aria-label="专业翻译文档"
                @click="handleClick('four')"
              >
                专业翻译
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'three'"
                class="check-tab-default"
                :class="activeTabClassThree"
                data-track-text="英语母语润色文档"
                aria-label="英语母语润色文档"
                @click="handleClick('three')"
              >
                <span class="tab-label-desktop">英语母语润色翻译</span>
                <span class="tab-label-mobile">母语润色</span>
              </button>
              <button
                type="button"
                role="tab"
                :aria-selected="activeName === 'second'"
                class="check-tab-default"
                :class="activeTabClassSecond"
                data-track-text="转换文档"
                aria-label="转换文档"
                @click="handleClick('second')"
              >
                转换文档
              </button>
            </div>
          </div>
          <div class="list-context">
            <div class="mobile-document-filters" aria-label="筛选文档">
              <el-input
                v-model.trim="fileName"
                clearable
                prefix-icon="el-icon-search"
                placeholder="搜索文件名"
                aria-label="搜索文件名"
              ></el-input>
              <el-select
                v-model="statusList"
                clearable
                placeholder="全部状态"
                aria-label="筛选文档状态"
              >
                <el-option
                  v-for="item in fileStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>

            <section
              v-loading="mobileDocumentLoading"
              class="mobile-document-list"
              aria-live="polite"
            >
              <article
                v-for="(item, index) in mobileDocumentRows"
                :key="item.id || index"
                class="mobile-document-card"
              >
                <header class="mobile-document-card-header">
                  <span class="mobile-document-index">{{ mobileDocumentIndex(index) }}</span>
                  <div class="mobile-document-heading">
                    <h2 :title="item.name">{{ item.name }}</h2>
                    <span>{{ mobileDocumentType(item) }}</span>
                  </div>
                  <span
                    :class="['mobile-document-status', mobileDocumentStatusTone(item)]"
                  >
                    {{ mobileDocumentStatus(item) }}
                  </span>
                </header>

                <div class="mobile-document-meta">
                  <div>
                    <span>翻译语言</span>
                    <strong :title="item.language || '-'">{{ item.language || '-' }}</strong>
                  </div>
                  <div>
                    <span>页数</span>
                    <strong>{{ item.pageNum || '-' }}</strong>
                  </div>
                  <div>
                    <span>创建时间</span>
                    <strong :title="item.datetime || '-'">{{ item.datetime || '-' }}</strong>
                  </div>
                  <div v-if="item.comment || item.terminology">
                    <span>{{ item.comment ? '翻译需求' : '术语' }}</span>
                    <strong :title="item.comment || item.terminology">
                      {{ item.comment || item.terminology }}
                    </strong>
                  </div>
                </div>

                <div v-if="mobileDocumentIsProgress(item)" class="mobile-document-progress">
                  <div>
                    <span>{{ mobileDocumentStatus(item) }}</span>
                    <strong>{{ mobileDocumentProgress(item) }}%</strong>
                  </div>
                  <el-progress
                    :percentage="mobileDocumentProgress(item)"
                    :stroke-width="5"
                    :show-text="false"
                  ></el-progress>
                </div>

                <div
                  v-if="mobileDocumentHasActions(item)"
                  class="mobile-document-actions"
                >
	                  <button
	                    v-if="mobileDocumentCanPay(item)"
	                    type="button"
	                    class="is-primary"
	                    data-track-id="list-pro.mobile.pay"
	                    data-track-text="去支付"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="mobilePayDocument(item)"
	                  >
                    <i class="el-icon-bank-card" aria-hidden="true"></i>
                    去支付
                  </button>
	                  <button
	                    v-if="mobileDocumentCanContinue(item)"
	                    type="button"
	                    class="is-primary"
	                    data-track-id="list-pro.mobile.continue"
	                    data-track-text="继续沟通"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="toPathH5(item.id)"
	                  >
                    <i class="el-icon-chat-line-round" aria-hidden="true"></i>
                    继续沟通
                  </button>
	                  <button
	                    v-if="mobileDocumentCanDetail(item)"
	                    type="button"
	                    data-track-id="list-pro.mobile.detail"
	                    data-track-text="查看详情"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="toDetail(item.id)"
	                  >
                    <i class="el-icon-document" aria-hidden="true"></i>
                    查看详情
                  </button>
	                  <button
	                    v-if="mobileDocumentCanRead(item)"
	                    type="button"
	                    data-track-id="list-pro.mobile.read"
	                    data-track-text="阅读"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="mobileReadDocument(item)"
	                  >
                    <i class="el-icon-view" aria-hidden="true"></i>
                    阅读
                  </button>
	                  <button
	                    v-if="mobileDocumentCanDownload(item)"
	                    type="button"
	                    class="is-primary"
	                    data-track-id="list-pro.mobile.download"
	                    data-track-text="下载"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="mobileDownloadDocument(item)"
	                  >
                    <i class="el-icon-download" aria-hidden="true"></i>
                    下载
                  </button>
	                  <button
	                    v-if="mobileDocumentCanMail(item)"
	                    type="button"
	                    data-track-id="list-pro.mobile.send-mail"
	                    data-track-text="发邮件"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="sendMail(item)"
	                  >
                    <i class="el-icon-message" aria-hidden="true"></i>
                    发邮件
                  </button>
	                  <button
	                    v-if="mobileDocumentCanDelete(item)"
	                    type="button"
	                    class="is-danger"
	                    data-track-id="list-pro.mobile.delete-open"
	                    data-track-text="打开删除确认"
	                    data-track-component="ListProMobileDocument"
	                    :data-track-business-id="item.id"
	                    @click="mobileDeleteConfirmId = item.id"
	                  >
                    <i class="el-icon-delete" aria-hidden="true"></i>
                    删除
                  </button>
                </div>

                <div
                  v-if="mobileDeleteConfirmId === item.id"
                  class="mobile-document-delete-confirm"
                  role="alert"
                >
                  <span>确定删除这份文档吗？</span>
                  <div>
	                    <button type="button" data-track-id="list-pro.mobile.delete-cancel" data-track-text="取消删除" data-track-component="ListProMobileDocument" :data-track-business-id="item.id" @click="mobileDeleteConfirmId = ''">取消</button>
	                    <button type="button" data-track-id="list-pro.mobile.delete-confirm" data-track-text="确定删除" data-track-component="ListProMobileDocument" :data-track-business-id="item.id" @click="mobileDeleteDocument(item)">确定删除</button>
                  </div>
                </div>
              </article>

              <div
                v-if="!mobileDocumentLoading && mobileDocumentRows.length === 0"
                class="mobile-document-empty"
              >
                <i class="el-icon-folder-opened" aria-hidden="true"></i>
                <strong>暂无文档</strong>
                <span>换个筛选条件，或开始新的翻译任务</span>
              </div>
            </section>
            <div v-show="activeName === 'all'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  :v-loading="allLoading"
                  size="small"
                  ref="multipleTable"
                  :data="allTableData"
                  tooltip-effect="light"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#fcfcfc',
                    'line-height': '30px',
                    height: '90px',
                    'border-radius': '3px',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="翻译语言"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="transType"
                    label="翻译类型"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="175"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.uploadType === 0 ||
                          scope.row.uploadType === 5
                        "
                      >
                        <span
                          v-if="scope.row.status !== '待支付'"
                          :style="
                            scope.row.status === '翻译中'
                              ? '#333333'
                              : scope.row.status === '翻译失败'
                              ? 'color:red;'
                              : scope.row.status === '待支付'
                              ? 'color:#e13f3f'
                              : scope.row.status === '排队中'
                              ? 'color:#E55050'
                              : scope.row.status === '已翻译'
                              ? 'color:var(--primary)'
                              : scope.row.status === '已下载' ||
                                scope.row.status === '已删除' ||
                                scope.row.status === '已过期'
                              ? 'color:#999999'
                              : 'color:#333333'
                          "
                          >{{ scope.row.status }}</span
                        >
                        <br v-show="scope.row.status === '翻译失败'" />
                        <span
                          v-show="
                            scope.row.status === '翻译失败' &&
                            scope.row.refundMode === '1'
                          "
                          style="color: red; font-size: 12px"
                        >
                          支付金额已退款到个人钱包</span
                        >
                        <span
                          v-show="
                            scope.row.status === '翻译失败' &&
                            scope.row.refundMode === '2'
                          "
                          style="color: red; font-size: 12px"
                        >
                          支付金额已退款到机构余额</span
                        >
                        <el-progress
                          class="listprogress"
                          :text-inside="false"
                          v-show="scope.row.status === '翻译中'"
                          :stroke-width="7"
                          :percentage="scope.row.numbers"
                          :color="customColor"
                        >
                        </el-progress>
                        <div
                          v-if="scope.row.status === '待支付'"
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          @click="pay(scope.row)"
                          style="
                            cursor: pointer;
                            text-align: center;
                            margin: 0 auto;
                            width: 46px;
                            height: 26px;
                            border-bottom: 1px solid #e7301e;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #e7301e;
                          "
                        >
                          去支付
                        </div>
                      </div>
                      <div v-if="scope.row.uploadType === 1">
                        <span
                          v-if="scope.row.status !== '待支付'"
                          :style="
                            scope.row.status === '转换中'
                              ? 'color:#333333;'
                              : scope.row.status === '转换失败'
                              ? 'color:red;'
                              : scope.row.status === '待支付'
                              ? 'color:#e13f3f'
                              : scope.row.status === '排队中'
                              ? 'color:#E55050'
                              : scope.row.status === '已转换'
                              ? 'color:var(--primary)'
                              : scope.row.status === '已下载' ||
                                scope.row.status === '已删除' ||
                                scope.row.status === '已过期'
                              ? 'color:#9a9a9a'
                              : 'color:#333333;'
                          "
                          >{{
                            scope.row.status === "转换中"
                              ? ""
                              : scope.row.status
                          }}</span
                        >
                        <br v-show="scope.row.status === '翻译失败'" />
                        <span
                          v-show="
                            scope.row.status === '翻译失败' &&
                            scope.row.refundMode === '1'
                          "
                          style="color: red; font-size: 12px"
                        >
                          支付金额已退款到个人钱包</span
                        >
                        <span
                          v-show="
                            scope.row.status === '翻译失败' &&
                            scope.row.refundMode === '2'
                          "
                          style="color: red; font-size: 12px"
                        >
                          支付金额已退款到机构余额</span
                        >
                        <el-progress
                          class="listprogress"
                          :text-inside="false"
                          v-show="scope.row.status === '转换中'"
                          :stroke-width="7"
                          :percentage="scope.row.numbers"
                          :color="customColor"
                        >
                        </el-progress>
                        <div
                          v-if="scope.row.status === '待支付'"
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          @click="pay(scope.row)"
                          style="
                            cursor: pointer;
                            text-align: center;
                            margin: 0 auto;
                            width: 46px;
                            height: 26px;
                            border-bottom: 1px solid #e7301e;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #e7301e;
                          "
                        >
                          去支付
                        </div>
                      </div>
                      <div
                        v-if="
                          scope.row.uploadType === 3 ||
                          scope.row.uploadType === 2
                        "
                      >
                        <span
                          v-if="
                            scope.row.status !== '394' &&
                            scope.row.status !== '431'
                          "
                          :style="
                            scope.row.status === '448'
                              ? 'color:#E55050;'
                              : scope.row.status === '431'
                              ? 'color:#999999;'
                              : scope.row.status === '395'
                              ? 'color:#F0833C'
                              : scope.row.status === '396'
                              ? 'color:var(--primary)'
                              : scope.row.status === '502' ||
                                scope.row.status === '501' ||
                                scope.row.status === '500'
                              ? 'color:#999999'
                              : 'color:#333333'
                          "
                          >{{
                            scope.row.status === "431"
                              ? "等待客服沟通......"
                              : scope.row.status === "395"
                              ? "等待译员处理"
                              : scope.row.status === "396"
                              ? "人工翻译已完成"
                              : scope.row.status === "502"
                              ? "已下载"
                              : scope.row.status === "501"
                              ? "已删除"
                              : scope.row.status === "500"
                              ? "已过期"
                              : scope.row.status === "448"
                              ? "任务终止,退款中"
                              : ""
                          }}</span
                        >
                        <el-popover
                          v-if="
                            scope.row.status !== '394' &&
                            scope.row.status === '431'
                          "
                          placement="bottom-start"
                          :width="194"
                          trigger="hover"
                        >
                          <template #reference>
                            <span :style="'color:#999999;'">
                              {{ "等待客服沟通......" }}
                            </span>
                          </template>
                          <div
                            style="
                              height: 186px;
                              display: flex;
                              flex-flow: column;
                              margin-top: 20px;
                            "
                          >
                            <div
                              style="
                                font-size: 14px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                color: var(--primary);
                                display: flex;
                                align-items: baseline;
                              "
                            >
                              <div
                                style="
                                  width: 10px;
                                  height: 10px;
                                  background: var(--primary);
                                  border-radius: 50%;
                                  margin-left: 20px;
                                  margin-right: 20px;
                                "
                              ></div>
                              <span>订单提交成功</span>
                            </div>
                            <div>
                              <div
                                style="
                                  margin-top: 2px;
                                  margin-left: 24px;
                                  width: 1px;
                                  height: 25px;
                                  background: var(--primary);
                                "
                              ></div>
                            </div>
                            <div
                              style="
                                font-size: 14px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                color: #f0833c;
                                display: flex;
                                align-items: baseline;
                              "
                            >
                              <div
                                style="
                                  width: 10px;
                                  height: 10px;
                                  background: #f0833c;
                                  border-radius: 50%;
                                  margin-left: 20px;
                                  margin-right: 20px;
                                "
                              ></div>
                              <span>等待客服沟通报价</span>
                            </div>
                            <div>
                              <div
                                style="
                                  margin-top: 2px;
                                  margin-left: 24px;
                                  width: 1px;
                                  height: 25px;
                                  background: #999999;
                                "
                              ></div>
                            </div>
                            <div
                              style="
                                font-size: 14px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                color: #999999;
                                display: flex;
                                align-items: baseline;
                              "
                            >
                              <div
                                style="
                                  width: 10px;
                                  height: 10px;
                                  background: #999999;
                                  border-radius: 50%;
                                  margin-left: 20px;
                                  margin-right: 20px;
                                "
                              ></div>
                              <span>确认并支付订单</span>
                            </div>
                            <div>
                              <div
                                style="
                                  margin-top: 2px;
                                  margin-left: 24px;
                                  width: 1px;
                                  height: 25px;
                                  background: #999999;
                                "
                              ></div>
                            </div>
                            <div
                              style="
                                font-size: 14px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                color: #999999;
                                display: flex;
                                align-items: baseline;
                              "
                            >
                              <div
                                style="
                                  width: 10px;
                                  height: 10px;
                                  background: #999999;
                                  border-radius: 50%;
                                  margin-left: 20px;
                                  margin-right: 20px;
                                "
                              ></div>
                              <span>恭喜您成功获得译文</span>
                            </div>
                          </div>
                        </el-popover>
                        <div
                          v-if="scope.row.status === '394'"
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          @click="pay(scope.row)"
                          style="
                            cursor: pointer;
                            text-align: center;
                            margin: 0 auto;
                            width: 46px;
                            height: 26px;
                            border-bottom: 1px solid #e7301e;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            color: #e7301e;
                          "
                        >
                          去支付
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="yeshu"
                    align="center"
                    prop="pageNum"
                    label="页数"
                    width="80"
                  >
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="
                          scope.row.uploadType === 0 ||
                          scope.row.uploadType === 5
                        "
                      >
                        <div
                          v-if="scope.row.status !== '待支付'"
                          class="caozuoinfo"
                        >
                          <div
                            class="read el-icon-yuedu"
                            data-track-text="阅读文档"
                            aria-label="阅读文档"
                            :style="
                              !canReadDocument(scope.row)
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            @click="
                              !canReadDocument(scope.row)
                                ? ''
                                : readingFile(scope.row)
                            "
                          ></div>
                          <div
                            class="down el-icon-xiazai1"
                            data-track-text="下载文档"
                            aria-label="下载文档"
                            :style="
                              scope.row.disables.disablesdown
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            @click="
                              scope.row.disables.disablesdown
                                ? ''
                                : downloadFile(scope.row)
                            "
                          ></div>
                          <div
                            class="mail el-icon-youjian"
                            data-track-text="发送邮件"
                            aria-label="发送邮件"
                            @click="sendMail(scope.row)"
                          ></div>
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="
                                  scope.row.disables.disablesdel
                                    ? ''
                                    : deleteFile(scope)
                                "
                                >确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              :style="
                                scope.row.disables.disablesdel
                                  ? 'cursor: no-drop;'
                                  : ''
                              "
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                        <div
                          v-if="scope.row.status === '待支付'"
                          class="caozuoinfo"
                        >
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="deleteFile(scope)"
                                >确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                      </div>
                      <div v-if="scope.row.uploadType === 1">
                        <div
                          v-if="scope.row.status !== '待支付'"
                          class="caozuoinfo"
                        >
                          <div
                            class="down el-icon-xiazai1"
                            data-track-text="下载转换文档"
                            aria-label="下载转换文档"
                            :style="
                              scope.row.disables.disablesdown
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            @click="
                              scope.row.disables.disablesdown
                                ? ''
                                : downloadConvertFile(scope.row)
                            "
                          ></div>
                          <div
                            class="mail el-icon-youjian"
                            data-track-text="发送邮件"
                            aria-label="发送邮件"
                            @click="sendMail(scope.row)"
                          ></div>
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="
                                  scope.row.disables.disablesdel
                                    ? ''
                                    : deleteFile(scope)
                                "
                                >确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              :style="
                                scope.row.disables.disablesdel
                                  ? 'cursor: no-drop;'
                                  : ''
                              "
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                        <div
                          v-if="scope.row.status === '待支付'"
                          class="caozuoinfo"
                        >
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="deleteFile(scope)"
                                >确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                      </div>

                      <div
                        v-if="
                          scope.row.uploadType === 3 ||
                          scope.row.uploadType === 2
                        "
                      >
                        <div
                          v-if="scope.row.status !== '394'"
                          class="caozuoinfo"
                        >
                          <div
                            class="detail el-icon-xiangqing"
                            data-track-text="查看详情"
                            aria-label="查看详情"
                            @click="toDetail(scope.row.id)"
                          ></div>
                          <div
                            class="read el-icon-yuedu"
                            data-track-text="阅读文档"
                            aria-label="阅读文档"
                            :style="
                              !canReadDocument(scope.row)
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            @click="
                              !canReadDocument(scope.row)
                                ? ''
                                : readingFile(scope.row)
                            "
                          ></div>
                          <div
                            class="down el-icon-xiazai1"
                            data-track-text="下载文档"
                            aria-label="下载文档"
                            :style="
                              scope.row.disables.disablesdown
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            @click="
                              scope.row.disables.disablesdown
                                ? ''
                                : downloadFile(scope.row)
                            "
                          ></div>
                          <div
                            class="mail el-icon-youjian"
                            data-track-text="发送邮件"
                            aria-label="发送邮件"
                            @click="sendMail(scope.row)"
                          ></div>
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="
                                  scope.row.disables.disablesdel
                                    ? scope.row.status === '431'
                                      ? deleteFile(scope)
                                      : ''
                                    : deleteFile(scope)
                                "
                              >
                                确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              :style="
                                scope.row.disables.disablesdel
                                  ? scope.row.status === '431'
                                    ? ''
                                    : 'cursor: no-drop;'
                                  : ''
                              "
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                        <div
                          v-if="scope.row.status === '394'"
                          class="caozuoinfo"
                        >
                          <div
                            class="detail el-icon-xiangqing"
                            data-track-text="查看详情"
                            aria-label="查看详情"
                            @click="toDetail(scope.row.id)"
                          ></div>
                          <el-popover
                            placement="top"
                            width="300"
                            :ref="`popover-${scope.$index}`"
                          >
                            <p>确定删除当前文件吗？</p>
                            <div style="text-align: right; margin: 0">
                              <el-button
                                size="mini"
                                data-track-text="取消删除文档"
                                aria-label="取消删除文档"
                                @click="
                                  scope._self.$refs[
                                    `popover-${scope.$index}`
                                  ].doClose()
                                "
                              >
                                取消
                              </el-button>
                              <el-button
                                type="primary"
                                data-track-text="确认删除文档"
                                aria-label="确认删除文档"
                                style="
                                  background-color: var(--primary);
                                  border-color: var(--primary);
                                "
                                size="mini"
                                @click="deleteFile(scope)"
                                >确定
                              </el-button>
                            </div>
                            <div
                              class="del el-icon-customerarchivesrecycleBin"
                              data-track-text="删除文档"
                              aria-label="删除文档"
                              slot="reference"
                            ></div>
                          </el-popover>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="countAll !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ countAll }}条
                </div>
                <div
                  v-if="countAll !== 0"
                  style="margin-top: 20px; float: right"
                >
                  <el-pagination
                    background
                    @size-change="handleAllSizeChange"
                    @current-change="handleAllCurrentChange"
                    :current-page="currentAllPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="countAll"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="activeName === 'first'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  :v-loading="transloading"
                  size="small"
                  ref="multipleTable"
                  :data="tableData"
                  tooltip-effect="light"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#fcfcfc',
                    'line-height': '30px',
                    height: '90px',
                    'border-radius': '3px',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexFirstMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="翻译语言"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="transType"
                    label="翻译类型"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="terminology"
                    label="术语"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="90"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.status !== '待支付'"
                        :style="
                          scope.row.status === '翻译中'
                            ? '#333333'
                            : scope.row.status === '翻译失败'
                            ? 'color:red;'
                            : scope.row.status === '待支付'
                            ? 'color:#e13f3f'
                            : scope.row.status === '排队中'
                            ? 'color:#E55050'
                            : scope.row.status === '已翻译'
                            ? 'color:var(--primary)'
                            : scope.row.status === '已下载' ||
                              scope.row.status === '已删除' ||
                              scope.row.status === '已过期'
                            ? 'color:#999999'
                            : 'color:#333333'
                        "
                        >{{ scope.row.status }}</span
                      >
                      <br v-show="scope.row.status === '翻译失败'" />
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '1'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到个人钱包</span
                      >
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '2'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到机构余额</span
                      >
                      <el-progress
                        class="listprogress"
                        :text-inside="false"
                        v-show="scope.row.status === '翻译中'"
                        :stroke-width="7"
                        :percentage="scope.row.numbers"
                        :color="customColor"
                      >
                      </el-progress>
                      <div data-track-text="继续支付" aria-label="继续支付"
                        v-if="scope.row.status === '待支付'"
                        @click="pay(scope.row)"
                        style="
                          cursor: pointer;
                          text-align: center;
                          margin: 0 auto;
                          width: 46px;
                          height: 26px;
                          border-bottom: 1px solid #e7301e;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #e7301e;
                        "
                      >
                        去支付
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="yeshu"
                    align="center"
                    prop="pageNum"
                    label="页数"
                    width="82"
                  >
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.status !== '待支付'"
                        class="caozuoinfo"
                      >
                        <div data-track-text="阅读文档" aria-label="阅读文档"
                          class="read el-icon-yuedu"
                          :style="
                            !canReadDocument(scope.row)
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            !canReadDocument(scope.row)
                              ? ''
                              : readingFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="下载文档" aria-label="下载文档"
                          class="down el-icon-xiazai1"
                          :style="
                            scope.row.disables.disablesdown
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            scope.row.disables.disablesdown
                              ? ''
                              : downloadFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="发送邮件" aria-label="发送邮件"
                          class="mail el-icon-youjian"
                          @click="sendMail(scope.row)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="
                                scope.row.disables.disablesdel
                                  ? ''
                                  : deleteFile(scope)
                              "
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            :style="
                              scope.row.disables.disablesdel
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                      <div
                        v-if="scope.row.status === '待支付'"
                        class="caozuoinfo"
                      >
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="deleteFile(scope)"
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="count !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ count }}条
                </div>
                <div v-if="count !== 0" style="margin-top: 20px; float: right">
                  <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="count"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="activeName === 'second'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  :v-loading="convertloading"
                  size="small"
                  ref="multipleTable"
                  :data="convertTableData"
                  tooltip-effect="dark"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#FCFCFC',
                    'line-height': '30px',
                    height: '90px',
                    'box-shadow': '0px 3px 3px 0px rgba(0, 0, 0, 0.05)',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexConvertMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="格式转换"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="189"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.status !== '待支付'"
                        :style="
                          scope.row.status === '转换中'
                            ? 'color:#333333;'
                            : scope.row.status === '转换失败'
                            ? 'color:red;'
                            : scope.row.status === '待支付'
                            ? 'color:#e13f3f'
                            : scope.row.status === '排队中'
                            ? 'color:#E55050'
                            : scope.row.status === '已转换'
                            ? 'color:var(--primary)'
                            : scope.row.status === '已下载' ||
                              scope.row.status === '已删除' ||
                              scope.row.status === '已过期'
                            ? 'color:#9a9a9a'
                            : 'color:#333333;'
                        "
                        >{{ scope.row.status }}</span
                      >
                      <br v-show="scope.row.status === '翻译失败'" />
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '1'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到个人钱包</span
                      >
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '2'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到机构余额</span
                      >
                      <el-progress
                        class="listprogress"
                        :text-inside="false"
                        v-show="scope.row.status === '转换中'"
                        :stroke-width="7"
                        :percentage="scope.row.numbers"
                        :color="customColor"
                      >
                      </el-progress>
                      <div data-track-text="继续支付" aria-label="继续支付"
                        v-if="scope.row.status === '待支付'"
                        @click="pay(scope.row)"
                        style="
                          cursor: pointer;
                          text-align: center;
                          margin: 0 auto;
                          width: 46px;
                          height: 26px;
                          border-bottom: 1px solid #e7301e;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #e7301e;
                        "
                      >
                        去支付
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="yeshu"
                    align="center"
                    prop="pageNum"
                    label="页数"
                    width="82"
                  >
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.status !== '待支付'"
                        class="caozuoinfo"
                      >
                        <div data-track-text="下载转换文档" aria-label="下载转换文档"
                          class="down el-icon-xiazai1"
                          :style="
                            scope.row.disables.disablesdown
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            scope.row.disables.disablesdown
                              ? ''
                              : downloadConvertFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="发送邮件" aria-label="发送邮件"
                          class="mail el-icon-youjian"
                          @click="sendMail(scope.row)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="
                                scope.row.disables.disablesdel
                                  ? ''
                                  : deleteFile(scope)
                              "
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            :style="
                              scope.row.disables.disablesdel
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                      <div
                        v-if="scope.row.status === '待支付'"
                        class="caozuoinfo"
                      >
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="deleteFile(scope)"
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="countConvert !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ countConvert }}条
                </div>
                <div
                  v-if="countConvert !== 0"
                  style="margin-top: 20px; float: right"
                >
                  <el-pagination
                    background
                    @size-change="handleConvertSizeChange"
                    @current-change="handleConvertCurrentChange"
                    :current-page="currentConvertPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="countConvert"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="activeName === 'three'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  :v-loading="polishLoading"
                  size="small"
                  ref="multipleTable"
                  :data="polishTableData"
                  tooltip-effect="light"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#fcfcfc',
                    'line-height': '30px',
                    height: '90px',
                    'border-radius': '3px',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexThreeMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="翻译语言"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="transType"
                    label="翻译类型"
                    width="123"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="189"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-if="
                          scope.row.status !== '394' &&
                          scope.row.status !== '431'
                        "
                        :style="
                          scope.row.status === '448'
                            ? 'color:#E55050;'
                            : scope.row.status === '431'
                            ? 'color:#999999;'
                            : scope.row.status === '395'
                            ? 'color:#F0833C'
                            : scope.row.status === '396'
                            ? 'color:var(--primary)'
                            : scope.row.status === '502' ||
                              scope.row.status === '501' ||
                              scope.row.status === '500'
                            ? 'color:#999999'
                            : 'color:#333333'
                        "
                        >{{
                          scope.row.status === "431"
                            ? "等待客服沟通......"
                            : scope.row.status === "395"
                            ? "等待译员处理"
                            : scope.row.status === "396"
                            ? "人工翻译已完成"
                            : scope.row.status === "502"
                            ? "已下载"
                            : scope.row.status === "501"
                            ? "已删除"
                            : scope.row.status === "500"
                            ? "已过期"
                            : scope.row.status === "448"
                            ? "任务终止,退款中"
                            : ""
                        }}</span
                      >
                      <el-popover
                        v-if="
                          scope.row.status !== '394' &&
                          scope.row.status === '431'
                        "
                        placement="bottom-start"
                        :width="194"
                        trigger="hover"
                      >
                        <template #reference>
                          <span :style="'color:#999999;'">
                            {{ "等待客服沟通......" }}
                          </span>
                        </template>
                        <div
                          style="
                            height: 186px;
                            display: flex;
                            flex-flow: column;
                            margin-top: 20px;
                          "
                        >
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: var(--primary);
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: var(--primary);
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>订单提交成功</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: var(--primary);
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #f0833c;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #f0833c;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>等待客服沟通报价</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: #999999;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #999999;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #999999;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>确认并支付订单</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: #999999;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #999999;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #999999;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>恭喜您成功获得译文</span>
                          </div>
                        </div>
                      </el-popover>
                      <div data-track-text="继续支付" aria-label="继续支付"
                        v-if="scope.row.status === '394'"
                        @click="pay(scope.row)"
                        style="
                          cursor: pointer;
                          text-align: center;
                          margin: 0 auto;
                          width: 46px;
                          height: 26px;
                          border-bottom: 1px solid #e7301e;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #e7301e;
                        "
                      >
                        去支付
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.status !== '394'" class="caozuoinfo">
                        <div data-track-text="查看详情" aria-label="查看详情"
                          class="detail el-icon-xiangqing"
                          @click="toDetail(scope.row.id)"
                        ></div>
                        <div data-track-text="阅读文档" aria-label="阅读文档"
                          class="read el-icon-yuedu"
                          :style="
                            !canReadDocument(scope.row)
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            !canReadDocument(scope.row)
                              ? ''
                              : readingFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="下载文档" aria-label="下载文档"
                          class="down el-icon-xiazai1"
                          :style="
                            scope.row.disables.disablesdown
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            scope.row.disables.disablesdown
                              ? ''
                              : downloadFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="发送邮件" aria-label="发送邮件"
                          class="mail el-icon-youjian"
                          @click="sendMail(scope.row)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="
                                scope.row.disables.disablesdel
                                  ? scope.row.status === '431'
                                    ? deleteFile(scope)
                                    : ''
                                  : deleteFile(scope)
                              "
                            >
                              确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            :style="
                              scope.row.disables.disablesdel
                                ? scope.row.status === '431'
                                  ? ''
                                  : 'cursor: no-drop;'
                                : ''
                            "
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                      <div v-if="scope.row.status === '394'" class="caozuoinfo">
                        <div data-track-text="查看详情" aria-label="查看详情"
                          class="detail el-icon-xiangqing"
                          @click="toDetail(scope.row.id)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="deleteFile(scope)"
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="countPolish !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ countPolish }}条
                </div>
                <div
                  v-if="countPolish !== 0"
                  style="margin-top: 20px; float: right"
                >
                  <el-pagination
                    background
                    @size-change="handlePublishSizeChange"
                    @current-change="handlePublishCurrentChange"
                    :current-page="currentPolishPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="countPolish"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="activeName === 'four'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  :v-loading="docLoading"
                  size="small"
                  ref="multipleTable"
                  :data="docTableData"
                  tooltip-effect="light"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#fcfcfc',
                    'line-height': '30px',
                    height: '90px',
                    'border-radius': '3px',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexFourMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="翻译语言"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="transType"
                    label="翻译类型"
                    width="123"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="189"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-if="
                          scope.row.status !== '394' &&
                          scope.row.status !== '431'
                        "
                        :style="
                          scope.row.status === '448'
                            ? 'color:#E55050;'
                            : scope.row.status === '431'
                            ? 'color:#999999;'
                            : scope.row.status === '395'
                            ? 'color:#F0833C'
                            : scope.row.status === '396'
                            ? 'color:var(--primary)'
                            : scope.row.status === '502' ||
                              scope.row.status === '501' ||
                              scope.row.status === '500'
                            ? 'color:#999999'
                            : 'color:#333333'
                        "
                        >{{
                          scope.row.status === "431"
                            ? "等待客服沟通......"
                            : scope.row.status === "395"
                            ? "等待译员处理"
                            : scope.row.status === "396"
                            ? "人工翻译已完成"
                            : scope.row.status === "502"
                            ? "已下载"
                            : scope.row.status === "501"
                            ? "已删除"
                            : scope.row.status === "500"
                            ? "已过期"
                            : scope.row.status === "448"
                            ? "任务终止,退款中"
                            : ""
                        }}</span
                      >
                      <el-popover
                        v-if="
                          scope.row.status !== '394' &&
                          scope.row.status === '431'
                        "
                        placement="bottom-start"
                        :width="194"
                        trigger="hover"
                      >
                        <template #reference>
                          <span :style="'color:#999999;'">
                            {{ "等待客服沟通......" }}
                          </span>
                        </template>
                        <div
                          style="
                            height: 186px;
                            display: flex;
                            flex-flow: column;
                            margin-top: 20px;
                          "
                        >
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: var(--primary);
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: var(--primary);
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>订单提交成功</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: var(--primary);
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #f0833c;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #f0833c;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>等待客服沟通报价</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: #999999;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #999999;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #999999;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>确认并支付订单</span>
                          </div>
                          <div>
                            <div
                              style="
                                margin-top: 2px;
                                margin-left: 24px;
                                width: 1px;
                                height: 25px;
                                background: #999999;
                              "
                            ></div>
                          </div>
                          <div
                            style="
                              font-size: 14px;
                              font-family: Microsoft YaHei;
                              font-weight: 400;
                              color: #999999;
                              display: flex;
                              align-items: baseline;
                            "
                          >
                            <div
                              style="
                                width: 10px;
                                height: 10px;
                                background: #999999;
                                border-radius: 50%;
                                margin-left: 20px;
                                margin-right: 20px;
                              "
                            ></div>
                            <span>恭喜您成功获得译文</span>
                          </div>
                        </div>
                      </el-popover>
                      <div data-track-text="继续支付" aria-label="继续支付"
                        v-if="scope.row.status === '394'"
                        @click="pay(scope.row)"
                        style="
                          cursor: pointer;
                          text-align: center;
                          margin: 0 auto;
                          width: 46px;
                          height: 26px;
                          border-bottom: 1px solid #e7301e;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #e7301e;
                        "
                      >
                        去支付
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.status !== '394'" class="caozuoinfo">
                        <div data-track-text="查看详情" aria-label="查看详情"
                          class="detail el-icon-xiangqing"
                          @click="toDetail(scope.row.id)"
                        ></div>
                        <div data-track-text="阅读文档" aria-label="阅读文档"
                          class="read el-icon-yuedu"
                          :style="
                            !canReadDocument(scope.row)
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            !canReadDocument(scope.row)
                              ? ''
                              : readingFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="下载文档" aria-label="下载文档"
                          class="down el-icon-xiazai1"
                          :style="
                            scope.row.disables.disablesdown
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            scope.row.disables.disablesdown
                              ? ''
                              : downloadFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="发送邮件" aria-label="发送邮件"
                          class="mail el-icon-youjian"
                          @click="sendMail(scope.row)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="
                                scope.row.disables.disablesdel
                                  ? scope.row.status === '431'
                                    ? deleteFile(scope)
                                    : ''
                                  : deleteFile(scope)
                              "
                            >
                              确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            :style="
                              scope.row.disables.disablesdel
                                ? scope.row.status === '431'
                                  ? ''
                                  : 'cursor: no-drop;'
                                : ''
                            "
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                      <div v-if="scope.row.status === '394'" class="caozuoinfo">
                        <div data-track-text="查看详情" aria-label="查看详情"
                          class="detail el-icon-xiangqing"
                          @click="toDetail(scope.row.id)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="deleteFile(scope)"
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="countDoc !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ countDoc }}条
                </div>
                <div
                  v-if="countDoc !== 0"
                  style="margin-top: 20px; float: right"
                >
                  <el-pagination
                    background
                    @size-change="handleDocSizeChange"
                    @current-change="handleDocCurrentChange"
                    :current-page="currentDocPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="countDoc"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
            <div v-show="activeName === 'ai'" class="filelist-domain">
              <div class="list-table-shell" style="min-height: 780px">
                <el-table
                  border
                  size="small"
                  ref="multipleTable"
                  :data="aiFileList"
                  :v-loading="aiLoading"
                  tooltip-effect="light"
                  style="width: 100%"
                  :row-class-name="tableRowClassName"
                  :header-cell-style="{
                    'font-size': '16px',
                    'font-family': 'Microsoft YaHei',
                    'font-weight': '400',
                    color: '#666666',
                    background: '#fcfcfc',
                    'line-height': '30px',
                    height: '90px',
                    'border-radius': '3px',
                  }"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="xuhao"
                    label="序号"
                    type="index"
                    width="65"
                    prop="id"
                    :index="indexFirstMethod"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    label-class-name="wendang"
                    label="文件名"
                    show-overflow-tooltip
                    prop="name"
                    min-width="360"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-input
                        suffix-icon="el-icon-search"
                        v-model="fileName"
                        size="mini"
                        placeholder="文件名"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="language"
                    label="翻译语言"
                    min-width="160"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="transType"
                    label="翻译类型"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="left"
                    show-overflow-tooltip
                    label-class-name="fanyi"
                    prop="terminology"
                    label="术语"
                    width="100"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label-class-name="zhuangtai"
                    prop="status"
                    label="状态"
                    width="90"
                  >
                    <template slot="header" slot-scope="scope">
                      <el-select v-model="statusList" placeholder="状态">
                        <el-option
                          v-for="item in fileStatus"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </template>
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.status !== '待支付'"
                        :style="
                          scope.row.status === '翻译中'
                            ? '#333333'
                            : scope.row.status === '翻译失败'
                            ? 'color:red;'
                            : scope.row.status === '待支付'
                            ? 'color:#e13f3f'
                            : scope.row.status === '排队中'
                            ? 'color:#E55050'
                            : scope.row.status === '已翻译'
                            ? 'color:var(--primary)'
                            : scope.row.status === '已下载' ||
                              scope.row.status === '已删除' ||
                              scope.row.status === '已过期'
                            ? 'color:#999999'
                            : 'color:#333333'
                        "
                        >{{ scope.row.status }}</span
                      >
                      <br v-show="scope.row.status === '翻译失败'" />
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '1'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到个人钱包</span
                      >
                      <span
                        v-show="
                          scope.row.status === '翻译失败' &&
                          scope.row.refundMode === '2'
                        "
                        style="color: red; font-size: 12px"
                      >
                        支付金额已退款到机构余额</span
                      >
                      <el-progress
                        class="listprogress"
                        :text-inside="false"
                        v-show="scope.row.status === '翻译中'"
                        :stroke-width="7"
                        :percentage="scope.row.numbers"
                        :color="customColor"
                      >
                      </el-progress>
                      <div data-track-text="继续支付" aria-label="继续支付"
                        v-if="scope.row.status === '待支付'"
                        @click="pay(scope.row)"
                        style="
                          cursor: pointer;
                          text-align: center;
                          margin: 0 auto;
                          width: 46px;
                          height: 26px;
                          border-bottom: 1px solid #e7301e;
                          font-size: 14px;
                          font-family: Microsoft YaHei;
                          font-weight: 400;
                          color: #e7301e;
                        "
                      >
                        去支付
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label-class-name="yeshu"
                    align="center"
                    prop="pageNum"
                    label="页数"
                    width="82"
                  >
                  </el-table-column>
                  <el-table-column
                    label-class-name="caozuo"
                    label="操作"
                    header-align="center"
                    align="center"
                    prop="disables"
                    width="220"
                  >
                    <template slot-scope="scope">
                      <div
                        v-if="scope.row.status !== '待支付'"
                        class="caozuoinfo"
                      >
                        <div data-track-text="阅读文档" aria-label="阅读文档"
                          class="read el-icon-yuedu"
                          :style="
                            !canReadDocument(scope.row)
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            !canReadDocument(scope.row)
                              ? ''
                              : readingFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="下载文档" aria-label="下载文档"
                          class="down el-icon-xiazai1"
                          :style="
                            scope.row.disables.disablesdown
                              ? 'cursor: no-drop;'
                              : ''
                          "
                          @click="
                            scope.row.disables.disablesdown
                              ? ''
                              : downloadFile(scope.row)
                          "
                        ></div>
                        <div data-track-text="发送邮件" aria-label="发送邮件"
                          class="mail el-icon-youjian"
                          @click="sendMail(scope.row)"
                        ></div>
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="
                                scope.row.disables.disablesdel
                                  ? ''
                                  : deleteFile(scope)
                              "
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            :style="
                              scope.row.disables.disablesdel
                                ? 'cursor: no-drop;'
                                : ''
                            "
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                      <div
                        v-if="scope.row.status === '待支付'"
                        class="caozuoinfo"
                      >
                        <el-popover
                          placement="top"
                          width="300"
                          :ref="`popover-${scope.$index}`"
                        >
                          <p>确定删除当前文件吗？</p>
                          <div style="text-align: right; margin: 0">
                            <el-button data-track-text="取消删除文档" aria-label="取消删除文档"
                              size="mini"
                              @click="
                                scope._self.$refs[
                                  `popover-${scope.$index}`
                                ].doClose()
                              "
                            >
                              取消
                            </el-button>
                            <el-button data-track-text="确认删除文档" aria-label="确认删除文档"
                              type="primary"
                              style="
                                background-color: var(--primary);
                                border-color: var(--primary);
                              "
                              size="mini"
                              @click="deleteFile(scope)"
                              >确定
                            </el-button>
                          </div>
                          <div
                            class="del el-icon-customerarchivesrecycleBin"
                            slot="reference"
                          ></div>
                        </el-popover>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div
                  v-if="countAi !== 0"
                  style="
                    font-family: 'Microsoft YaHei';
                    margin-top: 20px;
                    float: left;
                    font-size: 14px;
                  "
                >
                  共{{ countAi }}条
                </div>
                <div v-if="countAi !== 0" style="margin-top: 20px; float: right">
                  <el-pagination
                    background
                    @current-change="handleAiCurrentChange"
                    :current-page="currentAiPage"
                    :page-size="10"
                    :pager-count="5"
                    layout="prev, pager, next"
                    :total="countAi"
                  >
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </main>
      <div v-if="false" class="foot">
        <span
          >© 2020 北京容智科技发展有限公司
          <a
            href="https://beian.miit.gov.cn/#/Integrated/index"
            style="color: white"
            >京ICP备19036872号-3</a
          >
          All rights reserved. 京公网安备<a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011402010815"
            style="color: white"
            >11011402010815</a
          ></span
        >
        <span
          ><a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询"
            >联系邮箱：info@wiseivy.com.cn</a
          >
          <span style="margin-left: 15px">联系电话：010-80755328</span></span
        >
      </div>
      <site-footer />
      <floating-contact-tools />
    </div>
    <div v-if="false" class="main-index">
      <div class="header">
        <div data-track-text="登录" aria-label="登录"
          class="login"
          v-show="userInfo === ''"
          @click="toPath('/h5/login')"
        >
          登录
        </div>
        <div class="login" v-show="userInfo !== ''">
          <el-dropdown
            @command="logOut"
            v-if="showloginOut"
            style="
              display: flex;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              background: #f5f5f5;
            "
          >
            <span
              v-show="userInfo !== ''"
              class="title_hide"
              style="
                overflow-x: hidden;
                text-overflow: ellipsis;
                width: 100px;
                white-space: nowrap;
              "
            >
              {{ userInfo }}
            </span>
            <el-dropdown-menu v-if="showloginOut" slot="dropdown">
              <el-dropdown-item
                command="toCenter"
                style="z-index: 1; font-weight: 800"
              >
                <span
                  style="
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  >充值中心</span
                >
              </el-dropdown-item>
              <el-dropdown-item
                command="toAccount"
                style="z-index: 1; font-weight: 800"
              >
                <span
                  style="
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  >个人设置</span
                >
              </el-dropdown-item>
              <el-dropdown-item
                command="toOrder"
                style="z-index: 1; font-weight: 800"
              >
                <span
                  style="
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  >订单详情</span
                >
              </el-dropdown-item>
              <el-dropdown-item style="z-index: 1; font-weight: 800">
                <span
                  style="
                    font-size: 22px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  >退出</span
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span data-track-text="个人中心" aria-label="个人中心" @click="toCenter">
            <img
              v-if="userType === '0'"
              class="user-img"
              src="../assets/img/person_no.png"
              alt=""
            />
            <img
              v-if="userType === '1'"
              class="user-img"
              src="../assets/img/child_no.png"
              alt=""
            />
            <img
              v-if="userType === '2'"
              class="user-img"
              src="../assets/img/roaming_no.png"
              alt=""
            />
          </span>
        </div>
        <div data-track-text="登录" aria-label="登录"
          v-if="groupUserInfo === '机构登录'"
          class="login"
          @click="toPath('/h5/login')"
        >
          <span>机构登录</span>
        </div>
        <div
          v-if="groupUserInfo !== '机构登录'"
          style="
            overflow-x: hidden;
            text-overflow: ellipsis;
            width: 130px;
            white-space: nowrap;
          "
          class="login"
        >
          <el-dropdown
            @command="logOut"
            v-if="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
            style="
              display: flex;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              background: #f5f5f5;
            "
          >
            <span
              v-show="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
              style="
                overflow-x: hidden;
                text-overflow: ellipsis;
                width: 130px;
                white-space: nowrap;
              "
              class="title_hide"
              >{{ groupUserInfo }}</span
            >
            <el-dropdown-menu
              v-if="groupUserInfo !== '' && groupUserInfo !== '机构登录'"
              slot="dropdown"
            >
              <el-dropdown-item
                v-for="(item, index) in groupUserInfos"
                :key="index"
                :command="item.name"
                style="z-index: 1; font-weight: 800"
              >
                <span
                  style="
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  >{{ item.name }}</span
                >
                <span
                  style="
                    margin-left: 10px;
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                  "
                  v-if="!item.isIpScore"
                  >退出</span
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div
          class="select"
          style="
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #333333;
          "
        ></div>
        <div class="select">
          <div @click="showSelect = !showSelect" class="select-option" data-track-text="展开导航菜单" aria-label="展开导航菜单">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        <div v-show="showSelect" class="selected">
          <div data-track-text="首页" aria-label="首页" @click="toPath('/index')">首页</div>
          <div data-track-text="立即翻译" aria-label="立即翻译" @click="toPath('/translate')">立即翻译</div>
          <div data-track-text="人工翻译" aria-label="人工翻译" @click="toPath('/trans-pro')" v-if="isShowTransPro">
            人工翻译
          </div>
          <div data-track-text="PDF转换" aria-label="PDF转换" @click="toPath('/convert')">PDF转换</div>
          <div data-track-text="历史文档" aria-label="历史文档" @click="toPath('/list')">历史文档</div>
        </div>
      </div>
      <div class="list-main">
        <div class="trans-header">
          <div class="trans-header-select">
            <div
              class="check-tab-default"
              :class="activeTabClassAll"
              data-track-text="全部文档"
              aria-label="全部文档"
              @click="handleClickH5('all')"
              style="flex: 0.5"
            >
              全部
            </div>
            <div
              class="check-tab-default"
              :class="activeTabClassFirst"
              data-track-text="机器翻译文档"
              aria-label="机器翻译文档"
              @click="handleClickH5('first')"
            >
              机器翻译
            </div>
            <div
              class="check-tab-default"
              :class="activeTabClassFour"
              data-track-text="专业翻译文档"
              aria-label="专业翻译文档"
              @click="handleClickH5('four')"
            >
              专业翻译
            </div>
            <div
              class="check-tab-default"
              :class="activeTabClassThree"
              data-track-text="英语母语润色文档"
              aria-label="英语母语润色文档"
              @click="handleClickH5('three')"
              style="flex: 1.5"
            >
              英语母语润色翻译
            </div>
            <div
              class="check-tab-default"
              :class="activeTabClassSecond"
              data-track-text="转换文档"
              aria-label="转换文档"
              @click="handleClickH5('second')"
            >
              转换文档
            </div>
          </div>
        </div>
        <el-alert v-show="hasH5 && h5Message !== ''" type="success" center>
          <template slot="title">
            <span
              style="
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #4dbe92;
              "
              >{{ h5Message }}</span
            >
          </template>
        </el-alert>
        <el-alert v-show="hasH5 && h5ErrorMessage !== ''" type="error" center>
          <template slot="title">
            <span
              style="
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
              "
              >{{ h5ErrorMessage }}</span
            >
          </template>
        </el-alert>
        <div class="trans-list-context">
          <div class="list-context">
            <div v-show="activeName === 'all'" class="filelist-domain">
              <div class="list-context-search">
                <div class="list-context-search-input">
                  <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName"
                  >
                  </el-input>
                </div>
                <div class="list-context-search-select">
                  <el-select
                    popper-class="fileStatus"
                    v-model="statusList"
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <ul
                class="infinite-list"
                v-infinite-scroll="loadH5"
                infinite-scroll-disabled="disabled"
                style="overflow: auto"
              >
                <li v-for="item in allTableData" class="infinite-list-item">
                  <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click"
                  >
                    <div
                      style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                        width: 375px;
                        margin-top: 23px;
                        height: 120px;
                        background: var(--primary);
                      "
                    >
                      <div
                        v-show="
                          item.status === '待支付' || item.status === '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
	                        <img
	                          @click="payH5(item)"
	                          data-track-text="H5支付订单"
	                          aria-label="H5支付订单"
	                          src="../assets/H5/支付.png"
                          width="48"
                          alt="支付"
                        />
                      </div>
                      <div
                        v-show="item.uploadType === 3 || item.uploadType === 2"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="toDetail(item.id)"
                          data-track-text="查看详情"
                          aria-label="查看详情"
                          src="../assets/H5/detail-h5.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          (item.uploadType === 3 || item.uploadType === 2) &&
                          item.status !== '394' &&
                          item.status === '431'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? toPathH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          src="../assets/H5/list-time.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.uploadType === 0 ||
                          item.uploadType === 2 ||
                          item.uploadType === 3
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.uploadType === 0 ||
                              item.uploadType === 2 ||
                              item.uploadType === 3) &&
                            (item.status === '已翻译' ||
                              item.status === '已下载' ||
                              item.status === '396' ||
                              item.status === '502')
                              ? readingFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.uploadType === 0 ||
                              item.uploadType === 2 ||
                              item.uploadType === 3) &&
                            (item.status === '已翻译' ||
                              item.status === '已下载' ||
                              item.status === '396' ||
                              item.status === '502')
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="阅读文档"
                          aria-label="阅读文档"
                          src="../assets/H5/list-read.png"
                          width="54"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.status !== '待支付' && item.status !== '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? sendMail(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="发送邮件"
                          aria-label="发送邮件"
                          src="../assets/H5/mail.png"
                          width="55"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? item.uploadType === 1
                                ? downloadConvertFileH5(item)
                                : downloadFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="下载文档"
                          aria-label="下载文档"
                          src="../assets/H5/list-del.png"
                          width="40"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? deleteFileH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="删除文档"
                          aria-label="删除文档"
                          src="../assets/H5/liet-down.png"
                          width="48"
                          alt=""
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div style="margin-top: 20px" class="item">
                        <div
                          :class="
                            item.status === '翻译中' || item.status === '转换中'
                              ? 'item-trans'
                              : item.status === '已翻译' ||
                                item.status === '已转换' ||
                                item.status === '396'
                              ? 'item-status'
                              : 'item-other'
                          "
                        >
                          {{
                            item.status === "394"
                              ? "待支付"
                              : item.status === "431"
                              ? "待沟通"
                              : item.status === "395"
                              ? "待处理"
                              : item.status === "396"
                              ? "已完成"
                              : item.status === "502"
                              ? "已下载"
                              : item.status === "501"
                              ? "已删除"
                              : item.status === "500"
                              ? "已过期"
                              : item.status === "448"
                              ? "任务终止,退款中"
                              : item.status === "翻译中" &&
                                item.uploadType === 1
                              ? "转换中"
                              : item.status
                          }}
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="item-language">
                          翻译语言：{{ item.language }}
                        </div>
                        <div class="item-comment">
                          翻译需求：{{ item.comment }}
                        </div>
                        <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                      </div>
                    </div>
                  </el-popover>
                </li>
              </ul>
              <p v-if="loading">加载中...</p>
              <p
                v-if="noMore"
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                "
              >
                没有更多了
              </p>
            </div>
            <div v-show="activeName === 'first'" class="filelist-domain">
              <div class="list-context-search">
                <div class="list-context-search-input">
                  <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName"
                  >
                  </el-input>
                </div>
                <div class="list-context-search-select">
                  <el-select
                    popper-class="fileStatus"
                    v-model="statusList"
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <ul
                class="infinite-list"
                v-infinite-scroll="loadFirstH5"
                infinite-scroll-disabled="disabled"
                style="overflow: auto"
              >
                <li v-for="item in tableData" class="infinite-list-item">
                  <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click"
                  >
                    <div
                      style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                        width: 375px;
                        margin-top: 23px;
                        height: 120px;
                        background: var(--primary);
                      "
                    >
                      <div
                        v-show="
                          item.status === '待支付' || item.status === '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
	                        <img
	                          @click="payH5(item)"
	                          data-track-text="H5支付订单"
	                          aria-label="H5支付订单"
	                          src="../assets/H5/支付.png"
                          width="48"
                          alt="支付"
                        />
                      </div>
                      <div
                        v-show="
                          (item.uploadType === 3 || item.uploadType === 2) &&
                          item.status !== '394' &&
                          item.status === '431'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? toPathH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          src="../assets/H5/list-time.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' || item.status === '已下载'
                              ? readingFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' || item.status === '已下载'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="阅读文档"
                          aria-label="阅读文档"
                          src="../assets/H5/list-read.png"
                          width="54"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.status !== '待支付' && item.status !== '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? sendMail(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="发送邮件"
                          aria-label="发送邮件"
                          src="../assets/H5/mail.png"
                          width="55"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? downloadFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="下载文档"
                          aria-label="下载文档"
                          src="../assets/H5/list-del.png"
                          width="40"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.status !== '394' && item.status === '431') ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? deleteFileH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.status !== '394' && item.status === '431') ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="删除文档"
                          aria-label="删除文档"
                          src="../assets/H5/liet-down.png"
                          width="48"
                          alt=""
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div style="margin-top: 20px" class="item">
                        <div
                          :class="
                            item.status === '翻译中' || item.status === '转换中'
                              ? 'item-trans'
                              : item.status === '已翻译' ||
                                item.status === '已转换' ||
                                item.status === '396'
                              ? 'item-status'
                              : 'item-other'
                          "
                        >
                          {{
                            item.status === "394"
                              ? "待支付"
                              : item.status === "431"
                              ? "待沟通"
                              : item.status === "395"
                              ? "待处理"
                              : item.status === "396"
                              ? "已完成"
                              : item.status === "502"
                              ? "已下载"
                              : item.status === "501"
                              ? "已删除"
                              : item.status === "500"
                              ? "已过期"
                              : item.status === "448"
                              ? "任务终止,退款中"
                              : item.status
                          }}
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="item-language">
                          翻译语言：{{ item.language }}
                        </div>
                        <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                      </div>
                    </div>
                  </el-popover>
                </li>
              </ul>
              <p v-if="loadingFirst">加载中...</p>
              <p
                v-if="noMoreFirst"
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                "
              >
                没有更多了
              </p>
            </div>
            <div v-show="activeName === 'second'" class="filelist-domain">
              <div class="list-context-search">
                <div class="list-context-search-input">
                  <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName"
                  >
                  </el-input>
                </div>
                <div class="list-context-search-select">
                  <el-select
                    popper-class="fileStatus"
                    v-model="statusList"
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <ul
                class="infinite-list"
                v-infinite-scroll="loadSecondH5"
                infinite-scroll-disabled="disabled"
                style="overflow: auto"
              >
                <li v-for="item in convertTableData" class="infinite-list-item">
                  <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click"
                  >
                    <div
                      style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                        width: 375px;
                        margin-top: 23px;
                        height: 120px;
                        background: var(--primary);
                      "
                    >
                      <div
                        v-show="
                          item.status === '待支付' || item.status === '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
	                        <img
	                          @click="payH5(item)"
	                          data-track-text="H5支付订单"
	                          aria-label="H5支付订单"
	                          src="../assets/H5/支付.png"
                          width="48"
                          alt="支付"
                        />
                      </div>
                      <div
                        v-show="
                          (item.uploadType === 3 || item.uploadType === 2) &&
                          item.status !== '394' &&
                          item.status === '431'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? toPathH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.uploadType === 3 || item.uploadType === 2) &&
                            item.status !== '394' &&
                            item.status === '431'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          src="../assets/H5/list-time.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.uploadType === 0 &&
                          (item.status === '已翻译' || item.status === '已下载')
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.uploadType === 0 &&
                            (item.status === '已翻译' ||
                              item.status === '已下载')
                              ? readingFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.uploadType === 0 &&
                            (item.status === '已翻译' ||
                              item.status === '已下载')
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="阅读文档"
                          aria-label="阅读文档"
                          src="../assets/H5/list-read.png"
                          width="54"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.status !== '待支付' && item.status !== '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? sendMail(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="发送邮件"
                          aria-label="发送邮件"
                          src="../assets/H5/mail.png"
                          width="55"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? downloadConvertFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="下载文档"
                          aria-label="下载文档"
                          src="../assets/H5/list-del.png"
                          width="40"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            (item.status !== '394' && item.status === '431') ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? deleteFileH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            (item.status !== '394' && item.status === '431') ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="删除文档"
                          aria-label="删除文档"
                          src="../assets/H5/liet-down.png"
                          width="48"
                          alt=""
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div style="margin-top: 20px" class="item">
                        <div
                          :class="
                            item.status === '翻译中' || item.status === '转换中'
                              ? 'item-trans'
                              : item.status === '已翻译' ||
                                item.status === '已转换' ||
                                item.status === '396'
                              ? 'item-status'
                              : 'item-other'
                          "
                        >
                          {{
                            item.status === "394"
                              ? "待支付"
                              : item.status === "431"
                              ? "待沟通"
                              : item.status === "395"
                              ? "待处理"
                              : item.status === "396"
                              ? "已完成"
                              : item.status === "502"
                              ? "已下载"
                              : item.status === "501"
                              ? "已删除"
                              : item.status === "500"
                              ? "已过期"
                              : item.status === "448"
                              ? "任务终止,退款中"
                              : item.status
                          }}
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="item-language">
                          翻译语言：{{ item.language }}
                        </div>
                        <div class="item-pageNum">页数：{{ item.pageNum }}</div>
                      </div>
                    </div>
                  </el-popover>
                </li>
              </ul>
              <p v-if="loadingSecond">加载中...</p>
              <p
                v-if="noMoreSecond"
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                "
              >
                没有更多了
              </p>
            </div>
            <div v-show="activeName === 'three'" class="filelist-domain">
              <div class="list-context-search">
                <div class="list-context-search-input">
                  <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName"
                  >
                  </el-input>
                </div>
                <div class="list-context-search-select">
                  <el-select
                    popper-class="fileStatus"
                    v-model="statusList"
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <ul
                class="infinite-list"
                v-infinite-scroll="loadThreeH5"
                infinite-scroll-disabled="disabled"
                style="overflow: auto"
              >
                <li v-for="item in polishTableData" class="infinite-list-item">
                  <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click"
                  >
                    <div
                      style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                        width: 375px;
                        margin-top: 23px;
                        height: 120px;
                        background: var(--primary);
                      "
                    >
                      <div
                        v-show="
                          item.status === '待支付' || item.status === '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
	                        <img
	                          @click="payH5(item)"
	                          data-track-text="H5支付订单"
	                          aria-label="H5支付订单"
	                          src="../assets/H5/支付.png"
                          width="48"
                          alt="支付"
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="toDetail(item.id)"
                          data-track-text="查看详情"
                          aria-label="查看详情"
                          src="../assets/H5/detail-h5.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="item.status !== '394' && item.status === '431'"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status !== '394' && item.status === '431'
                              ? toPathH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status !== '394' && item.status === '431'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          src="../assets/H5/list-time.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? readingFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="阅读文档"
                          aria-label="阅读文档"
                          src="../assets/H5/list-read.png"
                          width="54"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.status !== '待支付' && item.status !== '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? sendMail(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="发送邮件"
                          aria-label="发送邮件"
                          src="../assets/H5/mail.png"
                          width="55"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? item.uploadType === 1
                                ? downloadConvertFileH5(item)
                                : downloadFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="下载文档"
                          aria-label="下载文档"
                          src="../assets/H5/list-del.png"
                          width="40"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '394' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? deleteFileH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '394' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="删除文档"
                          aria-label="删除文档"
                          src="../assets/H5/liet-down.png"
                          width="48"
                          alt=""
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div style="margin-top: 20px" class="item">
                        <div
                          :class="
                            item.status === '翻译中' || item.status === '转换中'
                              ? 'item-trans'
                              : item.status === '已翻译' ||
                                item.status === '已转换' ||
                                item.status === '396'
                              ? 'item-status'
                              : 'item-other'
                          "
                        >
                          {{
                            item.status === "394"
                              ? "待支付"
                              : item.status === "431"
                              ? "待沟通"
                              : item.status === "395"
                              ? "待处理"
                              : item.status === "396"
                              ? "已完成"
                              : item.status === "502"
                              ? "已下载"
                              : item.status === "501"
                              ? "已删除"
                              : item.status === "500"
                              ? "已过期"
                              : item.status === "448"
                              ? "任务终止,退款中"
                              : item.status
                          }}
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="item-language">
                          翻译语言：{{ item.language }}
                        </div>
                        <div
                          class="item-comment"
                          style="
                            flex: 3;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                        >
                          翻译需求：{{ item.comment }}
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </li>
              </ul>
              <p v-if="loadingThree">加载中...</p>
              <p
                v-if="noMoreThree"
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                "
              >
                没有更多了
              </p>
            </div>
            <div v-show="activeName === 'four'" class="filelist-domain">
              <div class="list-context-search">
                <div class="list-context-search-input">
                  <el-input
                    placeholder="文件名"
                    suffix-icon="el-icon-search"
                    v-model="fileName"
                  >
                  </el-input>
                </div>
                <div class="list-context-search-select">
                  <el-select
                    popper-class="fileStatus"
                    v-model="statusList"
                    placeholder="状态"
                  >
                    <el-option
                      v-for="item in fileStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <ul
                class="infinite-list"
                v-infinite-scroll="loadFourH5"
                infinite-scroll-disabled="disabled"
                style="overflow: auto"
              >
                <li v-for="item in docTableData" class="infinite-list-item">
                  <el-popover
                    :visible-arrow="false"
                    popper-class="popper-class"
                    placement="right"
                    trigger="click"
                  >
                    <div
                      style="
                        align-items: center;
                        justify-content: center;
                        display: flex;
                        width: 375px;
                        margin-top: 23px;
                        height: 120px;
                        background: var(--primary);
                      "
                    >
                      <div
                        v-show="
                          item.status === '待支付' || item.status === '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
	                        <img
	                          @click="payH5(item)"
	                          data-track-text="H5支付订单"
	                          aria-label="H5支付订单"
	                          src="../assets/H5/支付.png"
                          width="48"
                          alt="支付"
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="toDetail(item.id)"
                          data-track-text="查看详情"
                          aria-label="查看详情"
                          src="../assets/H5/detail-h5.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="item.status === '431'"
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '431'
                              ? toPathH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="item.status === '431' ? '' : 'opacity: 0.5;'"
                          data-track-text="继续支付"
                          aria-label="继续支付"
                          src="../assets/H5/list-time.png"
                          width="48"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? readingFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="阅读文档"
                          aria-label="阅读文档"
                          src="../assets/H5/list-read.png"
                          width="54"
                          alt=""
                        />
                      </div>
                      <div
                        v-show="
                          item.status !== '待支付' && item.status !== '394'
                        "
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? sendMail(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="发送邮件"
                          aria-label="发送邮件"
                          src="../assets/H5/mail.png"
                          width="55"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? item.uploadType === 1
                                ? downloadConvertFileH5(item)
                                : downloadFileH5(item)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="下载文档"
                          aria-label="下载文档"
                          src="../assets/H5/list-del.png"
                          width="40"
                          alt=""
                        />
                      </div>
                      <div
                        style="
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          flex: 1;
                        "
                      >
                        <img
                          @click="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '394' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? deleteFileH5(item.id)
                              : 'javascript:void(0)'
                          "
                          :style="
                            item.status === '431' ||
                            item.status === '待支付' ||
                            item.status === '已翻译' ||
                            item.status === '已下载' ||
                            item.status === '已转换' ||
                            item.status === '394' ||
                            item.status === '396' ||
                            item.status === '502'
                              ? ''
                              : 'opacity: 0.5;'
                          "
                          data-track-text="删除文档"
                          aria-label="删除文档"
                          src="../assets/H5/liet-down.png"
                          width="48"
                          alt=""
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div style="margin-top: 20px" class="item">
                        <div
                          :class="
                            item.status === '翻译中' || item.status === '转换中'
                              ? 'item-trans'
                              : item.status === '已翻译' ||
                                item.status === '已转换' ||
                                item.status === '396'
                              ? 'item-status'
                              : 'item-other'
                          "
                        >
                          {{
                            item.status === "394"
                              ? "待支付"
                              : item.status === "431"
                              ? "待沟通"
                              : item.status === "395"
                              ? "待处理"
                              : item.status === "396"
                              ? "已完成"
                              : item.status === "502"
                              ? "已下载"
                              : item.status === "501"
                              ? "已删除"
                              : item.status === "500"
                              ? "已过期"
                              : item.status === "448"
                              ? "任务终止,退款中"
                              : item.status
                          }}
                        </div>
                        <div class="item-name">{{ item.name }}</div>
                      </div>
                      <div class="item">
                        <div class="item-language">
                          翻译语言：{{ item.language }}
                        </div>
                        <div
                          class="item-comment"
                          style="
                            flex: 2;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                          "
                        >
                          翻译需求：{{ item.comment }}
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </li>
              </ul>
              <p v-if="loadingFour">加载中...</p>
              <p
                v-if="noMoreFour"
                style="
                  font-size: 24px;
                  font-family: Source Han Sans CN;
                  font-weight: 400;
                  color: #333333;
                "
              >
                没有更多了
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="main-foot" style="flex-flow: column">
        <div>
          © 2020 北京容智科技发展有限公司 京ICP备19036872号-3 All rights
          reserved. 京公网安备 11011402010815号
        </div>
        <div style="margin-top: 10px">
          <a href="mailto:info@wiseivy.com.cn?subject=微思翻译咨询"
            >联系邮箱：info@wiseivy.com.cn</a
          >
          <span style="margin-left: 15px">联系电话：010-80755328</span>
        </div>
      </div>
    </div>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="centerDialogVisible"
      width="555px"
      center
    >
      <div :class="downloadClass">
        <div
          v-show="isDownload"
          style="
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            width: 375px;
            margin-bottom: 20px;
          "
        >
          译文下载
        </div>
        <div
          v-show="isDownload"
          style="display: flex; align-items: center; justify-content: center"
        >
          <div class="down-type">
            <img
              src="../assets/doc.png"
              alt=""
              data-track-text="选择DOC格式"
              aria-label="选择DOC格式"
              style="width: 54px; height: 68px"
              @click="radio = 'doc'"
            />
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0; margin-top: 25px">doc</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/docx.png"
              alt=""
              data-track-text="选择DOCX格式"
              aria-label="选择DOCX格式"
              style="width: 54px; height: 68px"
              @click="radio = 'docx'"
            />
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="line-height: 0; margin-top: 25px">docx</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/pdf.png"
              alt=""
              data-track-text="选择PDF格式"
              aria-label="选择PDF格式"
              style="width: 54px; height: 68px"
              @click="radio = 'pdf'"
            />
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="line-height: 0; margin-top: 25px">pdf</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/txt.png"
              alt=""
              data-track-text="选择TXT格式"
              aria-label="选择TXT格式"
              style="width: 54px; height: 68px"
              @click="radio = 'txt'"
            />
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="line-height: 0; margin-top: 25px">txt</div>
          </div>
        </div>
        <div
          v-show="isDownload"
          style="
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            width: 375px;
            margin-bottom: 20px;
            margin-top: 50px;
          "
        >
          双语对照下载
        </div>
        <div
          v-show="isDownload"
          style="
            width: 420px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          "
        >
          <div class="down-type">
            <img
              src="../assets/docx.png"
              alt=""
              data-track-text="选择原文批注DOCX"
              aria-label="选择原文批注DOCX"
              style="width: 54px; height: 68px"
              @click="radio = 'commentsone'"
            />
            <el-radio v-model="radio" label="commentsone"></el-radio>
            <div style="line-height: 0; margin-top: 25px">原文做批注</div>
          </div>
          <div class="down-type" style="margin-left: 8px">
            <img
              src="../assets/docx.png"
              alt=""
              data-track-text="选择译文批注DOCX"
              aria-label="选择译文批注DOCX"
              style="width: 54px; height: 68px"
              @click="radio = 'commentstwo'"
            />
            <el-radio v-model="radio" label="commentstwo"></el-radio>
            <div style="line-height: 0; margin-top: 25px">译文做批注</div>
          </div>
        </div>
        <div
          v-show="isDownload"
          style="
            position: absolute;
            left: 50%;
            top: 85%;
            transform: translate(-50%, 0px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载文档"
            aria-label="确认下载文档"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载文档"
            aria-label="取消下载文档"
            @click="centerDialogVisible = false"
            >取 消
          </el-button>
        </div>
        <div v-show="!isDownload" style="text-align: center; width: 495px">
          <div style="line-height: 0">
            <img
              src="../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="centerDialogVisiblePro"
      width="555px"
      center
    >
      <div :class="downloadClass" style="height: 270px">
        <div
          v-show="isDownload"
          style="
            text-align: left;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #666666;
            width: 375px;
            margin-bottom: 40px;
          "
        >
          译文下载
        </div>
        <div
          v-show="isDownload"
          style="display: flex; align-items: center; justify-content: center"
        >
          <div class="down-type">
            <img
              src="../assets/doc.png"
              alt=""
              data-track-text="选择DOC格式"
              aria-label="选择DOC格式"
              style="width: 54px; height: 68px"
              @click="radio = 'doc'"
            />
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="line-height: 0; margin-top: 25px">doc</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/docx.png"
              alt=""
              data-track-text="选择DOCX格式"
              aria-label="选择DOCX格式"
              style="width: 54px; height: 68px"
              @click="radio = 'docx'"
            />
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="line-height: 0; margin-top: 25px">docx</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/pdf.png"
              alt=""
              data-track-text="选择PDF格式"
              aria-label="选择PDF格式"
              style="width: 54px; height: 68px"
              @click="radio = 'pdf'"
            />
            <el-radio v-model="radio" label="pdf"></el-radio>
            <div style="line-height: 0; margin-top: 25px">pdf</div>
          </div>
          <div class="down-type">
            <img
              src="../assets/txt.png"
              alt=""
              data-track-text="选择TXT格式"
              aria-label="选择TXT格式"
              style="width: 54px; height: 68px"
              @click="radio = 'txt'"
            />
            <el-radio v-model="radio" label="txt"></el-radio>
            <div style="line-height: 0; margin-top: 25px">txt</div>
          </div>
        </div>
        <div
          v-show="isDownload"
          style="
            position: absolute;
            left: 50%;
            top: 85%;
            transform: translate(-50%, -15px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载专业文档"
            aria-label="确认下载专业文档"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载专业文档"
            aria-label="取消下载专业文档"
            @click="centerDialogVisiblePro = false"
            >取 消
          </el-button>
        </div>
        <div v-show="!isDownload" style="text-align: center; width: 495px">
          <div style="line-height: 0">
            <img
              src="../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="excelDialogVisible"
      width="555px"
      center
    >
      <div :class="downloadClass">
        <div v-show="isDownload" style="margin: 20px 69.5px">
          <div class="down-type2">
            <img
              src="../assets/txt.png"
              alt=""
              data-track-text="选择XLS格式"
              aria-label="选择XLS格式"
              style="width: 54px; height: 68px"
              @click="radio !== 'xls' ? (radio = 'xlsx') : (radio = 'xls')"
            />
            <el-radio
              v-model="radio"
              label="xls"
              :disabled="radio !== 'xls'"
            ></el-radio>
            <div style="line-height: 0; margin-top: 25px">xls</div>
          </div>
          <div class="down-type2" :disabled="radio !== 'xlsx'">
            <img
              src="../assets/txt.png"
              alt=""
              data-track-text="选择XLSX格式"
              aria-label="选择XLSX格式"
              style="width: 54px; height: 68px"
              @click="radio !== 'xlsx' ? (radio = 'lsx') : (radio = 'xlsx')"
            />
            <el-radio
              v-model="radio"
              label="xlsx"
              :disabled="radio !== 'xlsx'"
            ></el-radio>
            <div style="line-height: 0; margin-top: 25px">xlsx</div>
          </div>
        </div>
        <div
          v-show="isDownload"
          style="
            position: absolute;
            left: 50%;
            top: 78%;
            transform: translate(-50%, 0px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载表格"
            aria-label="确认下载表格"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载表格"
            aria-label="取消下载表格"
            @click="excelDialogVisible = false"
            >取 消
          </el-button>
        </div>
        <div v-show="!isDownload">
          <div style="line-height: 0">
            <img
              src="../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test2"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="downloadTitle"
      :visible.sync="excelDialogVisibleConvert"
      width="555px"
      center
    >
      <div :class="downloadClass">
        <div
          v-show="isDownload"
          style="
            margin: 20px 50px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          <div class="down-type2">
            <img
              src="../assets/doc.png"
              alt=""
              data-track-text="选择DOC格式"
              aria-label="选择DOC格式"
              style="width: 54px; height: 68px"
              @click="radio = 'doc'"
            />
            <el-radio v-model="radio" label="doc"></el-radio>
            <div style="text-align: center; margin-top: 20px; line-height: 0">
              doc
            </div>
          </div>
          <div class="down-type2" :disabled="radio !== 'docx'">
            <img
              src="../assets/docx.png"
              alt=""
              data-track-text="选择DOCX格式"
              aria-label="选择DOCX格式"
              style="width: 54px; height: 68px"
              @click="radio = 'docx'"
            />
            <el-radio v-model="radio" label="docx"></el-radio>
            <div style="line-height: 0; text-align: center; margin-top: 20px">
              docx
            </div>
          </div>
        </div>
        <div
          v-show="isDownload"
          style="
            position: absolute;
            left: 50%;
            top: 78%;
            transform: translate(-50%, 0px);
          "
        >
          <el-button
            class="el-button--primarys"
            type="primary"
            data-track-text="确认下载转换文档"
            aria-label="确认下载转换文档"
            style="margin-right: 11px"
            :loading="downloadDocLoad"
            @click="downloadConvertDoc"
            >下 载
          </el-button>
          <el-button
            class="el-button--defaults"
            data-track-text="取消下载转换文档"
            aria-label="取消下载转换文档"
            @click="excelDialogVisibleConvert = false"
            >取 消
          </el-button>
        </div>
        <div v-show="!isDownload">
          <div
            style="
              line-height: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <img
              src="../assets/downloadjindu.png"
              alt=""
              style="height: 166px; width: 330px"
            />
          </div>
          <div
            style="
              width: 360px;
              height: 48px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgb(52, 52, 52);
              line-height: 30px;
              margin-left: 50%;
              transform: translate(-50%, 0px);
              margin-bottom: 42px;
              ext-align: center;
            "
          >
            <span>{{ downloadMessage }}</span>
          </div>
          <div
            style="position: absolute; left: 50%; transform: translate(-50%, 0)"
          >
            <el-progress
              :color="customColorDownload"
              style="width: 395px"
              id="test3"
              :text-inside="true"
              :stroke-width="28"
              :percentage="downloadPercentage"
            ></el-progress>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      class="payClass"
    >
      <div slot="title" class="dialog-title">
        <span v-if="checkType === 'all'" class="fanyiyuyan">翻译语言：</span>
        <span v-if="checkType === 'first'" class="fanyiyuyan">翻译语言：</span>
        <span v-if="checkType === 'second'" class="fanyiyuyan">转换类型：</span>
        <div style="display: inline; float: left; line-height: 45px">
          <el-form>
            {{ to }}
          </el-form>
        </div>
      </div>
      <el-table
        :data="gridData"
        :header-cell-style="{
          background: '#d3dee8',
          'line-height': '30px',
          height: '23px',
          'text-align': 'center',
          'font-size': '14px',
          color: '#333333',
        }"
      >
        <el-table-column
          type="index"
          property="id"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          property="title"
          label="题名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="page"
          label="校验页数"
          width="100"
          align="center"
        ></el-table-column>
        <el-table-column
          property="money"
          label="金额（元）"
          width="100"
          align="center"
          v-if="isShowMoney"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div
          style="
            line-height: 40px;
            float: left;
            font-size: 14px;
            font-family: Noto Sans S Chinese;
            font-weight: 400;
            color: #333333;
            width: 80%;
          "
        >
          <div style="float: left">
            总计：<span>{{ pages }}</span
            >页
          </div>
          <div style="float: right" v-if="isShowMoney">
            <span style="padding-right: 15px"
              >总价：￥{{ NumFilter(orderMoney) }}</span
            >
            <span style="padding-right: 15px"
              >优惠：
              <span style="color: #e13f3f">{{
                NumberSub(orderMoney, moneys)
              }}</span>
            </span>
            <span style="padding-right: 15px"
              >实付：
              <span style="color: #e13f3f; font-size: 18px"
                >￥{{ NumFilter(moneys) }}</span
              >
            </span>
          </div>
        </div>
        <el-button
          v-if="!isShowFree"
          type="primary"
          data-track-text="确认提交订单"
          aria-label="确认提交订单"
          @click="submitPay"
          class="okTranslate"
        >
          <span
            v-if="
              checkType === 'first' || (checkType === 'all' && uploadType === 0)
            "
            >确认翻译</span
          >
          <span
            v-if="
              checkType === 'second' ||
              (checkType === 'all' && uploadType === 1)
            "
            >确认转换</span
          >
        </el-button>
        <el-button
          v-if="isShowFree"
          type="primary"
          data-track-text="免费提交订单"
          aria-label="免费提交订单"
          @click="submitPay"
          class="okTranslate"
        >
          <span
            v-if="
              checkType === 'first' || (checkType === 'all' && uploadType === 0)
            "
            >免费翻译</span
          >
          <span
            v-if="
              checkType === 'second' ||
              (checkType === 'all' && uploadType === 1)
            "
            >免费转换</span
          >
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="proTableVisible"
      :close-on-click-modal="false"
      class="payClass"
    >
      <div slot="title" class="dialog-title">
        <span class="fanyiyuyan">翻译语言：</span>
        <div style="display: inline; float: left; line-height: 45px">
          <el-form>
            {{ to }}
          </el-form>
        </div>
      </div>
      <el-table
        :data="proGridData"
        :header-cell-style="{
          background: '#d3dee8',
          'line-height': '30px',
          height: '23px',
          'text-align': 'center',
          'font-size': '14px',
          color: '#333333',
        }"
      >
        <el-table-column
          type="index"
          property="id"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>
        <el-table-column
          property="title"
          label="题名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          property="money"
          label="金额（元）"
          width="100"
          align="center"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <div
          style="
            line-height: 40px;
            float: left;
            font-size: 14px;
            font-family: Noto Sans S Chinese;
            font-weight: 400;
            color: #333333;
            width: 80%;
          "
        >
          <div style="float: right">
            <span style="padding-right: 15px"
              >总价：￥{{ NumFilter(orderMoney) }}</span
            >
            <span style="padding-right: 15px"
              >实付：
              <span style="color: #e13f3f; font-size: 18px"
                >￥{{ NumFilter(moneys) }}</span
              >
            </span>
          </div>
        </div>
        <el-button type="primary" data-track-text="确认专业翻译支付" aria-label="确认专业翻译支付" @click="submitProPay" class="okTranslate">
          <span>确认翻译</span>
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { authServiceClient, translateServiceClient } from "@/tools/api/service";
import {
  outRequest,
  userPowerRequest,
  userStatusRequest,
} from "@/tools/api/auth-api";
import {
  checkRoamingRequest,
  deleteFileRequest,
  fileListRequest,
  FileListRequest,
  fileStatus,
  parentPowerRequest,
  payRequest,
  queryDocumentRequest,
  readDocumentRequest,
  readingFileRequest,
  statusRequest,
  submitConvertRequest,
  submitRequest,
  uploadTipRequest,
  sendEmailRequest,
} from "@/tools/api/translate-api";
import lanuages from "../../language.json";
import SiteHeader from "@/components/home/SiteHeader.vue";
import SiteFooter from "@/components/home/SiteFooter.vue";
import FloatingContactTools from "@/components/home/FloatingContactTools.vue";

export default {
  name: "ListPro",
  components: { SiteHeader, SiteFooter, FloatingContactTools },
  data() {
    return {
      allTableDataHas: false,
      tableDataHas: false,
      convertTableDataHas: false,
      polishTableDataHas: false,
      docTableDataHas: false,
      loading: false,
      loadingFirst: false,
      loadingSecond: false,
      loadingThree: false,
      loadingFour: false,
      showSelect: false,
      hasH5: false,
      h5Message: "",
      h5ErrorMessage: "",
      isShowTransPro: false,
      isShowInRoaming: false,
      userId: "",
      isRoamingTimer: undefined,
      isRoamingTimerOut: undefined,
      qrcodeUrl: "",
      showRoaming: false,
      activeTabClassAll: "",
      activeTabClassFirst: "",
      activeTabClassAi: "",
      activeTabClassSecond: "",
      activeTabClassThree: "",
      activeTabClassFour: "",
      groupUserInfos: [],
      userInfo: "",
      userType: "",
      iframeState: false,
      showloginOut: false,
      showHeader: true,
      groupUserInfo: "",
      title: "",
      activeName: "first",
      isShowMoney: false,
      isShowFree: false,
      from: "",
      to: "",
      moneys: 0,
      orderMoney: 0,
      pages: 0,
      gridData: [],
      proGridData: [],
      proTableVisible: false,
      dialogTableVisible: false,
      customColorDownload: "#1b5ea4 !important",
      downloadMessage: "下载大型文档或转换文档时，需等待时间较长请您耐心等待！",
      downloadClass: "downloadClass",
      downloadStatus: "",
      downloadPercentage: 0,
      isDownload: true,
      downloadTitle: "确定下载该文件的译文版本吗？",
      excelDialogVisibleConvert: false,
      deletevisible: false,
      customColor: "var(--primary) !important",
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      count: 0,
      currentAiPage: 1,
      pageAiSize: 10,
      countAi: 0,
      currentConvertPage: 1,
      pageConvertSize: 10,
      countConvert: 0,
      fileStatus: [
        { value: 0, label: "全部" },
        { value: 3, label: "已完成" },
        { value: 4, label: "已下载" },
      ],
      multipleSelection: [],
      tableData: [],
      transloading: false,
      aiLoading: false,
      convertloading: false,
      convertTableData: [],

      uploadType: 0,

      allTableData: [],
      allLoading: false,
      countAll: 0,
      currentAllPage: 1,
      pageAllSize: 10,

      docTableData: [],
      docLoading: false,
      countDoc: 0,
      currentDocPage: 1,
      pageDocSize: 10,

      polishTableData: [],
      polishLoading: false,
      countPolish: 0,
      currentPolishPage: 1,
      pagePolishSize: 10,

      statusList: "",
      fileName: "",
      content: "",
      radio: "pdf",
      centerDialogVisible: false,
      centerDialogVisiblePro: false,
      excelDialogVisible: false,
      downloadDocLoad: false,
      timer: "",
      timerConvert: "",
      downloadTimer: "",
      downloadId: "",
      checkType: "all",
      pendingPaymentType: "",
      mobileDeleteConfirmId: "",
      documentListRequestIds: {
        all: 0,
        first: 0,
        second: 0,
        three: 0,
        four: 0,
        ai: 0,
      },
      fullscreenLoadings: undefined,
      aiFileList: [],
      uploadTypeMap: {
        0: "机器翻译",
        1: "文档转换",
        2: "专业翻译",
        3: "母语润色",
        5: "AI翻译",
      },
    };
  },
  beforeCreate() {
    const that = this;
    window.addEventListener("message", function (e) {
      if (e.data.data === "params") {
        that.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
      }
      if (e.data.data === "register") {
        that.openTry();
      }
      if (e.data.data === "close") {
        layer.closeAll();
      }
      if (e.data.data === "topHidden") {
        that.showHeader = false;
      }
      if (e.data.data === "topNotHidden") {
        that.showHeader = true;
      }
    });
    const TOKEN_KEY = "token";
    authServiceClient
      .getUserStatus(userStatusRequest, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      })
      .then((res) => {
        if (!res.getStatus()) {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.userInfo = "";
          this.groupUserInfo = "";
          this.showRoaming = false;
          return;
        }
        const user = localStorage.getItem("auth-context");
        if (!user) {
          return;
        }
        const userJson = JSON.parse(user);
        const Base64 = require("js-base64").Base64;
        userJson.forEach((item) => {
          if (item.type === "Person" || item.type === "Child") {
            let realName = "";
            if (item.realName !== "" && item.realName !== undefined) {
              realName = Base64.decode(item.realName);
            } else {
              realName = item.name;
            }
            if (item.type === "Person") {
              this.userType = "0";
            }
            if (item.type === "Child") {
              this.userType = "1";
            }
            this.userInfo = realName;
            this.userId = item.name;
            if (!item.isRoaming) {
              let roaming = localStorage.getItem(this.userId);
              if (!roaming || roaming !== "1") {
                this.showRoaming = true;
              } else {
                this.showRoaming = false;
                this.userType = "2";
              }
            } else {
              this.userType = "2";
            }
            if (this.groupUserInfo === "") {
              this.groupUserInfo = "机构登录";
            }
            this.showloginOut = true;
          }
          if (item.type === "Group") {
            this.groupUserInfos.push(item);
            let realName = "";
            if (item.realName !== "" && item.realName !== undefined) {
              realName = Base64.decode(item.realName);
            } else {
              realName = item.name;
            }
            this.groupUserInfo = realName;
            this.url = process.env.VUE_APP_WEB_LOGIN_URL;
          }
        });
      })
      .catch((err) => {
        localStorage.removeItem("token");
        localStorage.removeItem("auth-context");
        this.userInfo = "";
        this.showRoaming = false;
      });
  },
  created() {
    let query = this.$route.query;
    let type = query?.type || "all";
    let name =
      type === "convert"
        ? "second"
        : type === "convert"
        ? "second"
        : type === "doc"
        ? "first"
        : type;
    this.hasH5 =
      /phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|webOS|android/i.test(
        navigator.userAgent
      );
    this.getUploadTip();
    const req = this.getUrlParameter(this.$route.fullPath).response;
    if (req !== undefined && req !== null && req !== "") {
      if (this.hasH5) {
        this.checkPayH5(req);
        this.handleClick(name);
        return;
      }
      this.checkPay(req);
      this.handleClick(name);
    }
    this.handleClick(name);
  },
  computed: {
    noMore() {
      return this.allTableDataHas;
    },
    disabled() {
      return this.loading || this.noMore;
    },
    noMoreFirst() {
      return this.tableDataHas;
    },
    disabledFirst() {
      return this.loadingFirst || this.noMoreFirst;
    },
    noMoreSecond() {
      return this.convertTableDataHas;
    },
    disabledSecond() {
      return this.loadingSecond || this.noMoreSecond;
    },
    noMoreThree() {
      return this.polishTableDataHas;
    },
    disabledThree() {
      return this.loadingThree || this.noMoreThree;
    },
    noMoreFour() {
      return this.docTableDataHas;
    },
    disabledFour() {
      return this.loadingFour || this.noMoreFour;
    },
    mobileDocumentRows() {
      const rowsByType = {
        all: this.allTableData,
        first: this.tableData,
        second: this.convertTableData,
        three: this.polishTableData,
        four: this.docTableData,
        ai: this.aiFileList,
      };
      return rowsByType[this.activeName] || [];
    },
    mobileDocumentLoading() {
      const loadingByType = {
        all: this.allLoading,
        first: this.transloading,
        second: this.convertloading,
        three: this.polishLoading,
        four: this.docLoading,
        ai: this.aiLoading,
      };
      return Boolean(loadingByType[this.activeName]);
    },
  },
  mounted() {
    /*if (this.hasH5) {
      this.timer = setInterval(this.RandomNumBothH5, 5000);
      this.timerConvert = setInterval(this.RandomNumBothConvertH5, 5000);
      return
    }
    debugger*/
    this.timer = setInterval(this.RandomNumBoth, 5000);
    this.timerConvert = setInterval(this.RandomNumBothConvert, 5000);
  },
  watch: {
    fileName() {
      this.requestDocumentFilter();
    },
    statusList() {
      this.requestDocumentFilter();
    },
    dialogTableVisible(val) {
      if (val) {
        let request = parentPowerRequest;
        request.setMoney(this.moneys);
        const TOKEN_KEY = "token";
        translateServiceClient
          .checkParentPower(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            this.isShowMoney = res.getShowmoney();
            if (this.isShowMoney && this.moneys === 0) {
              this.isShowFree = true;
            }
          })
          .catch((err) => {
            this.isShowMoney = true;
          });
      }
    },
  },
  methods: {
    gotoPage(type) {
      if (type === "text") {
        this.toPath("/translate", "txt");
      } else if (type === "doc") {
        this.toPath("/translate", "doc");
      } else if (type === "ai") {
        this.toPath("/translate", "AITranslate");
      } else if (type === "lange") {
        this.toPath("/translate", "more");
      } else if (type === "img") {
        this.toPath("/translate", "img");
      } else if (type === "polish") {
        this.toPath("/translate", "polish");
      } else if (type === "aiPPT") {
        this.toPath("/translate", "aiPPT");
      } else if (type === "rag") {
        this.toPath("/rag");
      } else if (type === "pro") {
        this.toPath("/trans-pro");
      }
    },
    mobileDocumentKind(row) {
      if (this.activeName === "all") {
        const uploadType = Number(row && row.uploadType);
        return Number.isNaN(uploadType) ? 0 : uploadType;
      }
      const kindByType = {
        first: 0,
        second: 1,
        four: 2,
        three: 3,
        ai: 5,
      };
      return kindByType[this.activeName] === undefined
        ? 0
        : kindByType[this.activeName];
    },
    mobileDocumentType(row) {
      return row.transType || this.uploadTypeMap[this.mobileDocumentKind(row)] || "翻译任务";
    },
    mobileDocumentStatus(row) {
      const status = String((row && row.status) || "");
      const statusLabels = {
        394: "待支付",
        395: "待处理",
        396: "已完成",
        431: "待沟通",
        448: "任务终止",
        500: "已过期",
        501: "已删除",
        502: "已下载",
      };
      if (statusLabels[status]) return statusLabels[status];
      if (status === "翻译中" && this.mobileDocumentKind(row) === 1) return "转换中";
      return status || "未知状态";
    },
    mobileDocumentStatusTone(row) {
      const status = this.mobileDocumentStatus(row);
      if (["已翻译", "已转换", "已完成", "已下载"].includes(status)) return "is-success";
      if (["翻译中", "转换中", "处理中", "排队中"].includes(status)) return "is-progress";
      if (["待支付", "待沟通", "待处理"].includes(status)) return "is-warning";
      if (status.includes("失败") || status === "任务终止") return "is-error";
      return "is-muted";
    },
    mobileDocumentIndex(index) {
      const currentPageByType = {
        all: this.currentAllPage,
        first: this.currentPage,
        second: this.currentConvertPage,
        three: this.currentPolishPage,
        four: this.currentDocPage,
        ai: this.currentAiPage,
      };
      const currentPage = currentPageByType[this.activeName] || 1;
      return (currentPage - 1) * 10 + index + 1;
    },
    mobileDocumentIsProgress(row) {
      return ["翻译中", "转换中", "处理中", "排队中"].includes(
        this.mobileDocumentStatus(row)
      );
    },
    mobileDocumentProgress(row) {
      const value = Number(row && row.numbers);
      if (!Number.isFinite(value) || value <= 0) return 5;
      return Math.max(1, Math.min(99, Math.round(value)));
    },
    mobileDocumentCanPay(row) {
      return ["待支付", "394"].includes(String(row.status));
    },
    mobileDocumentCanContinue(row) {
      return String(row.status) === "431";
    },
    mobileDocumentCanDetail(row) {
      const kind = this.mobileDocumentKind(row);
      return kind === 2 || kind === 3;
    },
    mobileDocumentCanRead(row) {
      return this.mobileDocumentKind(row) !== 1 && this.canReadDocument(row);
    },
    mobileDocumentCanDownload(row) {
      return Boolean(row.disables && !row.disables.disablesdown);
    },
    mobileDocumentCanMail(row) {
      return ["已翻译", "已转换", "已下载", "396", "502"].includes(
        String(row.status)
      );
    },
    mobileDocumentCanDelete(row) {
      const status = String(row.status);
      const kind = this.mobileDocumentKind(row);
      if (["待支付", "394", "431"].includes(status)) return true;
      if (kind === 2 || kind === 3) {
        return Boolean(row.disables && !row.disables.disablesdel);
      }
      return Boolean(row.disables && !row.disables.disablesdel);
    },
    mobileDocumentHasActions(row) {
      return (
        this.mobileDocumentCanPay(row) ||
        this.mobileDocumentCanContinue(row) ||
        this.mobileDocumentCanDetail(row) ||
        this.mobileDocumentCanRead(row) ||
        this.mobileDocumentCanDownload(row) ||
        this.mobileDocumentCanMail(row) ||
        this.mobileDocumentCanDelete(row)
      );
    },
    mobilePayDocument(row) {
      if (this.hasH5) {
        this.payH5(row);
        return;
      }
      this.pay(row);
    },
    mobileReadDocument(row) {
      if (this.hasH5) {
        this.readingFileH5(row);
        return;
      }
      this.readingFile(row);
    },
    isImagePreviewFile(name) {
      return /\.(?:jpe?g|png)$/i.test(String(name || "").trim());
    },
    canReadDocument(row) {
      if (!row) return false;
      if (this.isImagePreviewFile(row.name)) {
        return ["已翻译", "已下载", "396", "502"].includes(
          String(row.status)
        );
      }
      return Boolean(row.disables && !row.disables.disablesread);
    },
    openDocumentPreview(row) {
      if (this.isImagePreviewFile(row && row.name)) {
        const routeData = this.$router.resolve({
          name: "ImagePreview",
          params: { documentId: row.id },
        });
        if (this.hasH5) {
          this.$router.push(routeData.route.fullPath);
        } else {
          window.open(routeData.href, "_blank");
        }
        return;
      }
      if (this.hasH5) {
        this.$router.push({
          name: "NewRead",
          params: { documentId: row.id },
        });
        return;
      }
      const routeData = this.$router.resolve({
        name: "PdfPreview",
        params: { documentId: row.id },
      });
      window.open(routeData.href, "_blank");
    },
    mobileDownloadDocument(row) {
      const isConvert = this.mobileDocumentKind(row) === 1;
      if (this.hasH5) {
        if (isConvert) this.downloadConvertFileH5(row);
        else this.downloadFileH5(row);
        return;
      }
      if (isConvert) this.downloadConvertFile(row);
      else this.downloadFile(row);
    },
    mobileDeleteDocument(row) {
      this.mobileDeleteConfirmId = "";
      const deleteType = this.activeName;
      const deletePageRowCount = this.mobileDocumentRows.length;
      const request = deleteFileRequest;
      request.setId(row.id);
      const TOKEN_KEY = "token";
      translateServiceClient
        .deleteFile(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.getStatus()) {
            this.$message.error("删除失败");
            return;
          }
          this.$message.success("删除成功");
          this.moveDocumentPageBackAfterDelete(deleteType, deletePageRowCount);
          this.refreshMobileDocumentList(deleteType);
        })
        .catch((err) => {
          if (err && err.code === 5) {
            if (this.hasH5) this.$router.push("/h5/login");
            else {
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            }
            return;
          }
          this.$message.error("删除失败，请稍后再试");
        });
    },
    moveDocumentPageBackAfterDelete(type, pageRowCount) {
      if (pageRowCount !== 1) return;
      const pageKeyByType = {
        all: "currentAllPage",
        first: "currentPage",
        second: "currentConvertPage",
        three: "currentPolishPage",
        four: "currentDocPage",
        ai: "currentAiPage",
      };
      const pageKey = pageKeyByType[type];
      if (pageKey && this[pageKey] > 1) this[pageKey] -= 1;
    },
    refreshMobileDocumentList(type = this.activeName) {
      if (type === "all") this.handleAllCurrentChange(this.currentAllPage);
      else if (type === "first") this.handleCurrentChange(this.currentPage);
      else if (type === "second") this.handleConvertCurrentChange(this.currentConvertPage);
      else if (type === "three") this.handlePublishCurrentChange(this.currentPolishPage);
      else if (type === "four") this.handleDocCurrentChange(this.currentDocPage);
      else if (type === "ai") this.handleAiCurrentChange(this.currentAiPage);
    },
    documentFilterStatusList() {
      const statusMap = {
        1: fileStatus.NEW,
        2: fileStatus.PROGRESS,
        3: fileStatus.COMPLETE,
        4: fileStatus.DOWNLOAD,
        394: fileStatus.PEND_PAY,
        395: fileStatus.PEND_SUBMIT,
        396: fileStatus.SUCCESS,
        431: fileStatus.CUSTOM_SUBMIT,
        432: fileStatus.CUSTOM_PROCESS,
        448: fileStatus.OVER,
        449: fileStatus.CUSTOM_OVER,
        500: fileStatus.EXPIRE,
        501: fileStatus.DELETED,
        502: fileStatus.DOWN,
      };
      const status = statusMap[this.statusList];
      return status === undefined ? [] : [status];
    },
    documentFilterConfig(type) {
      const configByType = {
        all: {
          uploadType: 4,
          pageKey: "currentAllPage",
          pageSize: this.pageAllSize,
        },
        first: {
          uploadType: 0,
          pageKey: "currentPage",
          pageSize: this.pageSize,
        },
        second: {
          uploadType: 1,
          pageKey: "currentConvertPage",
          pageSize: this.pageConvertSize,
        },
        three: {
          uploadType: 3,
          pageKey: "currentPolishPage",
          pageSize: this.pagePolishSize,
        },
        four: {
          uploadType: 2,
          pageKey: "currentDocPage",
          pageSize: this.pageDocSize,
        },
        ai: {
          uploadType: 5,
          pageKey: "currentAiPage",
          pageSize: this.pageAiSize,
        },
      };
      return configByType[type];
    },
    setDocumentListLoading(type, loading) {
      if (type === "all") this.allLoading = loading;
      else if (type === "first") this.transloading = loading;
      else if (type === "ai") this.aiLoading = loading;
      else if (type === "second") this.convertloading = loading;
      else if (type === "three") this.polishLoading = loading;
      else if (type === "four") this.docLoading = loading;
    },
    applyDocumentFilterResponse(type, response) {
      if (type === "all") this.buildAllDatalist(response);
      else if (type === "first") this.buildDatalist(response);
      else if (type === "second") this.buildConvertDatalist(response);
      else if (type === "three") this.buildPolishDatalist(response);
      else if (type === "four") this.buildDocDatalist(response);
      else if (type === "ai") this.buildAiDatalist(response);
    },
    beginDocumentListRequest(type) {
      this.documentListRequestIds[type] += 1;
      return this.documentListRequestIds[type];
    },
    isCurrentDocumentListRequest(type, requestId) {
      return requestId === this.documentListRequestIds[type];
    },
    requestDocumentFilter() {
      const requestType = this.checkType;
      const config = this.documentFilterConfig(requestType);
      if (!config) return;

      this[config.pageKey] = 1;
      this.setDocumentListLoading(requestType, true);
      const requestId = this.beginDocumentListRequest(requestType);
      const request = new FileListRequest();
      request.setUploadtype(config.uploadType);
      request.setPagesize(config.pageSize);
      request.setCurrentpage(1);
      request.setFileName(this.fileName);
      request.setFileStatusList(this.documentFilterStatusList());
      const TOKEN_KEY = "token";

      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest(requestType, requestId)) return;
          this.applyDocumentFilterResponse(requestType, res);
          this.setDocumentListLoading(requestType, false);
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest(requestType, requestId)) return;
          this.setDocumentListLoading(requestType, false);
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    loadFourH5() {
      this.handleDocCurrentChangeH5(this.currentDocPage + 1);
    },
    loadThreeH5() {
      this.handlePublishCurrentChangeH5(this.currentPolishPage + 1);
    },
    loadSecondH5() {
      this.handleConvertCurrentChangeH5(this.currentConvertPage + 1);
    },
    loadFirstH5() {
      this.handleCurrentChangeH5(this.currentPage + 1);
    },
    loadH5() {
      this.handleAllCurrentChangeH5(this.currentAllPage + 1);
    },
    clearTimeH5() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    handleClickH5(name) {
      if (name === "all") {
        this.activeTabClassAll = "check-tab-active";
        this.activeTabClassSecond = "";
        this.activeTabClassFirst = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "all";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已完成" },
          { value: 4, label: "已下载" },
        ];
        if (this.allTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initAllFileListH5();
        }
      }
      if (name === "first") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "check-tab-active";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "first";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已翻译" },
          { value: 4, label: "已下载" },
        ];
        if (this.tableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initFileListH5();
        }
      }
      if (name === "second") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassSecond = "check-tab-active";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "second";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已转换" },
          { value: 4, label: "已下载" },
        ];
        if (this.convertTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initConvertFileListH5();
        }
      }
      if (name === "three") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "check-tab-active";
        this.activeTabClassFour = "";
        this.activeName = "three";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 396, label: "已完成" },
          { value: 394, label: "待付款" },
          { value: 431, label: "等待客服确认" },
          { value: 448, label: "任务终止" },
          { value: 502, label: "已下载" },
        ];
        if (this.polishTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initPolishFileListH5();
        }
      }
      if (name === "four") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "check-tab-active";
        this.activeName = "four";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 396, label: "已完成" },
          { value: 394, label: "待付款" },
          { value: 431, label: "等待客服确认" },
          { value: 448, label: "任务终止" },
          { value: 502, label: "已下载" },
        ];
        if (this.docTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initDocFileListH5();
        }
      }
    },
    checkPayH5(req) {
      const request = payRequest;
      request.setResponse(req);
      const TOKEN_KEY = "token";
      translateServiceClient
        .checkPay(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.getIspay()) {
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: "支付失败！",
            });
          }
          this.activeName = "all";
          this.initAllFileListH5();
        })
        .catch((err) => {
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "检查支付异常，请稍后！",
          });
        });
    },
    initPolishFileListH5() {
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(3);
      this.polishLoading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildPolishDatalistH5(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          this.polishLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    initDocFileListH5() {
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(2);
      this.docLoading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDocDatalistH5(res);
          this.docLoading = false;
        })
        .catch((err) => {
          this.docLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    initConvertFileListH5() {
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(1);
      this.convertloading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildConvertDatalistH5(res);
          this.convertloading = false;
        })
        .catch((err) => {
          this.convertloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    initAllFileListH5() {
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(4);
      this.transloading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildAllDatalistH5(res);
          this.transloading = false;
        })
        .catch((err) => {
          this.transloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    initFileListH5() {
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(0);
      this.transloading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDatalistH5(res);
          this.transloading = false;
        })
        .catch((err) => {
          this.transloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    getUrlParameterH5(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split("?");
      url = url[url.length - 1];
      let obj = {};
      url.split("&&").map((query) => {
        let temp = query.split("=");
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    payH5(row) {
      const paymentType = this.activeName;
      this.pendingPaymentType = paymentType;
      this.gridData = [];
      this.to = row.language;
      const data = {};
      data.id = row.id;
      data.title = row.name;
      data.page = row.pageNum;
      let request = queryDocumentRequest;
      request.setId(row.id);
      if (paymentType === "all") {
        this.allLoading = true;
        request.setUploadType(row.uploadType);
        this.uploadType = row.uploadType;
      } else if (paymentType === "first") {
        this.transloading = true;
        request.setUploadType(0);
      } else if (paymentType === "second") {
        this.convertloading = true;
        request.setUploadType(1);
      } else if (paymentType === "four") {
        this.docLoading = true;
        request.setUploadType(2);
      } else if (paymentType === "three") {
        this.polishLoading = true;
        request.setUploadType(3);
      } else if (paymentType === "ai") {
        this.aiLoading = true;
        request.setUploadType(5);
      }
      const TOKEN_KEY = "token";
      translateServiceClient
        .queryDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getMessage()) {
            this.setDocumentListLoading(paymentType, false);
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: res.getMessage(),
            });
            return;
          }
          if (paymentType === "all") {
            if (
              row.uploadType === 0 ||
              row.uploadType === 1 ||
              row.uploadType === 5
            ) {
              data.page = res.getPage();
              data.money = res.getOrderMoney();
              this.moneys = res.getMoney();
              this.orderMoney = res.getOrderMoney();
              this.pages = res.getPage();
              this.gridData.push(data);
              this.submitPayH5(paymentType);
            } else {
              data.money = res.getOrderMoney();
              this.moneys = res.getMoney();
              this.orderMoney = res.getOrderMoney();
              this.proGridData.push(data);
              this.submitProPayH5(paymentType);
            }
          } else if (
            paymentType === "first" ||
            paymentType === "second" ||
            paymentType === "ai"
          ) {
            data.page = res.getPage();
            data.money = res.getOrderMoney();
            this.moneys = res.getMoney();
            this.orderMoney = res.getOrderMoney();
            this.pages = res.getPage();
            this.gridData.push(data);
            this.submitPayH5(paymentType);
          } else {
            data.money = res.getOrderMoney();
            this.moneys = res.getMoney();
            this.orderMoney = res.getOrderMoney();
            this.proGridData.push(data);
            this.submitProPayH5(paymentType);
          }
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "支付异常请稍后",
          });
        });
    },
    submitConvertH5(paymentType = this.pendingPaymentType || this.activeName) {
      this.setDocumentListLoading(paymentType, true);
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submitConvert(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
            this.refreshMobileDocumentList(paymentType);
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "支付成功",
            });
            this.dialogTableVisible = false;
            return;
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    submitProPayH5(paymentType = this.pendingPaymentType || this.activeName) {
      const ids = [];
      this.proGridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submitPro(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    submitPayH5(paymentType = this.pendingPaymentType || this.activeName) {
      if (
        paymentType === "second" ||
        (paymentType === "all" && this.uploadType === 1)
      ) {
        this.submitConvertH5(paymentType);
        return;
      }
      this.setDocumentListLoading(paymentType, true);
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submit(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
            this.refreshMobileDocumentList(paymentType);
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "支付成功",
            });
            this.dialogTableVisible = false;
            return;
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    indexConvertMethodH5(index) {
      return (this.currentConvertPage - 1) * this.pageConvertSize + index + 1;
    },
    indexMethodH5(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    RandomNumBothH5() {
      this.tableData.forEach((item) => {
        if (item.status === "排队中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              const status = res.getStatus();
              if (
                status === "Pending" ||
                status === "Pended" ||
                status === "Translating" ||
                status === "Translated" ||
                status === "Completing"
              ) {
                item.status = "翻译中";
                localStorage.setItem(item.id, 0);
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "翻译中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已翻译";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "TransError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "DocError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (item.name.endsWith("xls") || item.name.endsWith("xlsx")) {
                item.disables.disablesread = true;
              }
              if (
                item.name.endsWith("jpg") ||
                item.name.endsWith("jpeg") ||
                item.name.endsWith("png") ||
                item.name.endsWith("tif")
              ) {
                item.disables.disablesread = true;
              }
              if (
                document.getName().endsWith("ppt") ||
                document.getName().endsWith("pptx")
              ) {
                item.disables.disablesread = true;
              }
            })
            .catch((err) => {});
        }
      });
    },
    RandomNumBothConvertH5() {
      this.convertTableData.forEach((item) => {
        if (item.status === "排队中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              const status = res.getStatus();
              if (
                status === "Pending" ||
                status === "Pended" ||
                status === "Translating" ||
                status === "Translated" ||
                status === "Completing"
              ) {
                item.status = "转换中";
                localStorage.setItem(item.id, 0);
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "转换中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已转换";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "TransError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "DocError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
            })
            .catch((err) => {});
        }
      });
    },
    base64ToBlobH5(code, type) {
      let bstr = atob(code);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: type });
    },
    toPathH5(id) {
      this.$router.push({
        name: "TransProStep",
        params: { documentId: id },
      });
    },
    readingFileH5(row) {
      const id = row && typeof row === "object" ? row.id : row;
      let request = readDocumentRequest;
      const TOKEN_KEY = "token";
      request.setId(id);
      translateServiceClient
        .checkReadDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            const targetRow =
              row && typeof row === "object" ? row : { id: id, name: "" };
            this.openDocumentPreview(targetRow);
            return;
          }
          this.$message({
            center: true,
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "请稍后再试！",
          });
        });
    },
    downloadConvertFileH5(row) {
      this.downloadTitle = "确定下载该文件的word版本吗？";
      this.downloadClass = "downloadConvertClass";
      this.downloadStatus = "";
      this.downloadMessage =
        "下载大型文档或转换文档时，需等待时间较长请您耐心等待！";
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = "docx";
      this.excelDialogVisibleConvert = true;
    },
    downloadFileH5(row) {
      this.downloadTitle = "确定下载该文件的译文版本吗？";
      this.downloadClass = "downloadClass";
      this.downloadStatus = "";
      this.downloadMessage =
        "下载大型文档或转换文档时，需等待时间较长请您耐心等待！";
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = row.name.substring(row.name.lastIndexOf(".") + 1);
      if (
        this.radio === "ppt" ||
        this.radio === "pptx" ||
        this.radio === "xls" ||
        this.radio === "xlsx" ||
        this.radio === "png" ||
        this.radio === "jpg" ||
        this.radio === "jpeg" ||
        this.radio === "tif"
      ) {
        this.fullscreenLoadings = this.$loading({
          lock: true,
          text: "正在下载",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.downloadDocH5();
      } else {
        if (row.id.indexOf("-") > 0) {
          this.centerDialogVisible = true;
        } else {
          this.centerDialogVisiblePro = true;
        }
      }
    },
    downloadConvertDocH5() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio);
      const that = this;
      const TOKEN_KEY = "token";
      let stream = translateServiceClient.downLoadConvertFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = "downloadClass2";
      this.downloadTitle = "";
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisibleConvert = false;
            this.excelDialogVisible = false;
            this.customColorDownload = "#1b5ea4";
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = "#38cb1c";
          this.downloadMessage = "下载完成";
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on("data", (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisibleConvert = false;
          this.excelDialogVisible = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on("end", (end) => {
        let aLink = document.createElement("a");
        let blob = that.base64ToBlobH5(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob);
        aLink.click();
        that.downloadPercentage = 99;
      });
      stream.on("error", (err) => {
        clearInterval(this.downloadTimer);
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          this.$router.push("/h5/login");
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文档失败，请稍后再试！",
          });
        }
      });
    },
    downloadDocH5() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio);
      const that = this;
      const TOKEN_KEY = "token";
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = "downloadClass2";
      this.downloadTitle = "";
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisible = false;
            this.excelDialogVisibleConvert = false;
            this.customColorDownload = "#1b5ea4";
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = "#38cb1c";
          this.downloadMessage = "下载完成";
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on("data", (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
          if (
            "commentsone" !== this.radio &&
            "commentstwo" !== this.radio &&
            title.indexOf(this.radio) === -1
          ) {
            that.$message({
              center: true,
              type: "warning",
              showClose: true,
              duration: 4000,
              message:
                "暂时不支持你选择的下载类型！已为您匹配到默认的下载类型，下载中请稍后！",
            });
          }
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisible = false;
          this.excelDialogVisibleConvert = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on("end", (end) => {
        let aLink = document.createElement("a");
        let blob = that.base64ToBlobH5(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob);
        aLink.click();
        that.downloadPercentage = 99;
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
      });
      stream.on("error", (err) => {
        clearInterval(this.downloadTimer);
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          this.$router.push("/h5/login");
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文档失败，请稍后再试！",
          });
        }
      });
    },
    deleteFileH5(id) {
      const that = this;
      let request = deleteFileRequest;
      request.setId(id);
      const TOKEN_KEY = "token";
      translateServiceClient
        .deleteFile(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "删除成功",
            });
            let innerrequest = new FileListRequest();
            if (this.checkType === "all") {
              that.allLoading = true;
              innerrequest.setUploadtype(4);
            } else if (this.checkType === "first") {
              that.transloading = true;
              innerrequest.setUploadtype(0);
            } else if (this.checkType === "second") {
              that.convertloading = true;
              innerrequest.setUploadtype(1);
            } else if (this.checkType === "four") {
              that.docLoading = true;
              innerrequest.setUploadtype(2);
            } else if (this.checkType === "three") {
              that.polishLoading = true;
              innerrequest.setUploadtype(3);
            }
            translateServiceClient
              .fileList(innerrequest, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                if (this.checkType === "all") {
                  that.allTableData = [];
                  that.allTableDataHas = false;
                  this.buildAllDatalistH5(res);
                  this.allLoading = false;
                } else if (this.checkType === "first") {
                  that.tableData = [];
                  that.tableDataHas = false;
                  this.buildDatalistH5(res);
                  this.transloading = false;
                } else if (this.checkType === "second") {
                  that.convertTableData = [];
                  that.convertTableDataHas = false;
                  this.buildConvertDatalistH5(res);
                  this.convertloading = false;
                } else if (this.checkType === "four") {
                  that.docTableData = [];
                  that.docTableDataHas = false;
                  this.buildDocDatalistH5(res);
                  this.docLoading = false;
                } else if (this.checkType === "three") {
                  that.polishTableData = [];
                  that.polishTableDataHas = false;
                  this.buildPolishDatalistH5(res);
                  this.polishLoading = false;
                }
              })
              .catch((err) => {
                this.allLoading = false;
                this.transloading = false;
                this.convertloading = false;
                this.docLoading = false;
                this.polishLoading = false;
                if (err && err.code === 5) {
                  this.$router.push("/h5/login");
                }
              });
            return;
          }
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "删除失败",
          });
        })
        .catch((err) => {
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
      scope._self.$refs[`popover-${scope.$index}`].doClose();
    },
    buildPolishDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      if (documentsList.length < 10) {
        this.polishTableDataHas = true;
      }
      this.countPolish = count;
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = document.getTo();
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        const comment =
          document.getCommon() === "" ? "母语润色翻译" : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          timeCast: document.getTimeCast(),
        };
        this.polishTableData.push(data);
      });
    },
    buildDocDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      if (documentsList.length < 10) {
        this.docTableDataHas = true;
      }
      this.countDoc = count;
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        const comment =
          document.getCommon() === "" ? "专业翻译" : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          timeCast: document.getTimeCast(),
        };
        this.docTableData.push(data);
      });
    },
    buildConvertDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      if (documentsList.length < 10) {
        this.convertTableDataHas = true;
      }
      this.countConvert = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const language = "pdf-word";
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        if (status === "已翻译") {
          status = "已转换";
        }
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "转换中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已转换" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          status = "转换中";
        }
        if (status === "转换中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已转换" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          status = "转换失败";
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
        };
        this.convertTableData.push(data);
      });
    },
    buildAllDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      if (documentsList.length < 10) {
        this.allTableDataHas = true;
      }
      this.countAll = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseNameH5(document.getTo());
        const from = that.getChineseNameH5(document.getFrom());
        const language =
          document.getUploadType() === 1 ? "pdf-word" : from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "翻译中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已翻译" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          if (document.getUploadType() === 1) {
            status = "转换中";
          } else {
            status = "翻译中";
          }
        }
        if (status === "翻译中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        if (status === "已翻译" && document.getUploadType() === 1) {
          status = "已转换";
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (
          status === "已转换" ||
          status === "已翻译" ||
          status === "已下载" ||
          status === "396" ||
          status === "502"
        ) {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败" || status === "448") {
          if (document.getUploadType() === 1) status = "转换失败";
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          comment:
            document.getUploadType() === 0
              ? "机器翻译"
              : document.getUploadType() === 1
              ? "转换文档"
              : document.getUploadType() === 2
              ? "专业翻译"
              : "母语润色",
          uploadType: document.getUploadType(),
          timeCast: document.getTimeCast(),
        };
        this.allTableData.push(data);
      });
    },
    buildDatalistH5(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      if (documentsList.length < 10) {
        this.tableDataHas = true;
      }
      this.count = count;
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseNameH5(document.getTo());
        const from = that.getChineseNameH5(document.getFrom());
        const language = from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "翻译中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已翻译" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          status = "翻译中";
        }
        if (status === "翻译中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已翻译" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
        };
        this.tableData.push(data);
      });
    },
    getChineseNameH5(lanuage) {
      let label = lanuage;
      lanuages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    handleNameChangeH5() {
      let that = this;
      let request = new FileListRequest();
      if (this.checkType === "all") {
        this.allLoading = true;
        request.setUploadtype(4);
      } else if (this.checkType === "first") {
        this.transloading = true;
        request.setUploadtype(0);
      } else if (this.checkType === "second") {
        this.convertloading = true;
        request.setUploadtype(1);
      } else if (this.checkType === "four") {
        this.docLoading = true;
        request.setUploadtype(2);
      } else if (this.checkType === "three") {
        this.polishLoading = true;
        request.setUploadtype(3);
      } else if (this.checkType === "ai") {
        this.transloading = true;
        request.setUploadtype(5);
      }
      request.setFileName(this.fileName);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (that.checkType === "all") {
            that.allTableDataHas = false;
            that.allTableData = [];
            that.buildAllDatalistH5(res);
            that.allLoading = false;
          } else if (that.checkType === "first") {
            that.tableData = [];
            that.tableDataHas = false;
            that.buildDatalistH5(res);
            that.transloading = false;
          } else if (that.checkType === "second") {
            that.convertTableData = [];
            that.convertTableDataHas = false;
            that.buildConvertDatalistH5(res);
            that.convertloading = false;
          } else if (that.checkType === "four") {
            that.docTableData = [];
            that.docTableDataHas = false;
            that.buildDocDatalistH5(res);
            that.docLoading = false;
          } else if (that.checkType === "three") {
            that.polishTableData = [];
            that.polishTableDataHas = false;
            that.buildPolishDatalistH5(res);
            that.polishLoading = false;
          }
        })
        .catch((err) => {
          this.transloading = false;
          this.convertloading = false;
          this.docLoading = false;
          this.polishLoading = false;
          this.allLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleStatusChangeH5() {
      let that = this;
      let request = new FileListRequest();
      if (this.checkType === "all") {
        this.allLoading = true;
        request.setUploadtype(4);
      } else if (this.checkType === "first") {
        this.transloading = true;
        request.setUploadtype(0);
      } else if (this.checkType === "second") {
        this.convertloading = true;
        request.setUploadtype(1);
      } else if (this.checkType === "four") {
        this.docLoading = true;
        request.setUploadtype(2);
      } else if (this.checkType === "three") {
        this.polishLoading = true;
        request.setUploadtype(3);
      }
      if (this.statusList === 0) {
        request.setFileStatusList([]);
        const TOKEN_KEY = "token";
        translateServiceClient
          .fileList(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (that.checkType === "all") {
              that.allTableDataHas = false;
              that.allTableData = [];
              that.buildAllDatalistH5(res);
              that.allLoading = false;
            } else if (that.checkType === "first") {
              that.tableData = [];
              that.tableDataHas = false;
              that.buildDatalistH5(res);
              that.transloading = false;
            } else if (that.checkType === "second") {
              that.convertTableData = [];
              that.convertTableDataHas = false;
              that.buildConvertDatalistH5(res);
              that.convertloading = false;
            } else if (that.checkType === "four") {
              that.docTableData = [];
              that.docTableDataHas = false;
              that.buildDocDatalistH5(res);
              that.docLoading = false;
            } else if (that.checkType === "three") {
              that.polishTableData = [];
              that.polishTableDataHas = false;
              that.buildPolishDatalistH5(res);
              that.polishLoading = false;
            }
          })
          .catch((err) => {
            this.allLoading = false;
            this.transloading = false;
            this.convertloading = false;
            this.docLoading = false;
            this.polishLoading = false;
            if (err && err.code === 5) {
              this.$router.push("/h5/login");
            }
          });
        return;
      }
      request.setFileName(this.fileName);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (that.checkType === "all") {
            that.allTableDataHas = false;
            that.allTableData = [];
            that.buildAllDatalistH5(res);
            that.allLoading = false;
          } else if (that.checkType === "first") {
            that.tableData = [];
            that.tableDataHas = false;
            that.buildDatalistH5(res);
            that.transloading = false;
          } else if (that.checkType === "second") {
            that.convertTableData = [];
            that.convertTableDataHas = false;
            that.buildConvertDatalistH5(res);
            that.convertloading = false;
          } else if (that.checkType === "four") {
            that.docTableData = [];
            that.docTableDataHas = false;
            that.buildDocDatalistH5(res);
            that.docLoading = false;
          } else if (that.checkType === "three") {
            that.polishTableData = [];
            that.polishTableDataHas = false;
            that.buildPolishDatalistH5(res);
            that.polishLoading = false;
          }
        })
        .catch((err) => {
          this.transloading = false;
          this.convertloading = false;
          this.docLoading = false;
          this.polishLoading = false;
          this.allLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleAllSizeChangeH5(val) {
      this.pageAllSize = val;
      let request = new FileListRequest();
      this.allLoading = true;
      request.setPagesize(this.pageAllSize);
      request.setFileName(this.fileName);
      request.setUploadtype(4);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildAllDatalistH5(res);
          this.allLoading = false;
        })
        .catch((err) => {
          this.allLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handlePublishSizeChangeH5(val) {
      this.pagePolishSize = val;
      let request = new FileListRequest();
      this.polishLoading = true;
      request.setPagesize(this.pagePolishSize);
      request.setFileName(this.fileName);
      request.setUploadtype(3);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildPolishDatalistH5(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          this.polishLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleDocSizeChangeH5(val) {
      this.pageDocSize = val;
      let request = new FileListRequest();
      this.docLoading = true;
      request.setPagesize(this.pageDocSize);
      request.setFileName(this.fileName);
      request.setUploadtype(2);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDocDatalistH5(res);
          this.docLoading = false;
        })
        .catch((err) => {
          this.docLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleConvertSizeChangeH5(val) {
      this.pageConvertSize = val;
      let request = new FileListRequest();
      this.convertloading = true;
      request.setPagesize(this.pageConvertSize);
      request.setFileName(this.fileName);
      request.setUploadtype(1);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildConvertDatalistH5(res);
          this.convertloading = false;
        })
        .catch((err) => {
          this.convertloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleSizeChangeH5(val) {
      this.pageSize = val;
      let request = new FileListRequest();
      this.transloading = true;
      request.setPagesize(this.pageSize);
      request.setFileName(this.fileName);
      request.setUploadtype(0);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDatalistH5(res);
          this.transloading = false;
        })
        .catch((err) => {
          this.transloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handlePublishCurrentChangeH5(val) {
      this.currentPolishPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pagePolishSize);
      request.setCurrentpage(this.currentPolishPage);
      request.setFileName(this.fileName);
      this.polishLoading = true;
      request.setUploadtype(3);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildPolishDatalistH5(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          this.polishLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleDocCurrentChangeH5(val) {
      this.currentDocPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pageDocSize);
      request.setCurrentpage(this.currentDocPage);
      request.setFileName(this.fileName);
      this.docLoading = true;
      request.setUploadtype(2);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDocDatalistH5(res);
          this.docLoading = false;
        })
        .catch((err) => {
          this.docLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleConvertCurrentChangeH5(val) {
      this.currentConvertPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pageConvertSize);
      request.setCurrentpage(this.currentConvertPage);
      request.setFileName(this.fileName);
      this.convertloading = true;
      request.setUploadtype(1);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildConvertDatalistH5(res);
          this.convertloading = false;
        })
        .catch((err) => {
          this.convertloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleCurrentChangeH5(val) {
      this.currentPage = val;
      let request = new FileListRequest();
      this.transloading = true;
      request.setPagesize(this.pageSize);
      request.setCurrentpage(this.currentPage);
      request.setFileName(this.fileName);
      request.setUploadtype(0);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDatalistH5(res);
          this.transloading = false;
        })
        .catch((err) => {
          this.transloading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleAllCurrentChangeH5(val) {
      this.currentAllPage = val;
      let request = new FileListRequest();
      this.allLoading = true;
      request.setPagesize(this.pageAllSize);
      request.setCurrentpage(this.currentAllPage);
      request.setFileName(this.fileName);
      request.setUploadtype(4);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildAllDatalistH5(res);
          this.allLoading = false;
        })
        .catch((err) => {
          this.allLoading = false;
          if (err && err.code === 5) {
            this.$router.push("/h5/login");
          }
        });
    },
    handleSelectionChangeH5(val) {
      this.multipleSelection = val;
    },
    tableRowClassNameH5({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "rows-oushu";
      }
      return "rows";
    },
    getUploadTip() {
      const TOKEN_KEY = "token";
      translateServiceClient
        .getUploadTip(uploadTipRequest, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.isShowInRoaming = res.getIsRoaming();
          this.isShowTransPro = res.getIsTransPro();
        })
        .catch((err) => {
          this.isShowInRoaming = false;
          this.isShowTransPro = true;
        });
    },
    getQrcode() {
      this.qrcodeUrl = "http://common.wesitrans.com/common/roaming/qrcode";
      this.isRoamingTimer = setInterval(this.roamingEvent, 1000);
      this.isRoamingTimerOut = setTimeout(this.clearTime, 60000);
    },
    clearTime() {
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    roamingEvent() {
      if (this.userId && localStorage.getItem(this.userId) !== "1") {
        let request = checkRoamingRequest;
        request.setUserId(this.userId);
        const TOKEN_KEY = "token";
        translateServiceClient
          .checkRoaming(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            localStorage.setItem(this.userId, res.getMessage());
            if (res.getMessage() === "1") {
              window.location.reload();
            }
          })
          .catch((err) => {});
      }
    },
    removeQrcode() {
      this.qrcodeUrl = "";
      clearInterval(this.isRoamingTimer);
      clearTimeout(this.isRoamingTimerOut);
    },
    logOut(val) {
      if (val === "toCenter") {
        window.open("http://user.wesitrans.com", "_blank");
        return;
      }
      if (val === "toAccount") {
        window.open("https://user.wesitrans.com/account", "_blank");
        return;
      }
      if (val === "toOrder") {
        window.open("https://user.wesitrans.com/order", "_blank");
        return;
      }
      if (val === "toRoaming") {
        window.open(
          "https://common.wesitrans.com/common/roaming/roaming",
          "_blank"
        );
        return;
      }
      if (val === "txtTrans") {
        this.toPath("/translate", "txt");
        return;
      }
      if (val === "docTrans") {
        this.toPath("/translate", "doc");
        return;
      }
      if (val === "mediaTrans") {
        this.openNewMessage();
        return;
      }
      if (val === "imgTrans") {
        this.toPath("/translate", "img");
        return;
      }
      if (val === "xlsTrans") {
        this.toPath("/translate", "more");
        return;
      }
      if (val === "musicTrans") {
        this.openNewMessage();
        return;
      }

      if (val === "toTransPro") {
        this.toPath("/trans-pro");
        return;
      }
      if (val === "standLangSet") {
        this.toPath("/translate", "setting");
        return;
      }
      if (val === "convertDoc") {
        this.toPath("/translate", "convert");
        return;
      }
      if (val === "mySelfDoc") {
        this.toPath("/list-pro");
        return;
      }
      if (val === "webTranslate") {
        this.toPath("/translate", "plugin");
        return;
      }
      if (val === "smartClassify") {
        this.toPath("/smart-classify");
        return;
      }

      let request = outRequest;
      if (val === undefined) {
        request.setName(this.userInfo);
      } else {
        request.setName(val);
      }
      const TOKEN_KEY = "token";
      authServiceClient
        .logOut(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          window.location.reload();
          this.$router.push("/index");
        })
        .catch((err) => {
          localStorage.removeItem("token");
          localStorage.removeItem("auth-context");
          this.userInfo = "";
          this.showRoaming = false;
          if (this.hasH5) {
            this.$router.push("/h5/login");
            return;
          }
          this.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
        });
    },
    toCenter() {
      window.open("https://user.wesitrans.com/account", "_blank");
    },
    showIframe(url) {
      return this.$authPopup.open(url)
    },
    senEmailAll() {
      this.$message.success(
        "请配置好您的邮箱账号。文献到期后将发送至您邮箱，请注意查收！"
      );
    },
    openRecommendations() {
      const width = $(window).width();
      if (width <= 768) {
        layer.open({
          skin: "login-demo-class",
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      } else {
        layer.open({
          area: ["948px", "625px"],
          type: 2,
          title: false,
          shadeClose: true,
          anim: -1,
          content: ["/recommendations", "no"],
        });
      }
    },
    openNewMessage() {
      this.$alert("服务升级中，敬请期待", "产品升级", {
        confirmButtonText: "确定",
      });
    },
    toPath(url, type) {
      this.showSelect = false;
      if (url === "/trans-pro") {
        window.open("/trans-pro/index", "_self");
        return;
      }
      if (url === "/list" || url === "/list-pro") {
        const TOKEN_KEY = "token";
        authServiceClient
          .getUserStatus(userStatusRequest, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (!res.getStatus()) {
              localStorage.removeItem("token");
              localStorage.removeItem("auth-context");
              if (this.hasH5) {
                this.$router.push("/h5/login");
                return;
              }
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
              return;
            }
            if (
              localStorage.getItem("auth-context") &&
              localStorage.getItem("token")
            ) {
              authServiceClient
                .checkUserPower(userPowerRequest, {
                  [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
                })
                .then((res) => {
                  if (res.getStatus()) {
                    this.$router.push(url);
                    return;
                  }
                  this.$message({
                    center: true,
                    type: "error",
                    showClose: true,
                    duration: 3000,
                    message: res.getMessage(),
                  });
                  if (this.hasH5) {
                    this.$router.push("/h5/login");
                    return;
                  }
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                })
                .catch((err) => {
                  if (this.hasH5) {
                    this.$router.push("/h5/login");
                    return;
                  }
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                });
            }
          })
          .catch((err) => {
            if (this.hasH5) {
              this.$router.push("/h5/login");
              return;
            }
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          });
        return;
      }
      if (type) {
        this.$router.push({
          path: url,
          query: { type: type },
        });
        return;
      }
      this.$router.push(url);
    },
    buildAiDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.countAi = count;
      this.aiFileList = [];
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseName(document.getTo());
        const from = that.getChineseName(document.getFrom());
        const language = from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        const domain = document.getDomain();
        const terminology = document.getTerminology();
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "翻译中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已翻译" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          status = "翻译中";
        }
        if (status === "翻译中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已翻译" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          disablesdel = false;
        }
        console.log(111, document.getUploadType());
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          domain: domain,
          terminology: terminology,
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.aiFileList.push(data);
      });
      console.log(234234, this.aiFileList);
    },
    getAiFileList() {
      this.handleAiCurrentChange(1);
    },
    handleClick(name) {
      if (name === "all") {
        this.activeTabClassAll = "check-tab-active";
        this.activeTabClassSecond = "";
        this.activeTabClassFirst = "";
        this.activeTabClassAi = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "all";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已完成" },
          { value: 4, label: "已下载" },
        ];
        if (this.allTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initAllFileList();
        }
      }
      if (name === "first") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "check-tab-active";
        this.activeTabClassAi = "";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "first";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已翻译" },
          { value: 4, label: "已下载" },
        ];
        if (this.tableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initFileList();
        }
      }
      if (name === "second") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassAi = "";
        this.activeTabClassSecond = "check-tab-active";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "second";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已转换" },
          { value: 4, label: "已下载" },
        ];
        if (this.convertTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initConvertFileList();
        }
      }
      if (name === "three") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassAi = "";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "check-tab-active";
        this.activeTabClassFour = "";
        this.activeName = "three";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 396, label: "已完成" },
          { value: 394, label: "待付款" },
          { value: 431, label: "等待客服确认" },
          { value: 448, label: "任务终止" },
          { value: 502, label: "已下载" },
        ];
        if (this.polishTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initPolishFileList();
        }
      }
      if (name === "four") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassAi = "";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "check-tab-active";
        this.activeName = "four";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 396, label: "已完成" },
          { value: 394, label: "待付款" },
          { value: 431, label: "等待客服确认" },
          { value: 448, label: "任务终止" },
          { value: 502, label: "已下载" },
        ];
        if (this.docTableData.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.initDocFileList();
        }
      }
      if (name === "ai") {
        this.activeTabClassAll = "";
        this.activeTabClassFirst = "";
        this.activeTabClassAi = "check-tab-active";
        this.activeTabClassSecond = "";
        this.activeTabClassThree = "";
        this.activeTabClassFour = "";
        this.activeName = "ai";
        this.checkType = name;
        this.fileStatus = [
          { value: 0, label: "全部" },
          { value: 3, label: "已完成" },
          { value: 4, label: "已下载" },
        ];
        if (this.aiFileList.length === 0) {
          this.statusList = "";
          this.fileName = "";
          this.getAiFileList();
        }
      }
    },
    checkPay(req) {
      const request = payRequest;
      request.setResponse(req);
      const TOKEN_KEY = "token";
      translateServiceClient
        .checkPay(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!res.getIspay()) {
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: "支付失败！",
            });
          }
          this.activeName = "all";
          this.initAllFileList();
        })
        .catch((err) => {
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "检查支付异常，请稍后！",
          });
        });
    },
    initPolishFileList() {
      const requestId = this.beginDocumentListRequest("three");
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(3);
      this.polishLoading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("three", requestId)) return;
          this.buildPolishDatalist(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("three", requestId)) return;
          this.polishLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    initDocFileList() {
      const requestId = this.beginDocumentListRequest("four");
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(2);
      this.docLoading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("four", requestId)) return;
          this.buildDocDatalist(res);
          this.docLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("four", requestId)) return;
          this.docLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    initConvertFileList() {
      const requestId = this.beginDocumentListRequest("second");
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(1);
      this.convertloading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("second", requestId)) return;
          this.buildConvertDatalist(res);
          this.convertloading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("second", requestId)) return;
          this.convertloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    initAllFileList() {
      const requestId = this.beginDocumentListRequest("all");
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(4);
      this.allLoading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("all", requestId)) return;
          this.buildAllDatalist(res);
          this.allLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("all", requestId)) return;
          this.allLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    initFileList() {
      const requestId = this.beginDocumentListRequest("first");
      const TOKEN_KEY = "token";
      let request = new FileListRequest();
      request.setUploadtype(0);
      this.transloading = true;
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("first", requestId)) return;
          this.buildDatalist(res);
          this.transloading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("first", requestId)) return;
          this.transloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    getUrlParameter(route) {
      //decodeURIComponent() 函数可对 encodeURIComponent() 函数编码的 URI 进行解码。
      let url = decodeURIComponent(route).split("?");
      url = url[url.length - 1];
      let obj = {};
      url.split("&&").map((query) => {
        let temp = query.split("=");
        obj[temp[0]] = temp[1];
      });
      return obj;
    },
    pay(row) {
      const paymentType = this.checkType;
      this.pendingPaymentType = paymentType;
      this.gridData = [];
      this.to = row.language;
      const data = {};
      data.id = row.id;
      data.title = row.name;
      data.page = row.pageNum;
      let request = queryDocumentRequest;
      request.setId(row.id);
      console.log(1221);
      if (paymentType === "all") {
        this.allLoading = true;
        request.setUploadType(row.uploadType);
        // debugger;
        this.uploadType = row.uploadType;
      } else if (paymentType === "first") {
        this.transloading = true;
        request.setUploadType(0);
      } else if (paymentType === "second") {
        this.convertloading = true;
        request.setUploadType(1);
      } else if (paymentType === "four") {
        this.docLoading = true;
        request.setUploadType(2);
      } else if (paymentType === "three") {
        this.polishLoading = true;
        request.setUploadType(3);
      } else if (paymentType === "ai") {
        this.aiLoading = true;
        request.setUploadType(5);
      }
      const TOKEN_KEY = "token";
      translateServiceClient
        .queryDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getMessage()) {
            this.setDocumentListLoading(paymentType, false);
            this.$message({
              center: true,
              type: "error",
              showClose: true,
              duration: 3000,
              message: res.getMessage(),
            });
            return;
          }
          if (paymentType === "all") {
            if (
              row.uploadType === 0 ||
              row.uploadType === 1 ||
              row.uploadType === 5
            ) {
              data.page = res.getPage();
              data.money = res.getOrderMoney();
              this.moneys = res.getMoney();
              this.orderMoney = res.getOrderMoney();
              this.pages = res.getPage();
              this.dialogTableVisible = true;
              this.gridData.push(data);
            } else {
              data.money = res.getOrderMoney();
              this.moneys = res.getMoney();
              this.orderMoney = res.getOrderMoney();
              this.proTableVisible = true;
              this.proGridData.push(data);
            }
          } else if (
            paymentType === "first" ||
            paymentType === "second" ||
            paymentType === "ai"
          ) {
            data.page = res.getPage();
            data.money = res.getOrderMoney();
            this.moneys = res.getMoney();
            this.orderMoney = res.getOrderMoney();
            this.pages = res.getPage();
            this.dialogTableVisible = true;
            this.gridData.push(data);
          } else {
            data.money = res.getOrderMoney();
            this.moneys = res.getMoney();
            this.orderMoney = res.getOrderMoney();
            this.proTableVisible = true;
            this.proGridData.push(data);
          }
          this.setDocumentListLoading(paymentType, false);
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "支付异常请稍后",
          });
        });
    },
    submitConvert(paymentType = this.pendingPaymentType || this.checkType) {
      this.setDocumentListLoading(paymentType, true);
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitConvertRequest;
      request.setIdsList(ids).setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submitConvert(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
            this.refreshMobileDocumentList(paymentType);
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "支付成功",
            });
            this.dialogTableVisible = false;
            return;
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    submitProPay(paymentType = this.pendingPaymentType || this.checkType) {
      const ids = [];
      this.proGridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submitPro(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    submitPay(paymentType = this.pendingPaymentType || this.checkType) {
      if (
        paymentType === "second" ||
        (paymentType === "all" && this.uploadType === 1)
      ) {
        this.submitConvert(paymentType);
        return;
      }
      this.setDocumentListLoading(paymentType, true);
      const ids = [];
      this.gridData.forEach((item, index) => {
        ids.push(item.id);
      });
      let request = submitRequest;
      request.setIdsList(ids);
      request.setMoney(this.moneys);
      const TOKEN_KEY = "token";
      translateServiceClient
        .submit(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            if (
              res.getMessage() !== undefined &&
              res.getMessage() !== null &&
              res.getMessage() !== ""
            ) {
              window.open(res.getMessage(), "_self");
              return;
            }
            this.refreshMobileDocumentList(paymentType);
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "支付成功",
            });
            this.dialogTableVisible = false;
            return;
          }
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          this.setDocumentListLoading(paymentType, false);
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "提交失败请稍后再试",
          });
        });
    },
    indexConvertMethod(index) {
      return (this.currentConvertPage - 1) * this.pageConvertSize + index + 1;
    },
    indexMethod(index) {
      return (this.currentAllPage - 1) * this.pageSize + index + 1;
    },
    indexFirstMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    },
    indexThreeMethod(index) {
      return (this.currentPolishPage - 1) * this.pageSize + index + 1;
    },
    indexFourMethod(index) {
      return (this.currentDocPage - 1) * this.pageSize + index + 1;
    },
    RandomNumBoth() {
      // debugger;
      this.tableData.forEach((item) => {
        if (item.status === "排队中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              const status = res.getStatus();
              if (
                status === "Pending" ||
                status === "Pended" ||
                status === "Translating" ||
                status === "Translated" ||
                status === "Completing"
              ) {
                item.status = "翻译中";
                localStorage.setItem(item.id, 0);
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "翻译中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              // debugger;
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已翻译";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "TransError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "DocError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (item.name.endsWith("xls") || item.name.endsWith("xlsx")) {
                item.disables.disablesread = true;
              }
              if (
                item.name.endsWith("jpg") ||
                item.name.endsWith("jpeg") ||
                item.name.endsWith("png") ||
                item.name.endsWith("tif")
              ) {
                item.disables.disablesread = true;
              }
              if (
                document.getName().endsWith("ppt") ||
                document.getName().endsWith("pptx")
              ) {
                item.disables.disablesread = true;
              }
            })
            .catch((err) => {});
        }
      });
      this.allTableData.forEach((item) => {
        if (item.status === "排队中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              const status = res.getStatus();
              if (
                status === "Pending" ||
                status === "Pended" ||
                status === "Translating" ||
                status === "Translated" ||
                status === "Completing"
              ) {
                item.status = "翻译中";
                localStorage.setItem(item.id, 0);
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "翻译中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              // debugger;
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已翻译";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "TransError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (res.getStatus() === "DocError") {
                item.status = "翻译失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (item.name.endsWith("xls") || item.name.endsWith("xlsx")) {
                item.disables.disablesread = true;
              }
              if (
                item.name.endsWith("jpg") ||
                item.name.endsWith("jpeg") ||
                item.name.endsWith("png") ||
                item.name.endsWith("tif")
              ) {
                item.disables.disablesread = true;
              }
              if (
                document.getName().endsWith("ppt") ||
                document.getName().endsWith("pptx")
              ) {
                item.disables.disablesread = true;
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "转换中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已转换";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "TransError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "DocError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
            })
            .catch((err) => {});
        }
      });
    },
    RandomNumBothConvert() {
      this.convertTableData.forEach((item) => {
        if (item.status === "排队中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              const status = res.getStatus();
              if (
                status === "Pending" ||
                status === "Pended" ||
                status === "Translating" ||
                status === "Translated" ||
                status === "Completing"
              ) {
                item.status = "转换中";
                localStorage.setItem(item.id, 0);
              }
            })
            .catch((err) => {});
          return;
        }
        if (item.status === "转换中" || item.status === "处理中") {
          let request = statusRequest;
          request.setId(item.id);
          const TOKEN_KEY = "token";
          translateServiceClient
            .checkStatus(request, {
              [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
            })
            .then((res) => {
              let nums = localStorage.getItem(item.id);
              let Range = 5 - 1;
              let Rand = Math.random();
              //四舍五入
              let num = 1 + Math.round(Rand * Range) + parseInt(nums);
              if (num > 99) {
                item.numbers = 99;
                num = 99;
                item.status = "处理中";
              } else {
                item.numbers = num;
              }
              localStorage.setItem(item.id, num);
              if (res.getStatus() === "Complete") {
                item.status = "已转换";
                item.disables.disablesread = false;
                item.disables.disablesdown = false;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "TransError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
              if (
                res.getStatus() === "DocError" ||
                res.getStatus() === "翻译失败"
              ) {
                item.status = "转换失败";
                item.disables.disablesread = true;
                item.disables.disablesdown = true;
                item.disables.disablesdel = false;
              }
            })
            .catch((err) => {});
        }
      });
    },
    readingFile(row) {
      let request = readDocumentRequest;
      const TOKEN_KEY = "token";
      request.setId(row.id);
      translateServiceClient
        .checkReadDocument(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            this.openDocumentPreview(row);
            return;
          }
          this.$message({
            center: true,
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
        })
        .catch((err) => {
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            return;
          }
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "请稍后再试！",
          });
        });
    },
    toDetail(id) {
      this.$router.push({
        name: "Detail",
        params: { documentId: id },
      });
    },
    base64ToBlob(code, type) {
      let bstr = atob(code);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: type });
    },
    downloadConvertFile(row) {
      this.downloadTitle = "确定下载该文件的word版本吗？";
      this.downloadClass = "downloadConvertClass";
      this.downloadStatus = "";
      this.downloadMessage =
        "下载大型文档或转换文档时，需等待时间较长请您耐心等待！";
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = "docx";
      this.excelDialogVisibleConvert = true;
    },
    sendMail(row) {
      let request = sendEmailRequest;
      request.setDocId(row.id);
      const TOKEN_KEY = "token";
      translateServiceClient
        .sendEmail(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          // debugger;
          let status = res.getStatus();
          let message = res.getMessage();
          if (status) {
            if ("send" === message) {
              if (this.hasH5) {
                this.h5Message = "翻译后的文献即将发送至您的邮箱，请注意查收!";
              } else {
                this.$message.success(
                  "翻译后的文献即将发送至您的邮箱，请注意查收!"
                );
              }
              return;
            }
            if (this.hasH5) {
              this.h5Message = "文献翻译完成后将发送至您的邮箱，请注意查收！";
            } else {
              this.$message.success(
                "文献翻译完成后将发送至您的邮箱，请注意查收！"
              );
            }
            return;
          }
          if ("login" === message) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
            } else {
              this.$message.warning("登录过期，请重新登录");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            }
            return;
          }
          if ("no_param" === message) {
            if (this.hasH5) {
              this.h5ErrorMessage = "参数有误，请重新操作";
            } else {
              this.$message.error("参数有误，请重新操作");
            }
            return;
          }
          if ("add_email" === message) {
            if (this.hasH5) {
              this.h5ErrorMessage = "您还未设置邮箱，请前往个人中心设置";
            } else {
              this.$message({
                message: "您还未设置邮箱，请前往个人中心设置，即将跳往个人中心",
                type: "warning",
                duration: 2000,
                onClose: () => {
                  window.open("https://user.wesitrans.com/account", "_blank");
                },
              });
            }
            return;
          }
          if ("success" === message) {
            if (this.hasH5) {
              this.h5Message = "翻译后的文献已发送至您的邮箱，请注意查收！";
            } else {
              this.$message.success(
                "翻译后的文献已发送至您的邮箱，请注意查收！"
              );
            }
            return;
          }
          if ("sending" === message) {
            if (this.hasH5) {
              this.h5Message = "翻译后的即将已发送至您的邮箱，请注意查收！";
            } else {
              this.$message.success(
                "翻译后的即将已发送至您的邮箱，请注意查收！"
              );
            }
            return;
          }
          if ("status" === message) {
            if (this.hasH5) {
              this.h5ErrorMessage = "当前文献不支持发送邮件";
            } else {
              this.$message.warning("当前文献不支持发送邮件");
            }
            return;
          }
          if (this.hasH5) {
            this.h5ErrorMessage = "未知原因，请稍后重试";
          } else {
            this.$message.warning("未知原因，请稍后重试");
          }
        })
        .catch((err) => {
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    downloadFile(row) {
      this.downloadTitle = "确定下载该文件的译文版本吗？";
      this.downloadClass = "downloadClass";
      this.downloadStatus = "";
      this.downloadMessage =
        "下载大型文档或转换文档时，需等待时间较长请您耐心等待！";
      this.downloadPercentage = 0;
      this.isDownload = true;
      this.downloadDocLoad = false;
      this.downloadId = row.id;
      this.radio = row.name.substring(row.name.lastIndexOf(".") + 1);
      if (
        this.radio === "ppt" ||
        this.radio === "pptx" ||
        this.radio === "xls" ||
        this.radio === "xlsx" ||
        this.radio === "png" ||
        this.radio === "jpg" ||
        this.radio === "jpeg" ||
        this.radio === "tif" ||
        this.radio === "xml" ||
        this.radio === "html" ||
        this.radio === "htm"
      ) {
        this.fullscreenLoadings = this.$loading({
          lock: true,
          text: "正在下载",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.downloadDoc();
      } else {
        if (row.id.indexOf("-") > 0) {
          this.centerDialogVisible = true;
        } else {
          this.centerDialogVisiblePro = true;
        }
      }
    },
    downloadConvertDoc() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio);
      const that = this;
      const TOKEN_KEY = "token";
      let stream = translateServiceClient.downLoadConvertFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = "downloadClass2";
      this.downloadTitle = "";
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisibleConvert = false;
            this.excelDialogVisible = false;
            this.customColorDownload = "#1b5ea4";
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = "#38cb1c";
          this.downloadMessage = "下载完成";
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on("data", (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisibleConvert = false;
          this.excelDialogVisible = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on("end", (end) => {
        let aLink = document.createElement("a");
        let blob = that.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob);
        aLink.click();
        that.downloadPercentage = 99;
      });
      stream.on("error", (err) => {
        clearInterval(this.downloadTimer);
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          if (this.hasH5) {
            this.$router.push("/h5/index");
            return;
          }
          that.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文档失败，请稍后再试！",
          });
        }
      });
    },
    downloadDoc() {
      let request = readingFileRequest;
      request.setId(this.downloadId);
      request.setType(this.radio);
      const that = this;
      const TOKEN_KEY = "token";
      let stream = translateServiceClient.downLoadFile(request, {
        [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
      });
      this.isDownload = false;
      this.downloadDocLoad = true;
      this.downloadClass = "downloadClass2";
      this.downloadTitle = "";
      let flag = 0;
      let content = "";
      let title = "";
      let type = "";
      let size = 0;
      let count = 0;
      this.downloadTimer = setInterval(() => {
        if (this.downloadPercentage < 98) {
          this.downloadPercentage += 1;
        }
        if (this.downloadPercentage === 100) {
          count += 1;
          if (count === 3) {
            clearInterval(this.downloadTimer);
            this.isDownload = true;
            this.downloadDocLoad = false;
            this.centerDialogVisible = false;
            this.centerDialogVisiblePro = false;
            this.excelDialogVisible = false;
            this.excelDialogVisibleConvert = false;
            this.customColorDownload = "#1b5ea4";
          }
        }
        if (this.downloadPercentage === 99) {
          this.customColorDownload = "#38cb1c";
          this.downloadMessage = "下载完成";
          this.downloadPercentage = 100;
        }
      }, 1000);
      stream.on("data", (res) => {
        if (res.getStatus() && flag === 0) {
          title = res.getTitle();
          type = res.getType();
          size = res.getSize();
          if (
            "commentsone" !== this.radio &&
            "commentstwo" !== this.radio &&
            title.indexOf(this.radio) === -1
          ) {
            that.$message({
              center: true,
              type: "warning",
              showClose: true,
              duration: 4000,
              message:
                "暂时不支持你选择的下载类型！已为您匹配到默认的下载类型，下载中请稍后！",
            });
          }
        }
        if (!res.getStatus() && flag === 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: res.getMessage(),
          });
          clearInterval(this.downloadTimer);
          this.isDownload = true;
          this.downloadDocLoad = false;
          this.centerDialogVisible = false;
          this.centerDialogVisiblePro = false;
          this.excelDialogVisible = false;
          this.excelDialogVisibleConvert = false;
          return;
        }
        flag++;
        content += res.getContent_asB64();
      });
      stream.on("end", (end) => {
        let aLink = document.createElement("a");
        let blob = that.base64ToBlob(content, type);
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("click", true, true);
        aLink.download = title;
        aLink.href = window.URL.createObjectURL(blob);
        aLink.click();
        that.downloadPercentage = 99;
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
      });
      stream.on("error", (err) => {
        clearInterval(this.downloadTimer);
        if (that.fullscreenLoadings !== undefined) {
          that.fullscreenLoadings.close();
        }
        that.isDownload = true;
        that.downloadDocLoad = false;
        that.centerDialogVisible = false;
        this.centerDialogVisiblePro = false;
        that.excelDialogVisibleConvert = false;
        that.excelDialogVisible = false;
        if (err && err.code === 5) {
          if (this.hasH5) {
            this.$router.push("/h5/index");
            return;
          }
          that.$router.push("/index");
          this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          return;
        }
        if (err && err.code !== 0) {
          that.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "下载文档失败，请稍后再试！",
          });
        }
      });
    },
    deleteFile(scope) {
      const id = scope.row.id;
      let request = deleteFileRequest;
      request.setId(id);
      const TOKEN_KEY = "token";
      translateServiceClient
        .deleteFile(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (res.getStatus()) {
            this.$message({
              center: true,
              type: "success",
              showClose: true,
              duration: 3000,
              message: "删除成功",
            });
            let innerrequest = new FileListRequest();
            if (this.checkType === "all") {
              this.allLoading = true;
              innerrequest.setUploadtype(4);
            } else if (this.checkType === "first") {
              this.transloading = true;
              innerrequest.setUploadtype(0);
            } else if (this.checkType === "second") {
              this.convertloading = true;
              innerrequest.setUploadtype(1);
            } else if (this.checkType === "four") {
              this.docLoading = true;
              innerrequest.setUploadtype(2);
            } else if (this.checkType === "three") {
              this.polishLoading = true;
              innerrequest.setUploadtype(3);
            }
            translateServiceClient
              .fileList(innerrequest, {
                [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
              })
              .then((res) => {
                if (this.checkType === "all") {
                  this.buildAllDatalist(res);
                  this.allLoading = false;
                } else if (this.checkType === "first") {
                  this.buildDatalist(res);
                  this.transloading = false;
                } else if (this.checkType === "second") {
                  this.buildConvertDatalist(res);
                  this.convertloading = false;
                } else if (this.checkType === "four") {
                  this.buildDocDatalist(res);
                  this.docLoading = false;
                } else if (this.checkType === "three") {
                  this.buildPolishDatalist(res);
                  this.polishLoading = false;
                }
              })
              .catch((err) => {
                this.allLoading = false;
                this.transloading = false;
                this.convertloading = false;
                this.docLoading = false;
                this.polishLoading = false;
                if (err && err.code === 5) {
                  if (this.hasH5) {
                    this.$router.push("/h5/index");
                    return;
                  }
                  this.$router.push("/index");
                  this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
                }
              });
            return;
          }
          this.$message({
            center: true,
            type: "error",
            showClose: true,
            duration: 3000,
            message: "删除失败",
          });
        })
        .catch((err) => {
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
      scope._self.$refs[`popover-${scope.$index}`].doClose();
    },
    buildPolishDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.countPolish = count;
      this.polishTableData = [];
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = document.getTo();
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        const comment =
          document.getCommon() === "" ? "母语润色翻译" : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          timeCast: document.getTimeCast(),
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.polishTableData.push(data);
      });
    },
    buildDocDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.countDoc = count;
      this.docTableData = [];
      documentsList.forEach((document, index) => {
        const to = document.getTo();
        const from = document.getFrom();
        const language = from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        const comment =
          document.getCommon() === "" ? "专业翻译" : document.getCommon();
        let status = document.getStatus();
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "396" || status === "502") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "448") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          comment: comment,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          timeCast: document.getTimeCast(),
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.docTableData.push(data);
      });
    },
    buildConvertDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.countConvert = count;
      this.convertTableData = [];
      const that = this;
      documentsList.forEach((document, index) => {
        const language = "pdf-word";
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        if (status === "已翻译") {
          status = "已转换";
        }
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "转换中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已转换" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          status = "转换中";
        }
        if (status === "转换中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已转换" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          status = "转换失败";
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.convertTableData.push(data);
      });
    },
    buildAllDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.countAll = count;
      this.allTableData = [];
      const that = this;
      console.log(666, documentsList);
      documentsList.forEach((document, index) => {
        const to = that.getChineseName(document.getTo());
        const from = that.getChineseName(document.getFrom());
        const language =
          document.getUploadType() === 1 ? "pdf-word" : from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "翻译中";
          }
        }
        // debugger;
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已翻译" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          if (document.getUploadType() === 1) {
            status = "转换中";
          } else {
            status = "翻译中";
          }
        }
        if (status === "翻译中" || status === "转换中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        if (status === "翻译中" && document.getUploadType() === 1) {
          status = "转换中";
        }
        if (status === "已翻译" && document.getUploadType() === 1) {
          status = "已转换";
        }
        // debugger;
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (
          status === "已转换" ||
          status === "已翻译" ||
          status === "已下载" ||
          status === "396" ||
          status === "502"
        ) {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败" || status === "448") {
          if (document.getUploadType() === 1) status = "转换失败";
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          comment:
            document.getUploadType() === 0
              ? "机器翻译"
              : document.getUploadType() === 1
              ? "转换文档"
              : document.getUploadType() === 2
              ? "专业翻译"
              : document.getUploadType() === 10
              ? "浩语OA"
              : "母语润色",
          uploadType: document.getUploadType(),
          timeCast: document.getTimeCast(),
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.allTableData.push(data);
      });
    },
    buildDatalist(res) {
      let count = res.getCount();
      const documentsList = res.getDocumentsList();
      this.count = count;
      this.tableData = [];
      const that = this;
      documentsList.forEach((document, index) => {
        const to = that.getChineseName(document.getTo());
        const from = that.getChineseName(document.getFrom());
        const language = from + "-" + to;
        const pageNum =
          document.getPageNum() === "" ? "-" : document.getPageNum();
        let status = document.getStatus();
        const domain = document.getDomain();
        const terminology = document.getTerminology();
        let number = 0;
        if (index === 0) {
          if (status === "排队中" && that.statusList !== 1) {
            status = "翻译中";
          }
        }
        if (
          localStorage.getItem(document.getId()) &&
          status !== "已翻译" &&
          status !== "已下载" &&
          status !== "翻译失败" &&
          status !== "已过期" &&
          status !== "已删除"
        ) {
          status = "翻译中";
        }
        if (status === "翻译中") {
          if (!localStorage.getItem(document.getId())) {
            localStorage.setItem(document.getId(), 0);
          }
          number = parseInt(localStorage.getItem(document.getId()));
          if (number > 99) {
            number = 99;
          }
        }
        let disablesread = true;
        let disablesdown = true;
        let disablesdel = true;
        if (status === "已翻译" || status === "已下载") {
          disablesread = false;
          disablesdown = false;
          disablesdel = false;
        }
        if (
          document.getName().endsWith("xls") ||
          document.getName().endsWith("xlsx")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("jpg") ||
          document.getName().endsWith("jpeg") ||
          document.getName().endsWith("png") ||
          document.getName().endsWith("tif")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("xml") ||
          document.getName().endsWith("html") ||
          document.getName().endsWith("htm")
        ) {
          disablesread = true;
        }
        if (
          document.getName().endsWith("ppt") ||
          document.getName().endsWith("pptx")
        ) {
          disablesread = true;
        }
        if (status === "翻译失败") {
          disablesdel = false;
        }
        const data = {
          id: document.getId(),
          name: document.getName(),
          status: status,
          language: language,
          pageNum: pageNum,
          disables: {
            disablesread: disablesread,
            disablesdown: disablesdown,
            disablesdel: disablesdel,
          },
          numbers: number,
          datetime: document.getCreateTime(),
          refundMode: document.getRefundMode(),
          domain: domain,
          terminology: terminology,
          transType: this.uploadTypeMap[document.getUploadType()],
        };
        this.tableData.push(data);
      });
    },
    getChineseName(lanuage) {
      let label = lanuage;
      lanuages.forEach((item) => {
        if (item.value === lanuage) {
          label = item.label;
        }
      });
      return label;
    },
    handleNameChange() {
      let that = this;
      let request = new FileListRequest();
      if (this.checkType === "all") {
        this.allLoading = true;
        request.setUploadtype(4);
      } else if (this.checkType === "first") {
        this.transloading = true;
        request.setUploadtype(0);
      } else if (this.checkType === "second") {
        this.convertloading = true;
        request.setUploadtype(1);
      } else if (this.checkType === "four") {
        this.docLoading = true;
        request.setUploadtype(2);
      } else if (this.checkType === "three") {
        this.polishLoading = true;
        request.setUploadtype(3);
      } else if (this.checkType === "ai") {
        this.transloading = true;
        request.setUploadtype(5);
      }
      request.setFileName(this.fileName);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (that.checkType === "all") {
            that.buildAllDatalist(res);
            this.allLoading = false;
          } else if (that.checkType === "first") {
            that.buildDatalist(res);
            this.transloading = false;
          } else if (that.checkType === "second") {
            that.buildConvertDatalist(res);
            this.convertloading = false;
          } else if (that.checkType === "four") {
            that.buildDocDatalist(res);
            this.docLoading = false;
          } else if (that.checkType === "three") {
            that.buildPolishDatalist(res);
            this.polishLoading = false;
          } else if (that.checkType === "ai") {
            that.buildAiDatalist(res);
            this.transloading = false;
          }
        })
        .catch((err) => {
          this.transloading = false;
          this.convertloading = false;
          this.docLoading = false;
          this.polishLoading = false;
          this.allLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleStatusChange() {
      let that = this;
      let request = new FileListRequest();
      if (this.checkType === "all") {
        this.allLoading = true;
        request.setUploadtype(4);
      } else if (this.checkType === "first") {
        this.transloading = true;
        request.setUploadtype(0);
      } else if (this.checkType === "second") {
        this.convertloading = true;
        request.setUploadtype(1);
      } else if (this.checkType === "four") {
        this.docLoading = true;
        request.setUploadtype(2);
      } else if (this.checkType === "three") {
        this.polishLoading = true;
        request.setUploadtype(3);
      } else if (this.checkType === "ai") {
        this.transloading = true;
        request.setUploadtype(5);
      }
      request.setFileName(this.fileName);
      if (this.statusList === 0) {
        request.setFileStatusList([]);
        const TOKEN_KEY = "token";
        translateServiceClient
          .fileList(request, {
            [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
          })
          .then((res) => {
            if (that.checkType === "all") {
              that.buildAllDatalist(res);
              this.allLoading = false;
            } else if (that.checkType === "first") {
              that.buildDatalist(res);
              this.transloading = false;
            } else if (that.checkType === "second") {
              that.buildConvertDatalist(res);
              this.convertloading = false;
            } else if (that.checkType === "four") {
              that.buildDocDatalist(res);
              this.docLoading = false;
            } else if (that.checkType === "three") {
              that.buildPolishDatalist(res);
              this.polishLoading = false;
            } else if (that.checkType === "ai") {
              that.buildAiDatalist(res);
              this.transloading = false;
            }
          })
          .catch((err) => {
            this.allLoading = false;
            this.transloading = false;
            this.convertloading = false;
            this.docLoading = false;
            this.polishLoading = false;
            if (err && err.code === 5) {
              if (this.hasH5) {
                this.$router.push("/h5/index");
                return;
              }
              this.$router.push("/index");
              this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
            }
          });
        return;
      }
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (that.checkType === "all") {
            that.buildAllDatalist(res);
            this.allLoading = false;
          } else if (that.checkType === "first") {
            that.buildDatalist(res);
            this.transloading = false;
          } else if (that.checkType === "second") {
            that.buildConvertDatalist(res);
            this.convertloading = false;
          } else if (that.checkType === "four") {
            that.buildDocDatalist(res);
            this.docLoading = false;
          } else if (that.checkType === "three") {
            that.buildPolishDatalist(res);
            this.polishLoading = false;
          } else if (that.checkType === "ai") {
            that.buildAiDatalist(res);
            this.transloading = false;
          }
        })
        .catch((err) => {
          this.transloading = false;
          this.convertloading = false;
          this.docLoading = false;
          this.polishLoading = false;
          this.allLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleAllSizeChange(val) {
      this.pageAllSize = val;
      let request = new FileListRequest();
      this.allLoading = true;
      request.setPagesize(this.pageAllSize);
      request.setFileName(this.fileName);
      request.setUploadtype(4);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildAllDatalist(res);
          this.allLoading = false;
        })
        .catch((err) => {
          this.allLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handlePublishSizeChange(val) {
      this.pagePolishSize = val;
      let request = new FileListRequest();
      this.polishLoading = true;
      request.setPagesize(this.pagePolishSize);
      request.setFileName(this.fileName);
      request.setUploadtype(3);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildPolishDatalist(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          this.polishLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleDocSizeChange(val) {
      this.pageDocSize = val;
      let request = new FileListRequest();
      this.docLoading = true;
      request.setPagesize(this.pageDocSize);
      request.setFileName(this.fileName);
      request.setUploadtype(2);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDocDatalist(res);
          this.docLoading = false;
        })
        .catch((err) => {
          this.docLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleConvertSizeChange(val) {
      this.pageConvertSize = val;
      let request = new FileListRequest();
      this.convertloading = true;
      request.setPagesize(this.pageConvertSize);
      request.setFileName(this.fileName);
      request.setUploadtype(1);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildConvertDatalist(res);
          this.convertloading = false;
        })
        .catch((err) => {
          this.convertloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      let request = new FileListRequest();
      this.transloading = true;
      request.setPagesize(this.pageSize);
      request.setFileName(this.fileName);
      request.setUploadtype(0);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          this.buildDatalist(res);
          this.transloading = false;
        })
        .catch((err) => {
          this.transloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handlePublishCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("three");
      this.currentPolishPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pagePolishSize);
      request.setCurrentpage(this.currentPolishPage);
      request.setFileName(this.fileName);
      this.polishLoading = true;
      request.setUploadtype(3);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("three", requestId)) return;
          this.buildPolishDatalist(res);
          this.polishLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("three", requestId)) return;
          this.polishLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleDocCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("four");
      this.currentDocPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pageDocSize);
      request.setCurrentpage(this.currentDocPage);
      request.setFileName(this.fileName);
      this.docLoading = true;
      request.setUploadtype(2);
      let fileStatusList = [];
      if (this.statusList === 500) {
        fileStatusList.push(fileStatus.EXPIRE);
      }
      if (this.statusList === 501) {
        fileStatusList.push(fileStatus.DELETED);
      }
      if (this.statusList === 394) {
        fileStatusList.push(fileStatus.PEND_PAY);
      }
      if (this.statusList === 395) {
        fileStatusList.push(fileStatus.PEND_SUBMIT);
      }
      if (this.statusList === 396) {
        fileStatusList.push(fileStatus.SUCCESS);
      }
      if (this.statusList === 431) {
        fileStatusList.push(fileStatus.CUSTOM_SUBMIT);
      }
      if (this.statusList === 432) {
        fileStatusList.push(fileStatus.CUSTOM_PROCESS);
      }
      if (this.statusList === 448) {
        fileStatusList.push(fileStatus.OVER);
      }
      if (this.statusList === 449) {
        fileStatusList.push(fileStatus.CUSTOM_OVER);
      }
      if (this.statusList === 502) {
        fileStatusList.push(fileStatus.DOWN);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("four", requestId)) return;
          this.buildDocDatalist(res);
          this.docLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("four", requestId)) return;
          this.docLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleConvertCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("second");
      this.currentConvertPage = val;
      let request = new FileListRequest();
      request.setPagesize(this.pageConvertSize);
      request.setCurrentpage(this.currentConvertPage);
      request.setFileName(this.fileName);
      this.convertloading = true;
      request.setUploadtype(1);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("second", requestId)) return;
          this.buildConvertDatalist(res);
          this.convertloading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("second", requestId)) return;
          this.convertloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleAiCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("ai");
      this.currentAiPage = val;
      const request = new FileListRequest();
      this.aiLoading = true;
      request.setPagesize(this.pageAiSize);
      request.setCurrentpage(this.currentAiPage);
      request.setFileName(this.fileName);
      request.setUploadtype(5);
      const fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("ai", requestId)) return;
          this.buildAiDatalist(res);
          this.aiLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("ai", requestId)) return;
          this.aiLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("first");
      this.currentPage = val;
      let request = new FileListRequest();
      this.transloading = true;
      request.setPagesize(this.pageSize);
      request.setCurrentpage(this.currentPage);
      request.setFileName(this.fileName);
      request.setUploadtype(0);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("first", requestId)) return;
          this.buildDatalist(res);
          this.transloading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("first", requestId)) return;
          this.transloading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleAllCurrentChange(val) {
      const requestId = this.beginDocumentListRequest("all");
      this.currentAllPage = val;
      let request = new FileListRequest();
      this.allLoading = true;
      request.setPagesize(this.pageAllSize);
      request.setCurrentpage(this.currentAllPage);
      request.setFileName(this.fileName);
      request.setUploadtype(4);
      let fileStatusList = [];
      if (this.statusList === 1) {
        fileStatusList.push(fileStatus.NEW);
      }
      if (this.statusList === 2) {
        fileStatusList.push(fileStatus.PROGRESS);
      }
      if (this.statusList === 3) {
        fileStatusList.push(fileStatus.COMPLETE);
      }
      if (this.statusList === 4) {
        fileStatusList.push(fileStatus.DOWNLOAD);
      }
      request.setFileStatusList(fileStatusList);
      const TOKEN_KEY = "token";
      translateServiceClient
        .fileList(request, {
          [TOKEN_KEY]: localStorage.getItem(TOKEN_KEY),
        })
        .then((res) => {
          if (!this.isCurrentDocumentListRequest("all", requestId)) return;
          this.buildAllDatalist(res);
          this.allLoading = false;
        })
        .catch((err) => {
          if (!this.isCurrentDocumentListRequest("all", requestId)) return;
          this.allLoading = false;
          if (err && err.code === 5) {
            if (this.hasH5) {
              this.$router.push("/h5/index");
              return;
            }
            this.$router.push("/index");
            this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL);
          }
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "rows-oushu";
      }
      return "rows";
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(this.downloadTimer);
    clearInterval(this.timerConvert);
  },
};
</script>

<style lang="less" scoped src="../assets/v2/css/list/common.less"/>
<style lang="less" scoped src="../assets/v2/css/list/index.less"/>

<style>
/deep/ .v-modal {
  z-index: 2030 !important;
}

.el-popover.popper-class {
  background: #95060600;
  padding: 0;
  border: 0px solid #ebeef5;
  box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0.1);
}
</style>

<style lang="less" scoped>
.task-list-page.task-list-page {
  --list-brand-strong: var(--primary-dark);
  --list-brand: var(--primary);
  --list-brand-light: #34d399;
  --list-brand-soft: #ecfdf5;
  --list-canvas: #f5f8fa;
  --list-surface: #ffffff;
  --list-text: #1a1a2e;
  --list-text-secondary: #6b7280;
  --list-border: #dce4e7;
  width: 100%;
  min-height: 100vh;
  color: var(--list-text);
  background: var(--list-canvas);
  font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;

  .mains {
    width: 100%;
    min-width: 0;
    min-height: 100vh;
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;
    justify-content: flex-start;
    background: var(--list-canvas);
  }

  .mains .page,
  .mains .page .group_1,
  .mains .page .group_1 .box_1 {
    width: 100%;
    min-width: 0;
    margin: 0;
    overflow: visible;
    background: transparent;
  }

  .list-page-intro {
    position: relative;
    width: calc(100% - 48px);
    min-height: 108px;
    margin: 28px auto 0;
    padding: 19px 28px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
    overflow: hidden;
    color: #fff;
    border-radius: 15px;
    background: linear-gradient(105deg, var(--list-brand-strong), var(--list-brand) 66%, var(--list-brand-light));
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);

    &::after {
      position: absolute;
      right: -42px;
      bottom: -86px;
      width: 220px;
      height: 220px;
      content: "";
      border: 38px solid rgba(255, 255, 255, 0.08);
      border-radius: 50%;
      pointer-events: none;
    }
  }

  .list-page-intro-copy {
    position: relative;
    z-index: 1;
    min-width: 0;
    flex: 1 1 auto;

    h1 {
      margin: 5px 0 7px;
      font-size: 26px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 1px;
    }

    p {
      margin: 0;
      color: rgba(255, 255, 255, 0.82);
      font-size: 14px;
      line-height: 1.8;
    }
  }

  .list-page-eyebrow {
    color: rgba(255, 255, 255, 0.72);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 3px;
  }

  .list-page-primary-action {
    position: relative;
    z-index: 1;
    min-width: 128px;
    height: 44px;
    padding: 0 20px;
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: var(--list-brand-strong);
    border: 1px solid rgba(255, 255, 255, 0.64);
    border-radius: 9px;
    background: #fff;
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.22);
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: transform 0.16s ease, box-shadow 0.16s ease;

    &:hover,
    &:focus-visible {
      transform: translateY(-2px);
      box-shadow: 0 9px 20px rgba(0, 0, 0, 0.28);
      outline: 3px solid rgba(255, 255, 255, 0.58);
      outline-offset: 2px;
    }
  }

  .tip-alert-content {
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .tip-alert-content .tip-alert {
    width: 100%;
    margin: 12px auto;
  }

  .mains .tip-alert-content .tip-alert /deep/ .el-alert {
    min-height: 42px;
    height: auto;
    padding: 9px 16px;
    color: #526b7f !important;
    border: 1px solid #d6e7f3;
    border-radius: 10px;
    background: #eef7fc !important;
  }

  .mains .tip-alert-content .tip-alert /deep/ .el-alert__title {
    color: inherit;
    font-size: 13px;
    line-height: 22px;
  }

  .tip-email-action {
    color: #526b7f !important;
    font-family: inherit !important;
  }

  .list-content {
    width: 100%;
    padding: 0 24px 40px;
    box-sizing: border-box;
  }

  .list-content .list-main {
    width: 100%;
    height: auto;
    min-height: 0;
    margin: 0 auto;
    overflow: hidden;
    border: 1px solid var(--list-border);
    border-radius: 15px;
    background: var(--list-surface);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.06);
  }

  .list-content .list-main .list-tab {
    width: 100%;
    padding: 9px;
    box-sizing: border-box;
    justify-content: flex-start;
    align-items: stretch;
    overflow-x: auto;
    border-bottom: 1px solid #ebeef5;
    background: #fff;
    scrollbar-width: thin;
    scrollbar-color: #bfd8e7 transparent;
  }

  .list-content .list-main .list-tab::-webkit-scrollbar {
    height: 6px;
  }

  .list-content .list-main .list-tab::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #bfd8e7;
  }

  .mains .list-content .list-main .list-tab .list-tab-but {
    width: 100%;
    min-width: 690px;
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
    border-radius: 12px;
    background: #f3f7f9;
  }

  .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default {
    min-width: 0;
    height: 42px;
    flex: 1 1 0;
    color: var(--list-text-secondary);
    border-radius: 9px;
    background: transparent;
    font-size: 14px;
    font-weight: 500;
    white-space: nowrap;
    transition: color 0.16s ease, background 0.16s ease, box-shadow 0.16s ease;
  }

  .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default:hover {
    height: 42px;
    color: var(--list-brand-strong) !important;
    border-radius: 9px;
    background: var(--list-brand-soft);
  }

  .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active,
  .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active:hover {
    height: 42px;
    color: #fff !important;
    border-radius: 9px;
    background: var(--list-brand-strong);
    box-shadow: none;
  }

  .list-content .list-main .list-context {
    margin: 0;
    padding: 0 18px 18px;
    box-sizing: border-box;
  }

  .list-table-scroll-hint {
    display: none;
  }

  .tab-label-mobile {
    display: none;
  }

  .mobile-document-filters,
  .mobile-document-list,
  .mobile-document-feedback {
    display: none;
  }

  .list-table-shell {
    min-height: 420px !important;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    align-content: start;
  }

  .list-table-shell > .el-table {
    grid-column-start: 1;
    grid-column-end: -1;
    align-self: start;
    margin-top: 14px;
  }

  .list-table-shell > .el-table + div {
    grid-column: 1;
    margin: 18px 0 2px !important;
    float: none !important;
    color: var(--list-text-secondary);
  }

  .list-table-shell > .el-table + div + div {
    grid-column: 2;
    margin: 18px 0 2px !important;
    float: none !important;
  }

  .list-main /deep/ .el-table {
    overflow: hidden;
    color: #334155;
    border: 1px solid #ebeef5 !important;
    border-radius: 11px;
  }

  .list-main /deep/ .el-table::before,
  .list-main /deep/ .el-table::after {
    display: none;
  }

  .list-main /deep/ .el-table th,
  .list-main /deep/ .el-table th.el-table__cell {
    height: 62px !important;
    padding: 8px 0;
    color: #4b5b68 !important;
    border-color: #ebeef5 !important;
    background: #f8fbfe !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }

  .list-main /deep/ .el-table td,
  .list-main /deep/ .el-table td.el-table__cell {
    padding: 0;
    border-color: #ebeef5 !important;
  }

  .list-main /deep/ .el-table .rows,
  .list-main /deep/ .el-table .rows-oushu {
    height: 60px;
    color: #334155;
    background: #fff;
    font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif;
  }

  .list-main /deep/ .el-table .rows-oushu td {
    background: #fbfdfe;
  }

  .list-main /deep/ .el-table__body tr:hover > td,
  .list-main /deep/ .el-table__body tr.hover-row > td {
    background: var(--list-brand-soft) !important;
  }

  .list-main /deep/ .el-table .cell {
    line-height: 21px;
  }

  .list-main /deep/ .wendang .el-input--mini .el-input__inner,
  .list-main /deep/ .zhuangtai .el-input--suffix .el-input__inner,
  .list-main /deep/ .zhuangtaiAll .el-input--suffix .el-input__inner {
    height: 38px;
    color: #526373;
    border: 1px solid var(--list-border);
    border-radius: 9px;
    background: #fff;
    font-size: 14px;
    transition: border-color 0.16s ease, box-shadow 0.16s ease;
  }

  .list-main /deep/ .wendang .el-input--mini .el-input__inner {
    width: 100%;
    max-width: none;
  }

  .list-main /deep/ .el-input__inner:focus {
    border-color: var(--list-brand);
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.11);
  }

  .list-main /deep/ .caozuoinfo .detail,
  .list-main /deep/ .caozuoinfo .read,
  .list-main /deep/ .caozuoinfo .down,
  .list-main /deep/ .caozuoinfo .mail,
  .list-main /deep/ .caozuoinfo .del {
    width: 34px;
    height: 34px;
    margin: 0 3px;
    box-sizing: border-box;
    color: var(--muted-foreground);
    border: 1px solid var(--border);
    border-radius: 50%;
    background: var(--bg-card);
    line-height: 32px;
    transition: color 0.16s ease, border-color 0.16s ease, background 0.16s ease, transform 0.16s ease;
  }

  .list-main /deep/ .caozuoinfo .detail:hover,
  .list-main /deep/ .caozuoinfo .read:hover,
  .list-main /deep/ .caozuoinfo .down:hover,
  .list-main /deep/ .caozuoinfo .mail:hover,
  .list-main /deep/ .caozuoinfo .del:hover {
    color: var(--primary);
    border-color: var(--primary);
    background: var(--primary-alpha-08);
  }

  /deep/ .el-button--primarys,
  .okTranslate {
    border-color: var(--list-brand-strong) !important;
    border-radius: 9px !important;
    background: var(--list-brand-strong) !important;
    box-shadow: 0 5px 14px rgba(0, 0, 0, 0.18);
  }

  /deep/ .el-button--defaults,
  .noTranslate {
    color: var(--list-brand) !important;
    border-color: var(--list-brand) !important;
    border-radius: 9px !important;
    background: #fff !important;
  }
}

@media (min-width: 768.01px) {
  .task-list-page.task-list-page {
    height: 100vh;
    height: 100dvh;
    min-height: 0;
    overflow: hidden;

    .mains {
      height: 100%;
      min-height: 0;
      overflow: hidden;
    }

    .mains > .page {
      height: 64px;
      min-height: 0;
      flex: 0 0 64px;
    }

    .task-list-workspace {
      width: 100%;
      min-width: 0;
      min-height: 0;
      flex: 1 1 auto;
      overflow-x: hidden;
      overflow-y: auto;
      box-sizing: border-box;
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .task-list-page.task-list-page .list-page-primary-action,
  .task-list-page.task-list-page .check-tab-default,
  .task-list-page.task-list-page /deep/ .caozuoinfo > div {
    transition: none !important;
  }
}

@media (max-width: 768px) {
  .task-list-page.task-list-page {
    .mains,
    .mains .page,
    .mains .page .group_1,
    .mains .page .group_1 .box_1 {
      width: 100% !important;
      min-width: 0 !important;
    }

    .list-page-intro {
      width: calc(100% - 24px);
      min-height: 96px;
      margin-top: 12px;
      padding: 16px 18px;
      flex-direction: row;
      align-items: center;
      gap: 14px;
      border-radius: 13px;

      &::after {
        right: -72px;
        bottom: -106px;
      }
    }

    .list-page-intro-copy h1 {
      margin: 3px 0 5px;
      font-size: 22px;
    }

    .list-page-intro-copy p {
      font-size: 13px;
      line-height: 1.7;
    }

    .list-page-primary-action {
      width: auto;
      min-width: 110px;
      min-height: 42px;
      padding: 0 14px;
    }

    .tip-alert-content {
      padding: 0 12px;
    }

    .tip-alert-content .tip-alert {
      margin: 10px auto;
    }

    .tip-alert-content .tip-alert /deep/ .el-alert {
      min-height: 44px;
      padding: 9px 12px;
      text-align: left;
    }

    .list-content {
      padding: 0 12px 24px;
    }

    .list-content .list-main {
      border-radius: 13px;
    }

    .list-content .list-main .list-tab {
      padding: 6px;
      overflow: visible;
    }

    .list-content .list-main .list-tab::-webkit-scrollbar {
      display: none;
    }

    .mains .list-content .list-main .list-tab .list-tab-but {
      width: 100%;
      min-width: 0;
      padding: 4px;
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 4px;
    }

    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default:hover,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active:hover {
      width: auto;
      min-width: 0;
      height: 42px;
      padding: 0 4px;
      font-size: 13px;
    }

    .tab-label-desktop {
      display: none;
    }

    .tab-label-mobile {
      display: inline;
    }

    .list-content .list-main .list-context {
      padding: 0 10px 13px;
    }

    .list-table-scroll-hint {
      display: none;
    }

    .mobile-document-feedback {
      width: calc(100% - 24px);
      max-width: 1216px;
      margin: 0 auto 10px;
      display: block;
    }

    .mobile-document-feedback /deep/ .el-alert {
      margin-top: 8px;
      border-radius: 10px;
    }

    .mobile-document-filters {
      padding: 10px 0 2px;
      display: grid;
      grid-template-columns: minmax(0, 1fr) 118px;
      gap: 8px;
    }

    .mobile-document-filters /deep/ .el-select {
      width: 100%;
    }

    .mobile-document-filters /deep/ .el-input__inner {
      height: 40px;
      padding-left: 34px;
      color: #334155;
      border-color: var(--list-border);
      border-radius: 9px;
      background: #fff;
      line-height: 40px;
    }

    .mobile-document-filters /deep/ .el-input__icon {
      line-height: 40px;
    }

    .mobile-document-list {
      min-height: 150px;
      padding: 8px 0 4px;
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      gap: 10px;
    }

    .mobile-document-card {
      min-width: 0;
      padding: 14px;
      box-sizing: border-box;
      overflow: hidden;
      border: 1px solid var(--list-border);
      border-left: 3px solid var(--list-brand);
      border-radius: 12px;
      background: #fff;
      box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
    }

    .mobile-document-card-header {
      display: grid;
      grid-template-columns: 28px minmax(0, 1fr) auto;
      align-items: start;
      gap: 9px;
    }

    .mobile-document-index {
      width: 28px;
      height: 28px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: var(--list-brand-strong);
      border-radius: 9px;
      background: var(--list-brand-soft);
      font-size: 12px;
      font-weight: 700;
    }

    .mobile-document-heading {
      min-width: 0;
    }

    .mobile-document-heading h2 {
      min-width: 0;
      margin: 0;
      overflow: hidden;
      color: var(--list-text);
      font-size: 15px;
      font-weight: 600;
      line-height: 22px;
      overflow-wrap: anywhere;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    .mobile-document-heading > span {
      margin-top: 3px;
      display: block;
      color: var(--list-text-secondary);
      font-size: 11px;
      line-height: 17px;
    }

    .mobile-document-status {
      min-height: 24px;
      padding: 3px 8px;
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #64748b;
      border-radius: 999px;
      background: #f1f5f9;
      font-size: 11px;
      font-weight: 600;
      line-height: 18px;
      white-space: nowrap;
    }

    .mobile-document-status.is-success {
      color: #087a5a;
      background: #e8f8f2;
    }

    .mobile-document-status.is-progress {
      color: var(--list-brand-strong);
      background: var(--list-brand-soft);
    }

    .mobile-document-status.is-warning {
      color: #9a5b00;
      background: #fff5df;
    }

    .mobile-document-status.is-error {
      color: #b42318;
      background: #fff0ef;
    }

    .mobile-document-meta {
      margin-top: 12px;
      padding: 10px 0;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 14px;
      border-top: 1px solid #ebeef5;
      border-bottom: 1px solid #ebeef5;
    }

    .mobile-document-meta > div {
      min-width: 0;
    }

    .mobile-document-meta span,
    .mobile-document-meta strong {
      min-width: 0;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .mobile-document-meta span {
      color: #8a98a7;
      font-size: 11px;
      line-height: 17px;
    }

    .mobile-document-meta strong {
      margin-top: 2px;
      color: #475569;
      font-size: 12px;
      font-weight: 500;
      line-height: 18px;
    }

    .mobile-document-progress {
      margin-top: 11px;
    }

    .mobile-document-progress > div {
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: var(--list-text-secondary);
      font-size: 12px;
    }

    .mobile-document-progress strong {
      color: var(--list-brand-strong);
    }

    .mobile-document-progress /deep/ .el-progress-bar__outer {
      background: #e8f0f5;
    }

    .mobile-document-progress /deep/ .el-progress-bar__inner {
      background: linear-gradient(90deg, var(--list-brand), var(--list-brand-light));
    }

    .mobile-document-actions {
      margin-top: 12px;
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px;
    }

    .mobile-document-actions button,
    .mobile-document-delete-confirm button {
      min-width: 0;
      min-height: 44px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      color: var(--list-brand-strong);
      border: 1px solid #bfd6e5;
      border-radius: 9px;
      background: #fff;
      font: inherit;
      font-size: 13px;
      font-weight: 600;
      cursor: pointer;
    }

    .mobile-document-actions button:focus-visible,
    .mobile-document-delete-confirm button:focus-visible {
      outline: 3px solid rgba(0, 0, 0, 0.2);
      outline-offset: 2px;
    }

    .mobile-document-actions button.is-primary {
      color: #fff;
      border-color: var(--list-brand-strong);
      background: var(--list-brand-strong);
    }

    .mobile-document-actions button.is-danger {
      color: #b42318;
      border-color: #f0c5c1;
      background: #fff7f6;
    }

    .mobile-document-delete-confirm {
      margin-top: 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      color: #7a2e27;
      border: 1px solid #f1cec9;
      border-radius: 9px;
      background: #fff7f6;
      font-size: 12px;
    }

    .mobile-document-delete-confirm > div {
      display: flex;
      gap: 6px;
    }

    .mobile-document-delete-confirm button {
      min-height: 34px;
      padding: 0 9px;
      font-size: 12px;
    }

    .mobile-document-delete-confirm button:last-child {
      color: #fff;
      border-color: #b42318;
      background: #b42318;
    }

    .mobile-document-empty {
      min-height: 190px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #94a3b8;
      border: 1px dashed #cbdbe5;
      border-radius: 12px;
      background: #f8fbfd;
      text-align: center;
    }

    .mobile-document-empty i {
      margin-bottom: 9px;
      color: #8eb9d2;
      font-size: 30px;
    }

    .mobile-document-empty strong {
      color: #526373;
      font-size: 14px;
    }

    .mobile-document-empty span {
      margin-top: 5px;
      font-size: 12px;
    }

    .filelist-domain /deep/ .el-table {
      display: none !important;
    }

    .list-table-shell {
      min-height: 0 !important;
      display: block;
    }

    .list-table-shell > .el-table + div,
    .list-table-shell > .el-table + div + div {
      width: 100%;
      margin: 14px 0 0 !important;
      display: flex;
      justify-content: center;
      float: none !important;
    }

    .list-table-shell > .el-table + div + div {
      margin-top: 10px !important;
    }

    .list-main /deep/ .el-table th,
    .list-main /deep/ .el-table th.el-table__cell {
      height: 56px !important;
    }

    .list-main /deep/ .el-table .rows,
    .list-main /deep/ .el-table .rows-oushu {
      height: 58px;
    }

    .list-main /deep/ .caozuoinfo .detail,
    .list-main /deep/ .caozuoinfo .read,
    .list-main /deep/ .caozuoinfo .down,
    .list-main /deep/ .caozuoinfo .mail,
    .list-main /deep/ .caozuoinfo .del {
      width: 38px;
      height: 38px;
      line-height: 36px;
    }

    /deep/ .el-pagination {
      display: flex;
      justify-content: center;
      white-space: nowrap;
    }

    .mains /deep/ .floating-contact-tools {
      display: none !important;
    }

    /deep/ .el-dialog,
    /deep/ .payClass .el-dialog {
      width: calc(100vw - 24px) !important;
      min-width: 0 !important;
      max-width: 560px;
      margin: 7vh auto !important;
      border-radius: 14px;
    }

    /deep/ .el-dialog__header {
      padding: 18px 18px 10px !important;
    }

    /deep/ .el-dialog__body {
      max-width: 100%;
      padding: 18px !important;
      box-sizing: border-box;
      overflow-x: auto;
    }

    /deep/ .downloadClass,
    /deep/ .downloadClass2,
    /deep/ .downloadConvertClass {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
}

@media (max-width: 480px) {
  .task-list-page.task-list-page {
    .list-page-intro {
      min-height: 82px;
      padding: 14px 16px;
    }

    .list-page-eyebrow,
    .list-page-intro-copy p {
      display: none;
    }

    .list-page-intro-copy h1 {
      margin: 0;
      font-size: 20px;
    }

    .list-page-primary-action {
      min-width: 104px;
      min-height: 40px;
      font-size: 13px;
    }

    .mobile-document-filters {
      grid-template-columns: minmax(0, 1fr) 108px;
    }

    .mobile-document-card {
      padding: 12px;
    }

    .mobile-document-card-header {
      grid-template-columns: 26px minmax(0, 1fr) auto;
      gap: 7px;
    }

    .mobile-document-delete-confirm {
      flex-direction: column;
      align-items: stretch;
    }

    .mobile-document-delete-confirm > div {
      justify-content: flex-end;
    }

    .mobile-document-index {
      width: 26px;
      height: 26px;
    }

    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default:hover,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active,
    .mains .list-content .list-main .list-tab .list-tab-but .check-tab-default.check-tab-active:hover {
      font-size: 12px;
    }
  }
}
</style>
<style lang="less" scoped>
.fileStatus {
  .el-select-dropdown__item.selected {
    color: var(--primary);
    font-weight: 400;
    font-size: 24px !important;
    font-family: Source Han Sans CN;
    font-weight: 400;
  }

  .el-select-dropdown__item {
    font-weight: 400;
    font-size: 24px !important;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }
}

.main-index {
  min-width: 768px;
  width: 100%;

  .header {
    width: 100%;
    height: 88px;
    background: #e6e6e6;
    display: flex;

    .title_hide {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      background: #e6e6e6;
    }

    .login {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      align-items: center;
      display: flex;
      height: 100%;
      margin-left: 33px;
    }

    .selected {
      position: fixed;
      width: 201px;
      background: #ffffff;
      box-shadow: 0px 5px 10px 0px rgba(116, 114, 114, 0.51);
      z-index: 100;
      top: 90px;
      right: 31px;
      text-align: center;

      div {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        line-height: 72px;
      }
    }

    .select {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex: 1;
      margin-right: 30px;

      .select-option {
        width: 48px;
        height: 11px;
        display: flex;

        div {
          height: 11px;
          width: 11px;
          background: #333333;
          margin-left: 5px;
          border-radius: 50%;
        }
      }
    }
  }

  .list-main {
    min-width: 765px;
    width: 100%;
    background: #f5f5f5;
    display: flex;
    flex-flow: column;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    .trans-header {
      width: 100%;
      height: 80px;
      background: #ffffff;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      justify-content: center;

      .trans-header-select {
        width: 765px;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        .check-tab-default {
          flex: 1;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 72px;
          height: 74px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .check-tab-active {
          border-bottom: 4px solid var(--primary);
        }
      }
    }

    .trans-list-context {
      width: 100%;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      justify-content: center;

      .list-context {
        width: 768px;
        display: flex;
        align-items: center;
        justify-content: center;

        .list-context-search {
          display: flex;
          margin-top: 5px;
          margin-bottom: 20px;

          /deep/ .list-context-search-input {
            margin-right: 22px;

            .el-input {
              width: 420px;
              height: 60px;
              background: #ffffff;
              border-radius: 3px;

              .el-input__icon {
                height: 100%;
                width: 25px;
                text-align: center;
                transition: all 0.3s;
                line-height: 40px;
                font-size: 24px;
              }

              .el-input__inner {
                width: 420px;
                height: 60px;
                background: #ffffff;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
              }
            }
          }

          /deep/ .list-context-search-select {
            .el-input {
              width: 263px;
              height: 60px;
              background: #ffffff;
              border-radius: 3px;

              .el-select .el-input .el-select__caret {
                color: #c0c4cc;
                transition: transform 0.3s;
                transform: rotateZ(180deg);
                cursor: pointer;
                font-size: 24px;
              }

              .el-input__inner {
                width: 263px;
                height: 60px;
                background: #ffffff;
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: 400;
              }
            }
          }
        }

        .infinite-list {
          height: 965px;
          padding: 0;
          margin: 0;
          list-style: none;

          .infinite-list-item {
            width: 706px;
            height: 120px;
            background: #ffffff;
            margin-bottom: 12px;
            display: flex;
            flex-flow: column;

            .item {
              display: flex;
              align-items: center;
              margin-left: 24px;

              .item-status {
                width: 90px;
                height: 30px;
                background: #4dbe92;
                border-radius: 5px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                line-height: 0px;
                margin-right: 9px;
                padding: 0px 10px;
              }

              .item-other {
                width: 90px;
                padding: 0px 10px;
                height: 30px;
                background: #999999;
                border-radius: 5px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                line-height: 0px;
                margin-right: 9px;
              }

              .item-trans {
                padding: 0px 10px;
                height: 30px;
                background: var(--primary);
                border-radius: 5px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #ffffff;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                line-height: 0px;
                margin-right: 9px;
              }

              .item-name {
                width: 474px;
                height: 30px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .item-language {
                height: 23px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                line-height: 72px;
                flex: 1.5;
              }

              .item-comment {
                height: 23px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                line-height: 72px;
                flex: 1;
              }

              .item-pageNum {
                height: 23px;
                font-size: 24px;
                font-family: Source Han Sans CN;
                font-weight: 400;
                color: #999999;
                line-height: 72px;
                flex: 0.5;
              }
            }
          }
        }
      }
    }
  }

  .main-foot {
    height: 149px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      width: 667px;
      height: 64px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: var(--primary);
      line-height: 36px;
    }
  }
}

/deep/ .zhuangtaiAll {
  .el-input--suffix .el-input__inner {
    width: 100px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
}

/deep/ .zhuangtai {
  padding: 0 !important;

  .el-input--suffix .el-input__inner {
    width: 80px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }
}

/deep/ .wendang {
  .el-input--mini .el-input__inner {
    width: 386px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 3px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
  }

  .el-input__suffix {
    right: 20px;
    transition: all 0.3s;
    pointer-events: none;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.user-img {
  width: 16px;
  float: right;
  padding-left: 5px;
}

/deep/ .payClass {
  .el-dialog {
    min-width: 800px;
  }

  .shanchu {
    text-decoration: line-through;
  }

  .el-dialog__footer {
    padding: 10px 30px 20px !important;
  }

  .el-dialog__body {
    padding: 30px 30px !important;
  }

  .el-dialog__header {
    padding: 20px 30px 10px !important;
  }
}

.noTranslate {
  border-color: var(--primary);
  color: var(--primary);
  width: 142px;
  height: 40px;
  border-radius: 2px;
  font-size: 14px;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}

.dialog-title {
  text-align: left;
  width: 100%;
  margin-bottom: 30px;

  .el-form--inline .el-form-item,
  .el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: baseline;
    margin: 0;
    padding: 0;
  }
}

/deep/ .rows {
  height: 68px;
  background: #ffffff;
  font-size: 14px !important;
  font-family: Source Han Sans CN;
  font-weight: 400;
  border-radius: 3px;
  color: #333333;
}

/deep/ .rows-oushu {
  height: 68px;
  background: #fcfcfc;
  font-size: 14px !important;
  font-family: Source Han Sans CN;
  font-weight: 400;
  border-radius: 3px;
  color: #333333;
}

/deep/ .el-radio {
  .el-radio__input {
  }

  &.is-checked {
    position: relative;

    &:after {
      content: "";
      display: block;
      height: 16px;
      width: 16px;
      background-image: url(../assets/duigou.png);
      background-size: 100%;
      position: absolute;
      top: 0px !important;
    }
  }
}

/deep/ .downloadConvertClass {
  height: 200px;
  border-radius: 6px;
}

/deep/ .downloadClass {
  height: 430px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
}

/deep/ .downloadClass2 {
  width: 550px;
  height: 317px;
  border-radius: 6px;
}

/deep/ .down-type {
  float: left;
  margin: 0 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/deep/ .down-type2 {
  float: left;
  margin: 0 75px;
}

/deep/ .el-radio__label {
  display: none !important;
}

/deep/ .el-button--primarys {
  width: 103px !important;
  height: 40px !important;
  background: var(--primary) !important;
  border-radius: 3px !important;
  color: #ffffff !important;
  border-color: var(--primary) !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

/deep/ .el-button--defaults {
  width: 103px !important;
  height: 38px !important;
  background: #ffffff !important;
  color: var(--primary) !important;
  border: 1px solid var(--primary) !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  font-family: Microsoft YaHei;
  font-weight: 400 !important;
  line-height: 0 !important;
}

.downloadConvertClass {
  /deep/ .el-radio {
    position: absolute !important;
  }
}

.downloadClass {
  /deep/ .el-radio {
    position: absolute !important;
    display: flex;
    width: 85px;
    justify-content: flex-end;
  }
}

/deep/ .el-dialog__title {
  width: 278px;
  height: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}

/deep/ .listprogress {
  .el-progress__text {
    font-size: 12px !important;
  }
}

.mains {
  min-width: 1250px;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background: url(../assets/v2/img/list/box-back.png) 0px 0px no-repeat;
  background-size: 1920px 1050px;
  background-position-x: center;

  .header {
    display: flex;
    width: 1200px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 80px;

    .header-left {
      display: flex;
      width: 135px;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-items: center;
    }

    .header-right {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;

      .title_hide {
      }

      div:nth-child(3) {
        height: 30px;
        width: 68px;
        background-color: var(--primary);
        border-radius: 3px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        margin-right: 10px;
        cursor: pointer;
      }

      div:nth-child(4) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 10px;
        margin-left: 10px;
        cursor: pointer;
      }

      div:nth-child(5) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #dddddd;
        cursor: pointer;
      }

      div:nth-child(7) {
        height: 10px;
        width: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
      }

      div:nth-child(6) {
        height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        cursor: pointer;
        margin-right: 10px;

        .el-button--text {
          color: #333333;
        }
      }

      div:nth-child(3):hover {
        background-color: var(--primary);
      }
    }
  }

  .line-hr {
    display: flex;
    width: 100%;
    height: 1px;
    background: #dddddd;
    border: 0;
  }

  .nav {
    display: flex;
    width: 100%;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    height: 58px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    cursor: pointer;
    //background: #ffffff;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;

    .nav-border {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      height: 56px;
      background: #e6e6e6;

      div {
        display: flex;
        width: 1200px;
        justify-content: flex-start;
        align-items: center;

        label {
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-items: center;
          width: 10%;
          cursor: pointer;

          .index {
            display: flex;
            width: 64px;
            height: 58px;
            border-bottom: 2px solid var(--primary);
            color: var(--primary);
            justify-content: center;
            align-items: center;
            padding: 0;
          }

          div:nth-child(1):hover {
            width: 38px;
            height: 58px;
            border-bottom: 2px solid var(--primary);
            color: var(--primary);
            justify-content: center;
            align-items: center;
          }
        }

        label:nth-child(1) {
          width: 7%;
        }

        label div:nth-child(1):hover {
          width: 64px;
          height: 58px;
          border-bottom: 2px solid var(--primary);
          color: var(--primary);
        }
      }
    }
  }

  .tip-alert-content {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;

    /deep/ .tip-alert {
      display: flex;
      width: 1200px;
      align-items: center;
      justify-content: center;
      margin-top: 15px;
      margin-bottom: 5px;

      .el-alert.is-center {
        background: #faf0e7 !important;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #d49964;
        height: 37px;
      }
    }
  }

  .list-content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    .list-main {
      width: 1200px;
      height: 55px;
      background: #ffffff;
      border: 1px solid #dddddd;

      .list-tab {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;

        .list-tab-but {
          flex-direction: row;
          display: flex;
          width: 100%;
          justify-content: flex-start;
          justify-content: center;
          align-items: center;

          .check-tab-default {
            flex: 1;
            cursor: pointer;
            background: white;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 55px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          .check-tab-active {
            flex: 1;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            height: 55px;
            background: var(--primary);
            color: #ffffff !important;
          }

          .check-tab-default:hover {
            flex: 1;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            height: 55px;
            background: var(--primary);
            color: #ffffff !important;
          }
        }

        /deep/ .list-form {
          width: 1000px;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #333333;
          }

          .el-form-item {
            margin-bottom: 0px;

            input {
              width: 180px;
              height: 40px;
              background: #ffffff;
              border-radius: 3px;
              border: 0;
            }
          }
        }
      }

      .list-context {
        margin-top: 5px;

        /deep/ .filelist-domain {
          .el-table--border td,
          .el-table--border th,
          .el-table__body-wrapper
            .el-table--border.is-scrolling-left
            ~ .el-table__fixed {
            border-right: 1px solid #eeeeee;
          }

          .el-table td,
          .el-table th.is-leaf {
            border-bottom: 1px solid #eeeeee;
          }

          .el-table--border,
          .el-table--group {
            border: 1px solid #eeeeee;
          }
        }
      }
    }
  }

  .foot {
    display: flex;
    width: 100%;
    height: 133px;
    background: var(--primary);
    align-items: center;
    justify-content: center;
    border-top: 1px solid var(--primary);
    margin-top: 860px;
    flex-flow: column;

    span {
      line-height: 28px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #e9eeff;
    }

    a {
      color: #e9eeff;
    }
  }
}

.left-yijian-wx {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 55px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian-qq {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 105px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #eaeaea;
}

.left-yijian {
  cursor: pointer;
  text-align: center;
  width: 60px;
  height: 60px;
  background: #ffffff;
  border-radius: 6px;
  left: auto;
  color: #ffffff;
  font-size: 12px;
  position: fixed;
  bottom: 166px;
  right: 0;
  font-family: "Microsoft YaHei";
  z-index: 19;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
